import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["icon", "children", "error", "success"],
    _excluded2 = ["isTravelAgent", "renderLink", "onLogout"];
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import '@total-typescript/ts-reset';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Container, Link, toThemeVars, defaultTheme, extendPalette, extendTheme, Dialog as Dialog$1, DialogPortal, DialogContent, cn as cn$1, Button, Loading, InputGroup, InputLeftContent, Input, Header, HeaderLogo, Sheet, HeaderButton, SheetTrigger, HeaderAvatar, SheetContent, SheetClose, HeaderContent, HeaderCombobox, HeaderSignInButton, HeaderCreateAccountButton, Popover, PopoverTrigger, HeaderUserAvatar, PopoverContent, PopoverClose, mediaQueries, Tabs, TabsList, TabsTrigger, TabsContent } from '@mozioinc/ui';
import { useTranslation as useTranslation$1, initReactI18next } from 'react-i18next';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { createCurrencyQuery, createConfirmationQuery, whiteLabelServices, USER_TYPE } from '@mozioinc/query';
import { QueryClient, useQuery, useMutation } from '@tanstack/react-query';
import i18n from 'i18next';
import { toHsla, mix } from 'color2k';
import merge from 'lodash.merge';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

var _path$k;

function _extends$o() {
  _extends$o = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$o.apply(this, arguments);
}

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 5 10",
    fill: "none"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "m4.672 5.26.26-1.693H3.31V2.47c0-.463.227-.915.953-.915H5V.115S4.331 0 3.692 0C2.357 0 1.484.81 1.484 2.277v1.29H0V5.26h1.484v4.09a5.9 5.9 0 0 0 1.827 0V5.26h1.361Z",
    fill: "currentColor"
  })));
};

var _path$j, _path2$b, _path3$8;

function _extends$n() {
  _extends$n = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$n.apply(this, arguments);
}

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M5.003.848c1.337 0 1.495.006 2.02.028.49.02.753.098.929.162.232.085.4.188.574.351.176.166.284.323.374.542.068.165.15.415.172.874.023.497.029.646.029 1.903 0 1.258-.006 1.408-.03 1.903-.02.46-.103.708-.171.874-.09.219-.2.377-.374.54a1.551 1.551 0 0 1-.574.352c-.176.065-.442.142-.928.162-.528.022-.686.028-2.021.028-1.337 0-1.495-.006-2.02-.028-.49-.02-.753-.097-.93-.162a1.56 1.56 0 0 1-.574-.351 1.444 1.444 0 0 1-.373-.541c-.068-.166-.15-.416-.172-.874-.023-.497-.03-.646-.03-1.903 0-1.26.007-1.408.03-1.903.022-.46.104-.709.172-.874.09-.22.2-.378.373-.542.176-.165.342-.266.575-.351.176-.064.442-.142.928-.162.526-.022.684-.028 2.02-.028Zm0-.848C3.645 0 3.475.006 2.94.028 2.41.05 2.044.13 1.728.247c-.33.121-.61.281-.888.544a2.3 2.3 0 0 0-.578.834c-.123.3-.21.642-.233 1.143C.006 3.272 0 3.432 0 4.71c0 1.28.006 1.44.03 1.942.023.5.109.845.232 1.143.129.31.299.574.578.835.278.262.557.424.886.543.318.116.682.197 1.213.22.534.021.704.027 2.062.027 1.358 0 1.528-.006 2.062-.028.531-.022.897-.103 1.213-.219.329-.12.608-.281.886-.543.277-.261.45-.524.576-.833.123-.3.21-.643.233-1.143.023-.503.029-.663.029-1.942s-.006-1.439-.03-1.941c-.023-.501-.109-.845-.232-1.143A2.196 2.196 0 0 0 9.166.79 2.466 2.466 0 0 0 8.28.248C7.962.133 7.598.052 7.067.03 6.53.006 6.36 0 5.003 0Z",
    fill: "currentColor"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.883c-1.656 0-3 1.266-3 2.826s1.344 2.826 3 2.826S8 6.27 8 4.71 6.656 1.883 5 1.883Zm0 4.66c-1.075 0-1.946-.822-1.946-1.834S3.925 2.876 5 2.876s1.946.82 1.946 1.833c0 1.012-.871 1.833-1.946 1.833Z",
    fill: "currentColor"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.354c0 .26-.225.47-.5.47-.277 0-.5-.21-.5-.47 0-.261.225-.471.5-.471s.5.212.5.47Z",
    fill: "currentColor"
  })));
};

var _path$i;

function _extends$m() {
  _extends$m = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$m.apply(this, arguments);
}

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M9.262 0H.738a.762.762 0 0 0-.522.204A.676.676 0 0 0 0 .695v8.03c0 .185.078.362.216.492.139.13.326.204.522.204h8.524a.762.762 0 0 0 .522-.204.676.676 0 0 0 .216-.492V.695a.676.676 0 0 0-.216-.491A.762.762 0 0 0 9.262 0ZM2.98 8.025H1.477V3.526h1.504v4.5Zm-.753-5.122a.901.901 0 0 1-.479-.14.825.825 0 0 1-.315-.366.77.77 0 0 1-.047-.47.8.8 0 0 1 .237-.414.881.881 0 0 1 .442-.221.913.913 0 0 1 .499.047.854.854 0 0 1 .386.3.78.78 0 0 1 .082.765.8.8 0 0 1-.188.266.857.857 0 0 1-.284.176.897.897 0 0 1-.333.057Zm6.294 5.126H7.02V5.571c0-.725-.327-.948-.749-.948-.446 0-.883.316-.883.967v2.44H3.883v-4.5H5.33v.623h.02c.145-.277.653-.75 1.429-.75.839 0 1.745.47 1.745 1.843V8.03Z",
    fill: "currentColor"
  })));
};

var Footer = function Footer() {
  var _useTranslation$ = useTranslation$1("transfer-widgets:footer"),
      t = _useTranslation$.t;

  var socials = [{
    href: "https://www.linkedin.com/company/mozio/",
    icon: /* @__PURE__ */jsx(SvgLinkedin, {})
  }, {
    href: "https://www.facebook.com/letsmozio/",
    icon: /* @__PURE__ */jsx(SvgFacebook, {})
  }, {
    href: "https://www.instagram.com/letsmozio/",
    icon: /* @__PURE__ */jsx(SvgInstagram, {})
  }];
  var navLinks = [{
    href: "/esim",
    content: t("eSIM")
  }, {
    href: "/parking",
    content: t("Parking")
  }, {
    href: "/coverage",
    content: t("Coverage")
  }, {
    href: "/travel-guides",
    content: t("Guides")
  }, {
    href: "/blog",
    content: t("Blog")
  }, {
    href: "/contact",
    content: t("Contact")
  }, {
    href: "/careers",
    content: t("Careers")
  }];
  var legalLinks = [{
    href: "https://www.mozio.com/en-us/privacy-policy",
    content: t("Privacy policy")
  }, {
    href: "https://www.mozio.com/en-us/terms-of-service",
    content: t("Terms of service")
  }, {
    href: "https://www.mozio.com/en-us/imprint",
    content: t("Imprint")
  }];

  var renderLogoAndSocials = function renderLogoAndSocials() {
    return /* @__PURE__ */jsxs("div", {
      className: "flex items-center justify-center gap-2 md:justify-start",
      children: [/* @__PURE__ */jsx("img", {
        className: "h-6",
        src: "https://static.mozio.com/assets/logo.svg",
        alt: "Mozio"
      }), socials.map(function (social) {
        return /* @__PURE__ */jsx("a", {
          className: "grid h-5 w-5 place-items-center rounded-full bg-neutral-800 text-xs text-white duration-200 hover:bg-neutral-900",
          href: social.href,
          target: "_blank",
          rel: "noreferrer",
          children: social.icon
        }, social.href);
      })]
    });
  };

  var renderNavLinks = function renderNavLinks() {
    return /* @__PURE__ */jsx("div", {
      className: "flex flex-wrap justify-center gap-x-7 gap-y-4 md:justify-end",
      children: navLinks.map(function (link) {
        return /* @__PURE__ */jsx(Link, {
          color: "primary",
          href: link.href,
          children: link.content
        }, link.href);
      })
    });
  };

  var renderLegalLinks = function renderLegalLinks() {
    return /* @__PURE__ */jsx("div", {
      className: "flex justify-center gap-x-4 text-xs",
      children: legalLinks.map(function (_ref) {
        var content = _ref.content,
            href = _ref.href;
        return /* @__PURE__ */jsx(Link, {
          color: "neutral",
          href: href,
          target: "_blank",
          children: content
        }, href);
      })
    });
  };

  var renderCopyRight = function renderCopyRight() {
    return /* @__PURE__ */jsxs("div", {
      className: "text-xs text-neutral-800",
      children: [/* @__PURE__ */new Date().getFullYear(), " ", t("Mozio Inc. Trademarks and brands are property of their respective owners.")]
    });
  };

  return /* @__PURE__ */jsxs("footer", {
    className: "border-primary mt-auto border-b-8 pb-5 pt-14 text-sm text-gray-500",
    children: [/* @__PURE__ */jsxs(Container, {
      className: "grid gap-4 text-center md:hidden",
      children: [renderLogoAndSocials(), renderNavLinks(), renderLegalLinks(), renderCopyRight()]
    }), /* @__PURE__ */jsxs(Container, {
      className: "hidden max-w-6xl gap-4 md:grid",
      children: [/* @__PURE__ */jsxs("div", {
        className: "grid grid-cols-[auto_1fr] gap-8",
        children: [/* @__PURE__ */jsx("div", {
          className: "grid gap-4",
          children: renderLogoAndSocials()
        }), renderNavLinks()]
      }), /* @__PURE__ */jsxs("div", {
        className: "flex items-end justify-between",
        children: [renderCopyRight(), renderLegalLinks()]
      })]
    })]
  });
};

var useTranslation = useTranslation$1;
var envMemo;

var getEnvs = function getEnvs() {
  if (envMemo) return envMemo;
  envMemo = {
    QUERY_ENV: process.env.CONFIG_ENV === "production" ? "production" : "staging"
  };
  return envMemo;
};

var Blog$g = "Blog";
var Careers$g = "Karrieren";
var Contact$g = "Kontakt";
var Coverage$g = "Abdeckung";
var Guides$g = "Reiseführer";
var Imprint$g = "Impressum";
var Parking$g = "Parken";
var eSIM$g = "eSIM";
var FooterDe = {
  Blog: Blog$g,
  Careers: Careers$g,
  Contact: Contact$g,
  Coverage: Coverage$g,
  Guides: Guides$g,
  Imprint: Imprint$g,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Marken und Markenzeichen sind Eigentum ihrer jeweiligen Inhaber.",
  Parking: Parking$g,
  "Privacy policy": "Datenschutzrichtlinie",
  "Terms of service": "Nutzungsbedingungen",
  eSIM: eSIM$g
};
var About$g = "Über";
var Close$g = "Schließen";
var Help$g = "Hilfe";
var More$g = "Mehr";
var OK$g = "Ok";
var Providers$x = "Anbieter";
var Send$g = "Senden";
var Thanks$g = "Danke";
var Travelers$x = "Reisende";
var HeaderDe = {
  About: About$g,
  "An error occurred while sending the email.": "Beim Senden Ihrer E-Mail ist ein Fehler aufgetreten.",
  "Business Partners": "Geschäftspartner",
  Close: Close$g,
  "Create Account": "Erstellen Sie Konto ",
  "Email address": "E-Mail-Adresse",
  "Hello, {{name}}!": "Hallo, {{name}} !",
  Help: Help$g,
  "If any reservations are found we'll send them to you.": "Vielen Dank! Wenn wir Reservierungen von Ihnen haben, werden wir sie Ihnen zusenden.",
  "Log out": "Ausloggen",
  More: More$g,
  "My account": "Mein Konto",
  "My bookings": "Meine Buchungen",
  OK: OK$g,
  Providers: Providers$x,
  "Resend Booking": "Buchung erneut senden",
  "Resend Confirmation Email": "Bestätigungs-Mail erneut senden",
  Send: Send$g,
  "Sign In": "Melden Sie Sich an ",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Geben Sie uns Ihre E-Mail-Adresse, und wir senden Ihnen Kopien von all Ihren bevorstehenden Buchungen",
  Thanks: Thanks$g,
  "Travel Agent": "Reiseveranstalter",
  "Travel Agents": "Reisebüros",
  Travelers: Travelers$x
};
var Businesses$h = "Unternehmen";
var Expertise$g = "Fachwissen";
var Provider$g = "Anbieter";
var Providers$w = "Anbieter";
var Transparency$g = "Transparenz";
var Travelers$w = "Reisende";
var Widget$g = "Widget";
var airports$g = "Flughäfen";
var cities$g = "Städte";
var countries$g = "Länder";
var currencies$g = "Währungen";
var eSIMs$g = "eSIMs";
var languages$g = "Sprachen";
var providers$g = "Anbieter";
var HomeDe = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 Länder, 3500+ Flughäfen, 3000+ Anbieter, 17 Sprachen, 39 Währungen.",
  "24/7 customer support": "24/7 Kundensupport",
  "771 reviews": "",
  "API Integration": "API-Integration",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Fügen Sie Such-Widgets auf Ihrer Website hinzu, damit Besucher direkt auf Ihrer Seite nach Transportmöglichkeiten suchen können und für die Buchung auf Mozio.com weitergeleitet werden.",
  "Airport Parking": "Flughafenparkplätze",
  "All transfers in one place": "Alle Transfers an einem Ort",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Sind Sie ein Reisebüro, Hotel, eine Fluggesellschaft oder eine Autovermietung und möchten Ihre Reichweite erweitern?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Sind Sie ein Reisebüro, Hotel, eine Fluggesellschaft oder eine Autovermietung und möchten Ihre Reichweite erweitern?",
  "Are you a Travel Agent?": "Sind Sie ein Reisebüro?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Sind Sie ein Reisebüro? Buchen Sie nahtlos Bodentransporte im Namen Ihrer Kunden mit unserem Reisebüro-Buchungstool.",
  "Are you a ground transportation Provider?": "Sind Sie ein Anbieter für Bodenverkehr?",
  "Are you planning a trip and need reliable transportation options?": "Planen Sie eine Reise und benötigen zuverlässige Transportmöglichkeiten?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Buchen Sie Limousinen, SUVs, Vans, private und geteilte Busse, Limousinen, Züge und sogar Wassertaxis.",
  "Book with Mozio": "Buchen Sie mit Mozio",
  "Booking tool for Travel Agents": "Buchungstool für Reisebüros",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Marken wie Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor und über 5.000 Reisebüros vertrauen Mozio für ihre Bodentransportbedürfnisse.",
  Businesses: Businesses$h,
  "Discover our solutions": "Entdecken Sie unsere Lösungen",
  "Do you manage travel arrangements for clients?": "Verwalten Sie Reisebuchungen für Kunden?",
  "Do you offer ground transportation services and want to expand your reach?": "Bieten Sie Bodentransportdienste an und möchten Ihre Reichweite erweitern?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Verbessern Sie das Kundenerlebnis, indem Sie bequeme Buchungsoptionen für Bodenverkehr in Ihre bestehenden Systeme integrieren.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Verbessern Sie Ihre Marke mit Mozios White-Label-Lösung, die einen vollständig angepassten Buchungsablauf für Transport integriert, der Ihre Marke von Farben und Logos bis hin zu URLs umfasst, und bietet Ihren Kunden ein nahtloses Erlebnis unter Ihrem Namen.",
  Expertise: Expertise$g,
  "Extensive network and reach": "Umfassendes Netzwerk und Reichweite",
  "Flight delayed? We wait.": "Flug verspätet? Wir warten.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Flug verspätet? Wir warten. Brauchen Sie Hilfe mit Ihrer Buchung? Erhalten Sie sofortige Unterstützung durch unseren 24/7-Support.",
  "Free cancellations within 24 hours": "Kostenlose Stornierungen innerhalb von 24 Stunden",
  "Free online cancellations": "Kostenlose Online-Stornierungen",
  "Global coverage": "Weltweite Abdeckung",
  "Innovative technology": "Innovative Technologie",
  "Instantly guaranteed booking": "Sofort garantierte Buchung",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integrieren Sie Mozios leistungsstarke API in Ihre bestehenden Systeme und ermöglichen Sie es Ihren Kunden, Transfers nahtlos zu buchen.",
  "Integrate with Mozio": "Integrieren Sie sich mit Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Treten Sie dem globalen Netzwerk von Mozio bei und verbinden Sie sich mit Millionen von Reisenden.",
  "Learn more": "Mehr erfahren",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Nutzen Sie unser Branchenwissen mit über 12 Jahren Spezialisierung im Bereich Bodenverkehr.",
  "Licensed partners": "Lizenzierte Partner",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Ändern Sie Buchungen ganz einfach mit kostenlosen Online-Stornierungen bei 99% der Buchungen.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Bieten Sie Ihren Kunden stressfreie Flughafenparkplätze, um einen reibungslosen Start und Abschluss ihrer Reise zu gewährleisten.",
  "Partner with Us": "Arbeiten Sie mit uns zusammen",
  "Partner with us": "Werden Sie unser Partner",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Bieten Sie Ihren Kunden nahtlosen Internetzugang weltweit mit eSIMs.",
  Provider: Provider$g,
  Providers: Providers$w,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Jetzt buchen",
  "The largest Travel Businesses in the world trust Mozio": "Die größten Reiseunternehmen der Welt vertrauen auf Mozio",
  Transparency: Transparency$g,
  "Travel Agency": "",
  "Travel Agent": "Reisebüros",
  "Travel Agent Booking Tool": "Reisebüro-Buchungstool",
  "Travel Agents": "Reisebüros",
  Travelers: Travelers$w,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Nutzen Sie unsere Plattform als One-Stop-Shop für alle Ihre Buchungen von Bodenverkehr, von Flughafentransfers bis zu lokalen Taxis, weltweit.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Nutzen Sie unsere hochmoderne Technologie mit fortschrittlichen Funktionen und anpassbaren Optionen.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Wir arbeiten mit lizenzierten Anbietern für Bodenverkehr zusammen, um Zuverlässigkeit bei jeder Buchung zu gewährleisten.",
  "What we offer": "Was wir bieten",
  "White Label": "White Label",
  "Why choose Mozio": "Warum Mozio wählen",
  Widget: Widget$g,
  "World class customer service": "Kundenservice der Spitzenklasse",
  "Your go-to ground transportation platform": "Ihre Go-To-Plattform für Bodentransport",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Ihre Go-To-Plattform für Bodentransport für Reisende, Reisebüros, Hotels, Fluggesellschaften und mehr.",
  airports: airports$g,
  cities: cities$g,
  countries: countries$g,
  currencies: currencies$g,
  eSIMs: eSIMs$g,
  "in New York City": "",
  languages: languages$g,
  providers: providers$g
};
var Blog$f = "Blog";
var Careers$f = "Careers";
var Contact$f = "Contact";
var Coverage$f = "Coverage";
var Guides$f = "Guides";
var Imprint$f = "Imprint";
var Parking$f = "Parking";
var eSIM$f = "eSIM";
var FooterEn = {
  Blog: Blog$f,
  Careers: Careers$f,
  Contact: Contact$f,
  Coverage: Coverage$f,
  Guides: Guides$f,
  Imprint: Imprint$f,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Trademarks and brands are property of their respective owners.",
  Parking: Parking$f,
  "Privacy policy": "Privacy policy",
  "Terms of service": "Terms of service",
  eSIM: eSIM$f
};
var About$f = "About";
var Close$f = "Close";
var Help$f = "Help";
var More$f = "More";
var OK$f = "OK";
var Providers$v = "Providers";
var Send$f = "Send";
var Thanks$f = "Thanks";
var Travelers$v = "Travelers";
var HeaderEn = {
  About: About$f,
  "An error occurred while sending the email.": "An error occurred while sending the email.",
  "Business Partners": "Business Partners",
  Close: Close$f,
  "Create Account": "Create Account",
  "Email address": "Email address",
  "Hello, {{name}}!": "Hello, {{name}}!",
  Help: Help$f,
  "If any reservations are found we'll send them to you.": "If any reservations are found we'll send them to you.",
  "Log out": "Log out",
  More: More$f,
  "My account": "My account",
  "My bookings": "My bookings",
  OK: OK$f,
  Providers: Providers$v,
  "Resend Booking": "Resend Booking",
  "Resend Confirmation Email": "Resend Confirmation Email",
  Send: Send$f,
  "Sign In": "Sign In",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Tell us your email and we'll send you copies of all your upcoming bookings.",
  Thanks: Thanks$f,
  "Travel Agent": "Travel Agent",
  "Travel Agents": "Travel Agents",
  Travelers: Travelers$v
};
var Businesses$g = "Businesses";
var Expertise$f = "Expertise";
var Provider$f = "Provider";
var Providers$u = "Providers";
var Transparency$f = "Transparency";
var Travelers$u = "Travelers";
var Widget$f = "Widget";
var airports$f = "airports";
var cities$f = "cities";
var countries$f = "countries";
var currencies$f = "currencies";
var eSIMs$f = "eSIMs";
var languages$f = "languages";
var providers$f = "providers";
var HomeEn = {
  "#28 of 254 Transportation": "#28 of 254 Transportation",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 countries, 3500+ airports, 3000+ providers, 17 languages, 39 currencies.",
  "24/7 customer support": "24/7 customer support",
  "771 reviews": "771 reviews",
  "API Integration": "API Integration",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.",
  "Airport Parking": "Airport Parking",
  "All transfers in one place": "All transfers in one place",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Are you a Travel Agency, Hotel, Airline, or Car Rental?",
  "Are you a Travel Agent?": "Are you a Travel Agent?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.",
  "Are you a ground transportation Provider?": "Are you a ground transportation Provider?",
  "Are you planning a trip and need reliable transportation options?": "Are you planning a trip and need reliable transportation options?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.",
  "Book with Mozio": "Book with Mozio",
  "Booking tool for Travel Agents": "Booking tool for Travel Agents",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.",
  Businesses: Businesses$g,
  "Discover our solutions": "Discover our solutions",
  "Do you manage travel arrangements for clients?": "Do you manage travel arrangements for clients?",
  "Do you offer ground transportation services and want to expand your reach?": "Do you offer ground transportation services and want to expand your reach?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.",
  Expertise: Expertise$f,
  "Extensive network and reach": "Extensive network and reach",
  "Flight delayed? We wait.": "Flight delayed? We wait.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.",
  "Free cancellations within 24 hours": "Free cancellations within 24 hours",
  "Free online cancellations": "Free online cancellations",
  "Global coverage": "Global coverage",
  "Innovative technology": "Innovative technology",
  "Instantly guaranteed booking": "Instantly guaranteed booking",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.",
  "Integrate with Mozio": "Integrate with Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Join Mozio's global network and connect with millions of Travelers. ",
  "Learn more": "Learn more",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Leverage our industry expertise with over 12 years of specialization in ground transportation.",
  "Licensed partners": "Licensed partners",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Manage changes easily with free online cancellations on 99% of bookings.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ",
  "Partner with Us": "Partner with us",
  "Partner with us": "Partner with us",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Provide your clients with seamless internet access worldwide with eSIMs. ",
  Provider: Provider$f,
  Providers: Providers$u,
  "Rating: 4.75 / 5": "Rating: 4.75 / 5",
  "Start booking now": "Start booking now",
  "The largest Travel Businesses in the world trust Mozio": "The largest Travel Businesses in the world trust Mozio",
  Transparency: Transparency$f,
  "Travel Agency": "Travel Agency",
  "Travel Agent": "Travel Agent",
  "Travel Agent Booking Tool": "Travel Agent Booking Tool",
  "Travel Agents": "Travel Agents",
  Travelers: Travelers$u,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Utilize our cutting-edge technology with advanced features and customizable options.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "We partner with licensed ground transportation Providers, ensuring reliability in every booking.",
  "What we offer": "What we offer",
  "White Label": "White Label",
  "Why choose Mozio": "Why choose Mozio",
  Widget: Widget$f,
  "World class customer service": "World class customer service",
  "Your go-to ground transportation platform": "Your go-to ground transportation platform",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.",
  airports: airports$f,
  cities: cities$f,
  countries: countries$f,
  currencies: currencies$f,
  eSIMs: eSIMs$f,
  "in New York City": "in New York City",
  languages: languages$f,
  providers: providers$f
};
var Blog$e = "Blog";
var Careers$e = "Carreras";
var Contact$e = "Contacto";
var Coverage$e = "Cobertura";
var Guides$e = "Guías";
var Imprint$e = "Imprimir";
var Parking$e = "Parkeo/ Parking";
var eSIM$e = "eSIM";
var FooterEs = {
  Blog: Blog$e,
  Careers: Careers$e,
  Contact: Contact$e,
  Coverage: Coverage$e,
  Guides: Guides$e,
  Imprint: Imprint$e,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Las marcas registradas y marcas comerciales son propiedad de sus respectivos dueños.",
  Parking: Parking$e,
  "Privacy policy": "Políticas de Privacidad",
  "Terms of service": "Términos y Condiciones",
  eSIM: eSIM$e
};
var About$e = "Acerca de";
var Close$e = "Cerrar";
var Help$e = "Ayuda";
var More$e = "Más";
var OK$e = "OK";
var Providers$t = "Proveedores";
var Send$e = "Enviar";
var Thanks$e = "Gracias";
var Travelers$t = "Viajeros";
var HeaderEs = {
  About: About$e,
  "An error occurred while sending the email.": "Se produjo un error al enviar el correo electrónico.",
  "Business Partners": "Socios comerciales",
  Close: Close$e,
  "Create Account": "Crear cuenta",
  "Email address": "Dirección de correo electrónico",
  "Hello, {{name}}!": "¡Hola, {{name}} !",
  Help: Help$e,
  "If any reservations are found we'll send them to you.": "Gracias, si encuentra alguna reserva, se la enviaremos.",
  "Log out": "Cerrar sesión",
  More: More$e,
  "My account": "Mi cuenta",
  "My bookings": "Mis reservas",
  OK: OK$e,
  Providers: Providers$t,
  "Resend Booking": "Reenviar reserva",
  "Resend Confirmation Email": "Reenviar correo electrónico de confirmación",
  Send: Send$e,
  "Sign In": "Iniciar Sesión",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Dinos tu correo electrónico y te enviaremos copias de todas tus próximas reservas.",
  Thanks: Thanks$e,
  "Travel Agent": "Agente de Viaje",
  "Travel Agents": "Agentes de viajes",
  Travelers: Travelers$t
};
var Businesses$f = "Empresas";
var Expertise$e = "Expertise";
var Provider$e = "Proveedores";
var Providers$s = "Proveedores";
var Transparency$e = "Transparencia";
var Travelers$s = "Viajeros";
var Widget$e = "Widget";
var airports$e = "aeropuertos";
var cities$e = "ciudades";
var countries$e = "países";
var currencies$e = "monedas";
var eSIMs$e = "eSIMs";
var languages$e = "idiomas";
var providers$e = "proveedores";
var HomeEs = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 países, más de 3500 aeropuertos, 3000+ proveedores, 17 idiomas, más de 39 monedas.",
  "24/7 customer support": "Soporte 24/7",
  "771 reviews": "",
  "API Integration": "Integración API",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Agrega Widgets de búsqueda en tu sitio web, permitiendo a los visitantes buscar opciones de transporte directamente en tu página y redirigiéndolos a Mozio.com para realizar la reserva.",
  "Airport Parking": "Estacionamiento en el Aeropuerto",
  "All transfers in one place": "Todos los traslados en un solo lugar",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "¿Eres una Agencia de Viajes, Hotel, Aerolínea o Alquiler de Autos y deseas ampliar tu alcance?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "¿Eres una Agencia de Viajes, Hotel, Aerolínea o Alquiler de Autos y deseas ampliar tu alcance?",
  "Are you a Travel Agent?": "¿Eres un Agente de Viajes?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "¿Eres un Agente de Viajes? Reserva transporte terrestre en nombre de tus clientes sin complicaciones con nuestra Herramienta de Reserva para Agentes de Viajes.",
  "Are you a ground transportation Provider?": "¿Eres un Proveedor de transporte terrestre?",
  "Are you planning a trip and need reliable transportation options?": "¿Estás planeando un viaje y necesitas opciones de transporte confiables?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Reserva sedanes, SUV, vans, autobuses privados y compartidos, limusinas, trenes e incluso taxis acuáticos.",
  "Book with Mozio": "Reserva con Mozio",
  "Booking tool for Travel Agents": "Herramienta de Reserva para Agentes de Viajes",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Marcas como Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor,\\ny más de 5000 agentes de viajes confían en Mozio para sus necesidades de transporte terrestre.",
  Businesses: Businesses$f,
  "Discover our solutions": "Descubre nuestras soluciones",
  "Do you manage travel arrangements for clients?": "¿Gestionas arreglos de viaje para tus clientes?",
  "Do you offer ground transportation services and want to expand your reach?": "¿Ofreces servicios de transporte terrestre y quieres ampliar tu alcance?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Mejora la experiencia del cliente integrando opciones convenientes de reserva de transporte terrestre en tus sistemas existentes.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Mejora tu marca con la solución de White Label de Mozio, ofreciendo un flujo de reservas de transporte completamente personalizado que integra tu marca, desde colores y logotipos hasta URLs, brindando a tus clientes una experiencia perfecta bajo tu nombre.",
  Expertise: Expertise$e,
  "Extensive network and reach": "Red y alcance extensos- I have doubts about this one",
  "Flight delayed? We wait.": "¿Vuelo retrasado? Nosotros esperamos.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "¿Vuelo retrasado? Nosotros esperamos. ¿Necesitas ayuda con tu reserva? Recibe asistencia inmediata con nuestro soporte 24/7.",
  "Free cancellations within 24 hours": "Cancelaciones gratuitas dentro de las 24 horas.",
  "Free online cancellations": "Cancelaciones gratuitas en línea",
  "Global coverage": "Cobertura global",
  "Innovative technology": "Tecnología innovadora",
  "Instantly guaranteed booking": "Reserva garantizada al instante",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integra la potente API de Mozio en tus sistemas existentes y permite a tus clientes reservar traslados sin complicaciones.",
  "Integrate with Mozio": "Integrate con Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Únete a la red global de Mozio y conéctate con millones de viajeros.",
  "Learn more": "Conoce más",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Aprovecha nuestra experiencia en la industria con más de 12 años de especialización en transporte terrestre.",
  "Licensed partners": "Socios licenciados",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Gestiona cambios fácilmente con cancelaciones gratuitas en el 99% de las reservas.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Ofrece a tus clientes opciones de Estacionamiento en el Aeropuerto sin complicaciones, asegurando un inicio y fin de su viaje sin problemas.",
  "Partner with Us": "Hazte socio con nosotros",
  "Partner with us": "Hazte socio con nosotros/ Asóciate",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Proporciona a tus clientes acceso a internet sin interrupciones en todo el mundo con eSIMs.",
  Provider: Provider$e,
  Providers: Providers$s,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Comienza a reservar ahora",
  "The largest Travel Businesses in the world trust Mozio": "Las Empresas de Viajes más grandes del mundo confían en Mozio.",
  Transparency: Transparency$e,
  "Travel Agency": "",
  "Travel Agent": "Agentes de viajes",
  "Travel Agent Booking Tool": "Herramienta de Reserva para Agentes de Viajes",
  "Travel Agents": "Agentes de Viajes",
  Travelers: Travelers$s,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Usa nuestra plataforma como una solución única para todas tus reservas de transporte terrestre, desde traslados al aeropuerto hasta taxis locales, en todo el mundo.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Usa/Aprovecha nuestra tecnología de vanguardia con funciones avanzadas y opciones personalizables.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Nos asociamos con Proveedores de transporte terrestre licenciados, asegurando la confiabilidad en cada reserva.",
  "What we offer": "Lo que ofrecemos",
  "White Label": "White Label",
  "Why choose Mozio": "Por qué elegir Mozio",
  Widget: Widget$e,
  "World class customer service": "Servicio al cliente de clase mundial",
  "Your go-to ground transportation platform": "Tu plataforma de transporte terrestre de confianza.",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Tu plataforma de transporte terrestre de confianza para Viajeros, Agentes de Viajes, Hoteles, Aerolíneas y más.",
  airports: airports$e,
  cities: cities$e,
  countries: countries$e,
  currencies: currencies$e,
  eSIMs: eSIMs$e,
  "in New York City": "",
  languages: languages$e,
  providers: providers$e
};
var Blog$d = "Blog";
var Careers$d = "Carrières";
var Contact$d = "Contact";
var Coverage$d = "Couverture";
var Guides$d = "Guides";
var Imprint$d = "Mentions légales";
var Parking$d = "Parking";
var eSIM$d = "eSIM";
var FooterFr = {
  Blog: Blog$d,
  Careers: Careers$d,
  Contact: Contact$d,
  Coverage: Coverage$d,
  Guides: Guides$d,
  Imprint: Imprint$d,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Les marques et logos sont la propriété de leurs propriétaires respectifs.",
  Parking: Parking$d,
  "Privacy policy": "Politique de confidentialité",
  "Terms of service": "Conditions d'utilisation",
  eSIM: eSIM$d
};
var About$d = "À propos";
var Close$d = "Fermer";
var Help$d = "Aide";
var More$d = "Plus";
var OK$d = "Ok";
var Providers$r = "Prestataires";
var Send$d = "Envoyer";
var Thanks$d = "Merci";
var Travelers$r = "Voyageurs";
var HeaderFr = {
  About: About$d,
  "An error occurred while sending the email.": "Une erreur s'est produite lors de l'envoi de l'e-mail.",
  "Business Partners": "Partenaires commerciaux",
  Close: Close$d,
  "Create Account": "S'inscrire",
  "Email address": "Adresse e-mail",
  "Hello, {{name}}!": "Bonjour, {{name}} !",
  Help: Help$d,
  "If any reservations are found we'll send them to you.": "Merci, si des réservations sont trouvées, nous vous les enverrons.",
  "Log out": "Se déconnecter",
  More: More$d,
  "My account": "Mon compte",
  "My bookings": "Mes réservations",
  OK: OK$d,
  Providers: Providers$r,
  "Resend Booking": "Renvoyer la réservation",
  "Resend Confirmation Email": "Renvoyer l'e-mail de confirmation",
  Send: Send$d,
  "Sign In": "Connexion",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Indiquez-nous votre e-mail et nous vous enverrons des copies de toutes vos réservations à venir.",
  Thanks: Thanks$d,
  "Travel Agent": "Agent de voyage",
  "Travel Agents": "Agents de voyage",
  Travelers: Travelers$r
};
var Businesses$e = "Entreprises";
var Expertise$d = "Expertise";
var Provider$d = "Prestataires";
var Providers$q = "Prestataires";
var Transparency$d = "Transparence";
var Travelers$q = "Voyageurs";
var Widget$d = "Widget";
var airports$d = "aéroports";
var cities$d = "villes";
var countries$d = "pays";
var currencies$d = "devises";
var eSIMs$d = "eSIMs";
var languages$d = "langues";
var providers$d = "prestataires";
var HomeFr = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 pays, 3500+ aéroports, 3000+ fournisseurs, 17 langues, 39 devises.",
  "24/7 customer support": "Support client 24h/24",
  "771 reviews": "",
  "API Integration": "Intégration d'API",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Ajoutez des widgets de recherche à votre site web, permettant aux visiteurs de rechercher des options de transport directement sur votre page et d'être redirigés vers Mozio.com pour la réservation.",
  "Airport Parking": "Parking d'aéroport",
  "All transfers in one place": "Tous les transferts en un seul endroit",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Êtes-vous une agence de voyage, un hôtel, une compagnie aérienne ou une société de location de voitures souhaitant élargir votre offre se services ?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Êtes-vous une agence de voyage, un hôtel, une compagnie aérienne ou une société de location de voitures souhaitant élargir votre offre se services ?",
  "Are you a Travel Agent?": "Êtes-vous un agent de voyage ?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Êtes-vous un agent de voyage ? Réservez des transports terrestres au nom de vos clients en toute simplicité avec notre outil de réservation.",
  "Are you a ground transportation Provider?": "Êtes-vous un prestataire de transport terrestre ?",
  "Are you planning a trip and need reliable transportation options?": "Besoin d'options de transport fiables pour planifier votre voyage?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Réservez des berlines, des SUV, des vans, des bus privés et partagés, des limousines, des trains et même des taxis aquatiques.",
  "Book with Mozio": "Réservez avec Mozio",
  "Booking tool for Travel Agents": "Outil de réservation pour les agents de voyage",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Des sociétés comme Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, et plus de 5000 agences de voyage font confiance à Mozio pour leurs besoins en transport terrestre.",
  Businesses: Businesses$e,
  "Discover our solutions": "Découvrez nos solutions",
  "Do you manage travel arrangements for clients?": "Gérez-vous des réservations de voyage pour des clients ?",
  "Do you offer ground transportation services and want to expand your reach?": "Offrez-vous des services de transport terrestre et souhaitez-vous étendre votre offre ?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Améliorez l'expérience client en intégrant des options de réservation de transport terrestre pratiques dans vos systèmes existants.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Améliorez vos services avec la solution marque blanche de Mozio, offrant un flux de réservation de transport entièrement personnalisé qui intègre votre image de marque — des couleurs et logos aux URLs — pour offrir à vos clients une expérience fluide sous votre propre nom.",
  Expertise: Expertise$d,
  "Extensive network and reach": "Réseau et couverture étendus",
  "Flight delayed? We wait.": "Vol retardé ? Nous vous attendons.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Vol retardé ? Nous attendons. Besoin d'aide pour votre réservation ? Recevez une assistance immédiate avec notre support 24h/24.",
  "Free cancellations within 24 hours": "Annulations gratuites dans les 24 heures",
  "Free online cancellations": "Annulations en ligne gratuites",
  "Global coverage": "Couverture mondiale",
  "Innovative technology": "Technologie innovante",
  "Instantly guaranteed booking": "Réservation garantie instantanément",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Intégrez l'API puissante de Mozio dans vos systèmes existants et permettez à vos clients de réserver des transferts de manière fluide.",
  "Integrate with Mozio": "Intégrez avec Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Rejoignez le réseau mondial de Mozio et connectez-vous avec des millions de voyageurs.",
  "Learn more": "En savoir plus",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Tirez parti de notre expertise sectorielle avec plus de 12 ans de spécialisation dans le transport terrestre.",
  "Licensed partners": "Partenaires agréés",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Gérez les changements facilement avec des annulations en ligne gratuites sur 99 % des réservations.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Offrez à vos clients des options de stationnement d'aéroport sans tracas, garantissant un début et une fin de voyage en douceur.",
  "Partner with Us": "Partenariat avec Mozio",
  "Partner with us": "Partenariat avec Mozio",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Fournissez à vos clients un accès Internet sans couture dans le monde entier avec des eSIMs.",
  Provider: Provider$d,
  Providers: Providers$q,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Commencez à réserver maintenant",
  "The largest Travel Businesses in the world trust Mozio": "Les plus grandes entreprises de voyages dans le monde font confiance à Mozio",
  Transparency: Transparency$d,
  "Travel Agency": "",
  "Travel Agent": "Agents de voyage",
  "Travel Agent Booking Tool": "Outil de réservation pour les agents de voyage",
  "Travel Agents": "Agents de voyage",
  Travelers: Travelers$q,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Utilisez notre plateforme comme guichet unique pour toutes vos réservations de transport terrestre, des transferts aéroportuaires aux taxis locaux, dans le monde entier.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Utilisez notre technologie de pointe avec des fonctionnalités avancées et des options personnalisables.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Nous collaborons avec des fournisseurs de transport terrestre agréés, garantissant la fiabilité de chaque réservation.",
  "What we offer": "Ce que nous offrons",
  "White Label": "Marque blanche",
  "Why choose Mozio": "Pourquoi choisir Mozio",
  Widget: Widget$d,
  "World class customer service": "Service client de classe mondiale",
  "Your go-to ground transportation platform": "Votre plateforme de transport terrestre privilégiée",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Votre plateforme de transport terrestre pour les voyageurs, agents de voyage, hôtels, compagnies aériennes et plus encore.",
  airports: airports$d,
  cities: cities$d,
  countries: countries$d,
  currencies: currencies$d,
  eSIMs: eSIMs$d,
  "in New York City": "",
  languages: languages$d,
  providers: providers$d
};
var Blog$c = "Blog";
var Careers$c = "Karier";
var Contact$c = "Kontak";
var Coverage$c = "Cakupan";
var Guides$c = "Panduan";
var Imprint$c = "Jejak";
var Parking$c = "Parkir";
var eSIM$c = "eSIM";
var FooterId = {
  Blog: Blog$c,
  Careers: Careers$c,
  Contact: Contact$c,
  Coverage: Coverage$c,
  Guides: Guides$c,
  Imprint: Imprint$c,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Merek dagang dan merek adalah milik dari pemiliknya masing-masing.",
  Parking: Parking$c,
  "Privacy policy": "Kebijakan Privasi",
  "Terms of service": "Ketentuan Layanan",
  eSIM: eSIM$c
};
var About$c = "Tentang";
var Close$c = "Tutup";
var Help$c = "Bantuan";
var More$c = "Lagi";
var OK$c = "Oke";
var Providers$p = "Penyedia";
var Send$c = "Kirim";
var Thanks$c = "Terima kasih";
var Travelers$p = "Pelancong";
var HeaderId = {
  About: About$c,
  "An error occurred while sending the email.": "Terjadi kesalahan saat mengirim email.",
  "Business Partners": "Mitra bisnis",
  Close: Close$c,
  "Create Account": "Buat Akun",
  "Email address": "Alamat email",
  "Hello, {{name}}!": "{{name}} !",
  Help: Help$c,
  "If any reservations are found we'll send them to you.": "Terima kasih, apabila pemesanan ditemukan kami akan mengirimnya ke Anda.",
  "Log out": "Keluar",
  More: More$c,
  "My account": "Akun saya",
  "My bookings": "Pemesanan saya",
  OK: OK$c,
  Providers: Providers$p,
  "Resend Booking": "Kirim Ulang Pesanan",
  "Resend Confirmation Email": "Kirim Ulang Email Konfirmasi",
  Send: Send$c,
  "Sign In": "Masuk",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Masukkan email Anda agar kami dapat mengirimkan salinan pesanan Anda.",
  Thanks: Thanks$c,
  "Travel Agent": "Travel Agent",
  "Travel Agents": "Agen perjalanan",
  Travelers: Travelers$p
};
var Businesses$d = "Bisnis";
var Expertise$c = "Keahlian";
var Provider$c = "Penyedia";
var Providers$o = "Penyedia";
var Transparency$c = "Transparansi";
var Travelers$o = "Wisatawan";
var Widget$c = "Widget";
var airports$c = "bandara";
var cities$c = "kota";
var countries$c = "negara";
var currencies$c = "mata uang";
var eSIMs$c = "eSIMs";
var languages$c = "bahasa";
var providers$c = "penyedia";
var HomeId = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 negara, 3500+ bandara, 3000+ penyedia, 17 bahasa, 39 mata uang.",
  "24/7 customer support": "Dukungan pelanggan 24/7",
  "771 reviews": "",
  "API Integration": "Integrasi API",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Tambahkan Widget pencarian ke situs web Anda, memungkinkan pengunjung mencari opsi transportasi langsung di halaman Anda dan mengarahkan mereka ke Mozio.com untuk pemesanan.",
  "Airport Parking": "Parkir bandara",
  "All transfers in one place": "Semua transfer dalam satu tempat",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Apakah Anda Agen Perjalanan, Hotel, Maskapai Penerbangan, atau Agen Sewa Mobil yang ingin memperluas jangkauan Anda?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Apakah Anda Agen Perjalanan, Hotel, Maskapai Penerbangan, atau Agen Sewa Mobil yang ingin memperluas jangkauan Anda?",
  "Are you a Travel Agent?": "Apakah Anda agen perjalanan?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Apakah Anda Agen Perjalanan? Pesan transportasi darat atas nama klien Anda dengan lancar menggunakan Alat Pemesanan Agen Perjalanan kami.",
  "Are you a ground transportation Provider?": "Apakah Anda penyedia transportasi darat?",
  "Are you planning a trip and need reliable transportation options?": "Apakah Anda merencanakan perjalanan dan membutuhkan opsi transportasi yang dapat diandalkan?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Pesan sedan, SUV, van, bus pribadi dan bersama, limusin, kereta, dan bahkan taksi air.",
  "Book with Mozio": "Pesan dengan Mozio",
  "Booking tool for Travel Agents": "Alat Pemesanan untuk Agen Perjalanan",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Merek seperti Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, dan lebih dari 5.000 agen perjalanan mempercayai Mozio untuk kebutuhan transportasi darat mereka.",
  Businesses: Businesses$d,
  "Discover our solutions": "Temukan solusi kami",
  "Do you manage travel arrangements for clients?": "Apakah Anda mengelola pengaturan perjalanan untuk klien?",
  "Do you offer ground transportation services and want to expand your reach?": "Apakah Anda menawarkan layanan transportasi darat dan ingin memperluas jangkauan Anda?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Tingkatkan pengalaman pelanggan dengan mengintegrasikan opsi pemesanan transportasi darat yang nyaman ke dalam sistem Anda saat ini. ",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Tingkatkan merek Anda dengan solusi White Label Mozio, menawarkan alur pemesanan transportasi yang sepenuhnya disesuaikan untuk keperluan pengintegrasian branding Anda—mulai dari warna dan logo hingga URL—memberikan pengalaman tanpa hambatan kepada klien Anda atas nama Anda.",
  Expertise: Expertise$c,
  "Extensive network and reach": "Jaringan dan jangkauan yang luas",
  "Flight delayed? We wait.": "Penerbangan tertunda? Kami akan menunggu.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Penerbangan tertunda? Kami akan menunggu. Butuh bantuan dengan pemesanan Anda? Dapatkan bantuan langsung dengan dukungan kami yang tersedia 24/7.",
  "Free cancellations within 24 hours": "Pembatalan gratis dalam 24 jam",
  "Free online cancellations": "Pembatalan online gratis",
  "Global coverage": "Cakupan global",
  "Innovative technology": "Teknologi inovatif",
  "Instantly guaranteed booking": "Pemesanan instan yang terjamin",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integrasikan API Mozio yang kuat ke dalam sistem Anda yang sudah ada dan biarkan klien Anda memesan transfer dengan lancar.",
  "Integrate with Mozio": "Integrasi dengan Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Bergabunglah dengan jaringan global Mozio dan terhubung dengan jutaan Pelancong.",
  "Learn more": "Pelajari lebih lanjut",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Manfaatkan keahlian industri kami yang lebih dari 12 tahun spesialisasi dalam transportasi darat.",
  "Licensed partners": "Mitra berlisensi",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Kelola perubahan dengan mudah melalui pembatalan online gratis pada 99% pemesanan.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Tawarkan kepada klien Anda opsi parkir bandara yang bebas repot, memastikan perjalanan mereka berjalan lancar dari awal hingga akhir.",
  "Partner with Us": "Bermitra dengan kami",
  "Partner with us": "Bekerja sama dengan Kami",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Berikan klien Anda akses internet tanpa hambatan di seluruh dunia dengan eSIM.",
  Provider: Provider$c,
  Providers: Providers$o,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Mulai pesan sekarang",
  "The largest Travel Businesses in the world trust Mozio": "Bisnis perjalanan terbesar di dunia mempercayai Mozio",
  Transparency: Transparency$c,
  "Travel Agency": "",
  "Travel Agent": "Agen perjalanan",
  "Travel Agent Booking Tool": "Alat Pemesanan Agen Perjalanan",
  "Travel Agents": "Agen Perjalanan",
  Travelers: Travelers$o,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Gunakan platform kami sebagai pusat pemesanan semua transportasi darat Anda, dari transfer bandara hingga taksi lokal, di seluruh dunia.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Gunakan teknologi mutakhir kami dengan fitur canggih dan opsi yang dapat disesuaikan.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Kami bermitra dengan Penyedia transportasi darat berlisensi, memastikan realibilitas dalam setiap pemesanan.",
  "What we offer": "Apa yang Kami Tawarkan",
  "White Label": "White Label",
  "Why choose Mozio": "Mengapa memilih Mozio",
  Widget: Widget$c,
  "World class customer service": "Layanan pelanggan kelas dunia",
  "Your go-to ground transportation platform": "Platform transportasi darat andalan Anda",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Platform transportasi darat andalan Anda untuk Wisatawan, Agen Perjalanan, Hotel, Maskapai Penerbangan, dan lainnya.",
  airports: airports$c,
  cities: cities$c,
  countries: countries$c,
  currencies: currencies$c,
  eSIMs: eSIMs$c,
  "in New York City": "",
  languages: languages$c,
  providers: providers$c
};
var Blog$b = "Blog";
var Careers$b = "Lavora con noi";
var Contact$b = "Contatti";
var Coverage$b = "Copertura";
var Guides$b = "Guide";
var Imprint$b = "Impronta";
var Parking$b = "Parcheggi";
var eSIM$b = "eSIM";
var FooterIt = {
  Blog: Blog$b,
  Careers: Careers$b,
  Contact: Contact$b,
  Coverage: Coverage$b,
  Guides: Guides$b,
  Imprint: Imprint$b,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. I marchi e i brand sono proprietà dei rispettivi titolari.",
  Parking: Parking$b,
  "Privacy policy": "Privacy Policy",
  "Terms of service": "Termini di Servizio",
  eSIM: eSIM$b
};
var About$b = "Chi siamo";
var Close$b = "Chiudi";
var Help$b = "Aiuto";
var More$b = "Di più";
var OK$b = "Ok";
var Providers$n = "Provider";
var Send$b = "Invia";
var Thanks$b = "Grazie";
var Travelers$n = "Viaggiatori";
var HeaderIt = {
  About: About$b,
  "An error occurred while sending the email.": "C'è stato un errore durante l'invio della email.",
  "Business Partners": "Partner Commerciali",
  Close: Close$b,
  "Create Account": "Crea un Conto",
  "Email address": "Indirizzo email",
  "Hello, {{name}}!": "Ciao, {{name}} !",
  Help: Help$b,
  "If any reservations are found we'll send them to you.": "Grazie, nel caso in cui siano presenti delle prenotazioni te le invieremo.",
  "Log out": "Disconnettersi",
  More: More$b,
  "My account": "Il mio conto",
  "My bookings": "Le mie prenotazioni",
  OK: OK$b,
  Providers: Providers$n,
  "Resend Booking": "Reinvia prenotazione",
  "Resend Confirmation Email": "Invia conferma email di nuovo",
  Send: Send$b,
  "Sign In": "Accedi",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Comunicaci la tua email e ti invieremo una copia delle tue prenotazioni",
  Thanks: Thanks$b,
  "Travel Agent": "Agente di Viaggio",
  "Travel Agents": "Agenzie di Viaggio",
  Travelers: Travelers$n
};
var Businesses$c = "Agenzie";
var Expertise$b = "Esperienza";
var Provider$b = "Provider";
var Providers$m = "Provider";
var Transparency$b = "Trasparenza";
var Travelers$m = "Viaggiatori";
var Widget$b = "Widget";
var airports$b = "aeroporti";
var cities$b = "città";
var countries$b = "paesi";
var currencies$b = "valute";
var eSIMs$b = "eSIMs";
var languages$b = "lingue";
var providers$b = "Provider";
var HomeIt = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 paesi, oltre 3500 aeroporti, più di 3000 Provider, 17 lingue, oltre 39 valute.",
  "24/7 customer support": "Assistenza clienti 24/7.",
  "771 reviews": "",
  "API Integration": "Integrazione API",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Aggiungi i widget di ricerca sul tuo sito web, permettendo ai visitatori di cercare soluzioni per transfer direttamente sulla tua pagina e trasferendoli poi a Mozio.com per la prenotazione.",
  "Airport Parking": "Parcheggio in Aeroporto",
  "All transfers in one place": "Un’unica piattaforma per tutte le tue esigenze di mobilità",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Sei un'Agenzia di Viaggi, un Hotel, una Compagnia Aerea o un'Agenzia di Noleggio Auto che desidera ampliare la propria portata?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Sei un'Agenzia di Viaggi, un Hotel, una Compagnia Aerea o un'Agenzia di Noleggio Auto che desidera ampliare la propria portata?",
  "Are you a Travel Agent?": "Sei un'Agenzia di Viaggi?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Sei un’Agenzia di Viaggi? Prenota transfer per conto dei tuoi clienti in modo semplice e veloce con il nostro Strumento di Prenotazione per Agenzie di Viaggio.",
  "Are you a ground transportation Provider?": "Sei un Provider di mobilità?",
  "Are you planning a trip and need reliable transportation options?": "Stai pianificando un viaggio e hai bisogno di soluzioni di mobilità affidabili?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Prenota berline, SUV, furgoni, autobus privati e condivisi, limousine, treni e persino taxi acquatici.",
  "Book with Mozio": "Prenota con Mozio",
  "Booking tool for Travel Agents": "Strumento di Prenotazione per Agenzie di Viaggio",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Marchi come Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, e oltre 5.000 Agenzie di Viaggio si affidano a Mozio per le loro esigenze di mobilità.",
  Businesses: Businesses$c,
  "Discover our solutions": "Scopri le nostre soluzioni",
  "Do you manage travel arrangements for clients?": "Gestisci le prenotazioni di viaggio per i tuoi clienti?",
  "Do you offer ground transportation services and want to expand your reach?": "Offri servizi di mobilità e desideri ampliare la tua portata?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Migliora l’esperienza dei tuoi clienti integrando convenienti soluzioni di prenotazione transfer nei tuoi sistemi.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Valorizza il tuo marchio con la soluzione White Label di Mozio, offrendo un flusso di prenotazione dei transfer completamente personalizzato che integra il tuo branding—dai colori e loghi agli URL—offrendo ai tuoi clienti un ottima esperienza con il tuo nome.",
  Expertise: Expertise$b,
  "Extensive network and reach": "Rete estesa e ampia copertura",
  "Flight delayed? We wait.": "Volo in ritardo? Ti aspettiamo.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Volo in ritardo? Ti aspettiamo. Hai bisogno di aiuto con la tua prenotazione? Ricevi assistenza immediata con il nostro supporto 24/7.",
  "Free cancellations within 24 hours": "Cancellazioni gratuite entro 24 ore.",
  "Free online cancellations": "Cancellazioni online gratuite",
  "Global coverage": "Copertura globale",
  "Innovative technology": "Tecnologia innovativa",
  "Instantly guaranteed booking": "Prenotazione garantita istantaneamente.",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integra le efficaci API di Mozio nei tuoi sistemi e consenti ai tuoi clienti di prenotare transfer in maniera facile e veloce.",
  "Integrate with Mozio": "Integrati con Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Unisciti alla rete globale di Mozio e connettiti con milioni di Viaggiatori.",
  "Learn more": "Scopri di più",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Sfrutta la nostra esperienza nel settore con oltre 12 anni di specializzazione nella mobilità.",
  "Licensed partners": "Partner autorizzati.",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Gestisci le modifiche facilmente con cancellazioni online gratuite sul 99% delle prenotazioni.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Offri ai tuoi clienti soluzioni di parcheggio aeroportuale senza stress, garantendo un inizio e una conclusione del viaggio senza problemi.",
  "Partner with Us": "Collabora con noi",
  "Partner with us": "Collabora con Noi",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Offri ai tuoi clienti un accesso a Internet senza interruzioni in tutto il mondo con le eSIM.",
  Provider: Provider$b,
  Providers: Providers$m,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Prenota ora",
  "The largest Travel Businesses in the world trust Mozio": "Le più grandi Compagnie di Viaggio al mondo si affidano a Mozio.",
  Transparency: Transparency$b,
  "Travel Agency": "",
  "Travel Agent": "Agenzie di Viaggio",
  "Travel Agent Booking Tool": "Strumento di Prenotazione per Agenzie di Viaggio",
  "Travel Agents": "Agenzie di Viaggio",
  Travelers: Travelers$m,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Usa la nostra piattaforma come riferimento per tutte le tue esigenze di mobilità, dai transfer aeroportuali ai taxi locali, in tutto il mondo.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Sfrutta la nostra tecnologia all'avanguardia con funzionalità avanzate e opzioni personalizzabili.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Collaboriamo con Provider di mobilità autorizzati, garantendo affidabilità in ogni prenotazione.",
  "What we offer": "Cosa offriamo",
  "White Label": "White Label",
  "Why choose Mozio": "Perché scegliere Mozio",
  Widget: Widget$b,
  "World class customer service": "Assistenza clienti di livello mondiale",
  "Your go-to ground transportation platform": "La tua piattaforma di riferimento per la mobilità",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "La tua piattaforma di riferimento per la mobilità dedicata a Viaggiatori, Agenzie di Viaggio, Hotel, Compagnie Aeree e altro ancora.",
  airports: airports$b,
  cities: cities$b,
  countries: countries$b,
  currencies: currencies$b,
  eSIMs: eSIMs$b,
  "in New York City": "",
  languages: languages$b,
  providers: providers$b
};
var Blog$a = "ブログ";
var Careers$a = "キャリア";
var Contact$a = "お問い合わせ";
var Coverage$a = "補償範囲";
var Guides$a = "ガイド";
var Imprint$a = "インプリント";
var Parking$a = "駐車場";
var eSIM$a = "eSIM";
var FooterJa = {
  Blog: Blog$a,
  Careers: Careers$a,
  Contact: Contact$a,
  Coverage: Coverage$a,
  Guides: Guides$a,
  Imprint: Imprint$a,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "年 Mozio Inc. 商標およびブランドはそれぞれの所有者に帰属します。",
  Parking: Parking$a,
  "Privacy policy": "プライバシーポリシー",
  "Terms of service": "利用規約",
  eSIM: eSIM$a
};
var About$a = "について";
var Close$a = "閉じる";
var Help$a = "ヘルプ";
var More$a = "もっと";
var OK$a = "OK";
var Providers$l = "プロバイダー";
var Send$a = "送信";
var Thanks$a = "ありがとう";
var Travelers$l = "旅行者";
var HeaderJa = {
  About: About$a,
  "An error occurred while sending the email.": "メールの送信中にエラーが発生しました。",
  "Business Partners": "ビジネスパートナー",
  Close: Close$a,
  "Create Account": "アカウントの作成",
  "Email address": "Eメールアドレス",
  "Hello, {{name}}!": "こんにちは、 {{name}} ！",
  Help: Help$a,
  "If any reservations are found we'll send them to you.": "ありがとうございます。何か予約が入りましたらお送りします。",
  "Log out": "ログアウト",
  More: More$a,
  "My account": "私のアカウント",
  "My bookings": "私の予約",
  OK: OK$a,
  Providers: Providers$l,
  "Resend Booking": "予約を再送信する",
  "Resend Confirmation Email": "確認メールを再送信する",
  Send: Send$a,
  "Sign In": "サインイン",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Eメールをお知らせいただければ、今後の予約の全コピーをお送りします。",
  Thanks: Thanks$a,
  "Travel Agent": "旅行代理店",
  "Travel Agents": "旅行代理店",
  Travelers: Travelers$l
};
var Businesses$b = "ビジネス";
var Expertise$a = "専門知識";
var Provider$a = "プロバイダー";
var Providers$k = "プロバイダー";
var Transparency$a = "透明性";
var Travelers$k = "旅行者";
var Widget$a = "ウィジェット";
var airports$a = "以上の空港";
var cities$a = "以上の都市";
var countries$a = "カ国以上";
var currencies$a = "以上の通貨";
var eSIMs$a = "eSIMs";
var languages$a = "の言語";
var providers$a = "以上のプロバイダー";
var HomeJa = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180カ国、3500以上の空港、3000以上のプロバイダー、17の言語、39以上の通貨。",
  "24/7 customer support": "24時間365日のカスタマーサポート",
  "771 reviews": "",
  "API Integration": "API統合",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "ウェブサイトに検索ウィジェットを追加すると、訪問者が貴社のページで直接交通オプションを検索できるようになり、Mozio.comでの予約にリダイレクトされます。",
  "Airport Parking": "空港駐車場",
  "All transfers in one place": "すべての転送を一箇所で",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "貴社は旅行代理店、ホテル、航空会社、またはレンタカー会社で、顧客層を拡大したいとお考えですか？",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "貴社は旅行代理店、ホテル、航空会社、またはレンタカー会社で、顧客層を拡大したいとお考えですか？",
  "Are you a Travel Agent?": "貴社は旅行代理店ですか？",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "貴社は旅行代理店ですか？弊社の旅行代理店予約ツールで、顧客のためにシームレスに地上交通を予約しましょう。",
  "Are you a ground transportation Provider?": "貴社は地上交通のプロバイダーですか？",
  "Are you planning a trip and need reliable transportation options?": "旅行を計画していて、信頼できる交通手段が必要ですか？",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "セダン、SUV、バン、プライベートおよび共有バス、リムジン、列車、さらには水上タクシーまで予約できます。",
  "Book with Mozio": "Mozioで予約する",
  "Booking tool for Travel Agents": "旅行代理店向け予約ツール",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Mozioは、Hertz、エールフランス、TUI、Priceline、JetBlue、Booking.com、CruisePlanners、Accorのほか5,000以上の旅行代理店から、地上交通のニーズについて信頼を得ています。",
  Businesses: Businesses$b,
  "Discover our solutions": "弊社のソリューションをご覧ください",
  "Do you manage travel arrangements for clients?": "顧客の旅行手配を管理していますか？",
  "Do you offer ground transportation services and want to expand your reach?": "地上交通サービスを提供しており、顧客層を拡大したいですか？",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "便利な地上交通の予約オプションを貴社のシステムに統合して、顧客体験を向上させましょう。",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Mozioのホワイトラベルソリューションによって貴社のブランドを強化できます。色やロゴからURLまでの完全にカスタマイズした交通予約フローを統合することで、貴社の名前でシームレスなサービスを顧客に提供いただけます。",
  Expertise: Expertise$a,
  "Extensive network and reach": "広範なネットワークとリーチ",
  "Flight delayed? We wait.": "フライトの遅延ですか？私たちはお待ちします。",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "フライトが遅れましたか？私たちはお待ちします。ご予約にサポートが必要ですか？24時間年中無休のサポートで即時対応します。",
  "Free cancellations within 24 hours": "24時間以内の無料キャンセル",
  "Free online cancellations": "無料のオンラインキャンセル",
  "Global coverage": "グローバルな補償範囲",
  "Innovative technology": "革新的な技術",
  "Instantly guaranteed booking": "即時保証された予約",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Mozioの強力なAPIを既存のシステムに統合し、顧客がシームレスに送迎を予約できるようにします。",
  "Integrate with Mozio": "Mozioと統合する",
  "Join Mozio's global network and connect with millions of Travelers. ": "Mozioのグローバルネットワークに参加し、数百万人の旅行者とつながりましょう。",
  "Learn more": "詳しくはこちら",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "地上交通における12年以上の専門知識を活用しましょう。",
  "Licensed partners": "認定パートナー",
  "Manage changes easily with free online cancellations on 99% of bookings.": "99％の予約で無料のオンラインキャンセルにより簡単に変更を管理できます。",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "面倒な手続きが不要な空港駐車場のオプションをクライアントに提供し、スムーズな旅行の始まりと終わりを保証しましょう。",
  "Partner with Us": "弊社と提携する",
  "Partner with us": "私たちと提携する",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "eSIMを使って、クライアントに世界中でシームレスなインターネットアクセスを提供しましょう。",
  Provider: Provider$a,
  Providers: Providers$k,
  "Rating: 4.75 / 5": "",
  "Start booking now": "今すぐ予約開始",
  "The largest Travel Businesses in the world trust Mozio": "世界の最大手の旅行会社がMozioを信頼しています。",
  Transparency: Transparency$a,
  "Travel Agency": "",
  "Travel Agent": "旅行代理店",
  "Travel Agent Booking Tool": "旅行代理店予約ツール",
  "Travel Agents": "旅行代理店",
  Travelers: Travelers$k,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "空港送迎から現地のタクシーまで、すべての地上交通の予約をワンストップで行える弊社のプラットフォームをご利用ください。",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "先端技術を活用し、高度な機能とカスタマイズ可能なオプションを提供します。",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "私たちはライセンスを持つ地上交通のプロバイダーと提携し、すべての予約で信頼性を確保しています。",
  "What we offer": "私たちの提供するもの",
  "White Label": "ホワイトラベル",
  "Why choose Mozio": "なぜMozioが選ばれるのか",
  Widget: Widget$a,
  "World class customer service": "世界クラスのカスタマーサービス",
  "Your go-to ground transportation platform": "あなたのGo-To地上交通プラットフォーム",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "旅行者、旅行代理店、ホテル、航空会社などのためのGo-To地上交通プラットフォーム。",
  airports: airports$a,
  cities: cities$a,
  countries: countries$a,
  currencies: currencies$a,
  eSIMs: eSIMs$a,
  "in New York City": "",
  languages: languages$a,
  providers: providers$a
};
var Blog$9 = "블로그";
var Careers$9 = "채용 정보";
var Contact$9 = "연락처";
var Coverage$9 = "보장 범위";
var Guides$9 = "가이드";
var Imprint$9 = "법적 고지";
var Parking$9 = "주차";
var eSIM$9 = "eSIM";
var FooterKo = {
  Blog: Blog$9,
  Careers: Careers$9,
  Contact: Contact$9,
  Coverage: Coverage$9,
  Guides: Guides$9,
  Imprint: Imprint$9,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. 상표 및 브랜드는 각 소유자의 자산입니다.",
  Parking: Parking$9,
  "Privacy policy": "개인정보 보호정책",
  "Terms of service": "서비스 약관",
  eSIM: eSIM$9
};
var About$9 = "회사 소개";
var Close$9 = "닫기";
var Help$9 = "도움말";
var More$9 = "더";
var OK$9 = "알았어요.";
var Providers$j = "제공업체";
var Send$9 = "보내기";
var Thanks$9 = "감사해요";
var Travelers$j = "여행객";
var HeaderKo = {
  About: About$9,
  "An error occurred while sending the email.": "이메일을 보내는 동안 오류가 발생했습니다.",
  "Business Partners": "협력사",
  Close: Close$9,
  "Create Account": "계정 만들기",
  "Email address": "이메일 주소",
  "Hello, {{name}}!": "안녕하세요, {{name}} !",
  Help: Help$9,
  "If any reservations are found we'll send them to you.": "감사합니다, 예약이 확인되는 대로 전송해드립니다.",
  "Log out": "로그 아웃",
  More: More$9,
  "My account": "내 계정",
  "My bookings": "내 예약",
  OK: OK$9,
  Providers: Providers$j,
  "Resend Booking": "예약 재전송",
  "Resend Confirmation Email": "확인 이메일 재전송",
  Send: Send$9,
  "Sign In": "로그인",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "귀하의 이메일을 알려주시면 향후 예약에 관한 모든 사본을 전송해드립니다. ",
  Thanks: Thanks$9,
  "Travel Agent": "여행사",
  "Travel Agents": "여행사",
  Travelers: Travelers$j
};
var Businesses$a = "협력사";
var Expertise$9 = "전문성";
var Provider$9 = "제공업체";
var Providers$i = "제공업체";
var Transparency$9 = "투명성";
var Travelers$i = "여행객";
var Widget$9 = "위젯";
var airports$9 = "개 이상의 공항";
var cities$9 = "개 이상의 도시";
var countries$9 = "개 이상의 국가";
var currencies$9 = "개 이상의 통화를 지원합니다";
var eSIMs$9 = "eSIMs";
var languages$9 = "개 언어";
var providers$9 = "개 이상의 제공업체";
var HomeKo = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180개국, 3,500개 이상의 공항, 3,000개 이상의 제공업체, 17개 언어, 39개 이상의 통화를 지원합니다.",
  "24/7 customer support": "연중무휴 고객 지원",
  "771 reviews": "",
  "API Integration": "API 통합",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "귀사 웹사이트에 검색 위젯을 추가하여 해당 웹페이지에서 직접 교통수단 옵션을 검색한 후 Mozio.com으로 연결하여 교통편을 예약할 수 있습니다.",
  "Airport Parking": "공항 주차",
  "All transfers in one place": "모든 교통편을 한 곳에서",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "여행사, 호텔, 항공사 또는 렌터카 업체로 서비스를 확장하고 싶으신가요?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "여행사, 호텔, 항공사 또는 렌터카 업체로 서비스를 확장하고 싶으신가요?",
  "Are you a Travel Agent?": "여행사 직원이신가요?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "여행사 직원이신가요? 여행사 예약 도구로 원활하게 고객의 교통편을 예약하실 수 있습니다.",
  "Are you a ground transportation Provider?": "지상 교통 서비스 제공 업체인가요?",
  "Are you planning a trip and need reliable transportation options?": "여행에 이용할 신뢰할 수 있는 교통수단이 필요하신가요?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "세단, SUV, 밴, 개인 및 공용 버스, 리무진, 기차, 심지어 수상 택시까지 예약하실 수 있습니다.",
  "Book with Mozio": "Mozio로 예약하기",
  "Booking tool for Travel Agents": "여행사 예약 도구",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor 등과 5,000개 이상의 여행사가 Mozio의 지상 교통 서비스를 신뢰하고 있습니다.",
  Businesses: Businesses$a,
  "Discover our solutions": "솔루션 살펴보기",
  "Do you manage travel arrangements for clients?": "고객 여행 일정을 관리하십니까?",
  "Do you offer ground transportation services and want to expand your reach?": "지상 교통 서비스 제공 업체로 서비스를 확장하고 싶으신가요?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "기존 시스템에 편리한 지상 교통 예약 옵션을 통합하여 고객 경험을 개선하실 수 있습니다.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "색상, 로고부터 URL까지 브랜딩을 통합, 맞춤화된 교통 예약 플로를 제공하는 Mozio의 White Label 솔루션으로 브랜드를 강화하여 고객에게 귀사의 이름으로 원활한 경험을 제공하실 수 있습니다.",
  Expertise: Expertise$9,
  "Extensive network and reach": "광범위한 네트워크 및 서비스 범위",
  "Flight delayed? We wait.": "비행기가 연착되어도 대기합니다.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "항공편이 지연되더라도 대기합니다. 도움이 필요하신 경우, 연중무휴 24시간 지원팀이 즉시 지원합니다.",
  "Free cancellations within 24 hours": "24시간 이내 무료 취소",
  "Free online cancellations": "무료 온라인 취소",
  "Global coverage": "グローバルな補償範囲",
  "Innovative technology": "혁신적인 기술",
  "Instantly guaranteed booking": "즉시 확약",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Mozio의 강력한 API를 기존 시스템에 통합하여 고객이 원활하게 교통편을 예약할 수 있는 서비스를 제공할 수 있습니다.",
  "Integrate with Mozio": "Mozio와 통합하기",
  "Join Mozio's global network and connect with millions of Travelers. ": "Mozio의 글로벌 네트워크에 합류하여 수백만 명의 여행객과 연결하세요.",
  "Learn more": "자세히 알아보기",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "12년 이상 지상 교통 서비스 분야에서 전문성을 쌓아온 당사의 업계 전문성을 활용하세요.",
  "Licensed partners": "인증된 파트너",
  "Manage changes easily with free online cancellations on 99% of bookings.": "예약의 99%가 온라인에서 무료로 취소할 수 있어 변경 사항을 간편하게 관리할 수 있습니다.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "고객에게 간편한 공항 주차 옵션을 제공하여 여행의 원활한 시작과 마무리를 보장하세요.",
  "Partner with Us": "Mozio와 협력하기",
  "Partner with us": "Mozio와 협력하기",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "eSIM으로 고객에게 전 세계에서 원활한 인터넷 접속을 제공하실 수 있습니다.",
  Provider: Provider$9,
  Providers: Providers$i,
  "Rating: 4.75 / 5": "",
  "Start booking now": "지금 예약하기",
  "The largest Travel Businesses in the world trust Mozio": "세계 최대 여행 업체들이 Mozio를 신뢰합니다.",
  Transparency: Transparency$9,
  "Travel Agency": "",
  "Travel Agent": "여행사",
  "Travel Agent Booking Tool": "여행사 예약 도구",
  "Travel Agents": "여행사",
  Travelers: Travelers$i,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "공항 교통편에서 현지 택시까지 전 세계 모든 지상 교통편 예약이 가능한 원스톱 플랫폼 Mozio를 이용하세요.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "고급 기능과 사용자 지정 옵션을 갖춘 최첨단 기술을 활용하세요.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "저희는 허가받은 지상 교통수단 제공 업체와 제휴하여 모든 예약의 신뢰성을 보장합니다.",
  "What we offer": "제공 서비스",
  "White Label": "White Label",
  "Why choose Mozio": "Mozio를 선택해야 하는 이유",
  Widget: Widget$9,
  "World class customer service": "세계적인 수준의 고객 서비스",
  "Your go-to ground transportation platform": "지상 교통 플랫폼",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "여행객, 여행사, 호텔, 항공사 등을 위한 지상 교통 플랫폼입니다.",
  airports: airports$9,
  cities: cities$9,
  countries: countries$9,
  currencies: currencies$9,
  eSIMs: eSIMs$9,
  "in New York City": "",
  languages: languages$9,
  providers: providers$9
};
var Blog$8 = "Blog";
var Careers$8 = "Carrières";
var Contact$8 = "Contact";
var Coverage$8 = "Dekking";
var Guides$8 = "Gidsen";
var Imprint$8 = "Impressum";
var Parking$8 = "Parkeren";
var eSIM$8 = "eSIM";
var FooterNl = {
  Blog: Blog$8,
  Careers: Careers$8,
  Contact: Contact$8,
  Coverage: Coverage$8,
  Guides: Guides$8,
  Imprint: Imprint$8,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Handelsmerken en merken zijn eigendom van hun respectievelijke eigenaren.",
  Parking: Parking$8,
  "Privacy policy": "Privacybeleid",
  "Terms of service": "Servicevoorwaarden",
  eSIM: eSIM$8
};
var About$8 = "Over";
var Close$8 = "Sluiten";
var Help$8 = "Help";
var More$8 = "Meer";
var OK$8 = "Oké";
var Providers$h = "Aanbieders";
var Send$8 = "Verzenden";
var Thanks$8 = "Bedankt";
var Travelers$h = "Reizigers";
var HeaderNl = {
  About: About$8,
  "An error occurred while sending the email.": "Er is een fout opgetreden tijdens het verzenden van de e-mail.",
  "Business Partners": "Zakelijke partners",
  Close: Close$8,
  "Create Account": "Account aanmaken",
  "Email address": "E-mail adres",
  "Hello, {{name}}!": "Hallo, {{name}} !",
  Help: Help$8,
  "If any reservations are found we'll send them to you.": "Dank u, als er reserveringen worden gevonden sturen we ze naar u toe.",
  "Log out": "Uitloggen",
  More: More$8,
  "My account": "Mijn rekening",
  "My bookings": "Mijn boekingen",
  OK: OK$8,
  Providers: Providers$h,
  "Resend Booking": "Verstuur bevestiging opnieuw",
  "Resend Confirmation Email": "Verstuur Bevestigings E-mail opnieuw",
  Send: Send$8,
  "Sign In": "Aanmelden",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Geef ons uw e-mail en we sturen u de kopieën van al uw toekomstige boekingen. ",
  Thanks: Thanks$8,
  "Travel Agent": "Reisagent",
  "Travel Agents": "Reisagenten",
  Travelers: Travelers$h
};
var Businesses$9 = "Bedrijven";
var Expertise$8 = "Expertise";
var Provider$8 = "Aanbieders";
var Providers$g = "Aanbieders";
var Transparency$8 = "Transparantie";
var Travelers$g = "Reizigers";
var Widget$8 = "Widget";
var airports$8 = "luchthavens";
var cities$8 = "steden";
var countries$8 = "landen";
var currencies$8 = "valuta";
var eSIMs$8 = "eSIMs";
var languages$8 = "talen";
var providers$8 = "aanbieders";
var HomeNl = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 landen, 3500+ luchthavens, 3000+ aanbieders, 17 talen, 39 valuta.",
  "24/7 customer support": "24/7 klantenservice",
  "771 reviews": "",
  "API Integration": "API-integratie",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Voeg zoekwidgets toe aan je website, zodat bezoekers rechtstreeks op je pagina vervoersopties kunnen zoeken en worden doorgestuurd naar Mozio.com voor boekingen.",
  "Airport Parking": "Luchthavenparkeren",
  "All transfers in one place": "Alle transfers op één plek",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Ben je een Reisbureau, Hotel, Luchtvaartmaatschappij of Autoverhuurbedrijf dat zijn bereik wil vergroten?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Ben je een Reisbureau, Hotel, Luchtvaartmaatschappij of Autoverhuurbedrijf dat zijn bereik wil vergroten?",
  "Are you a Travel Agent?": "Bent u een Reisagent?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Ben je een Reisagent? Boek grondtransport namens je klanten naadloos met onze Reisagent Boekingstool.",
  "Are you a ground transportation Provider?": "Bent u een aanbieder van vervoer over de weg?",
  "Are you planning a trip and need reliable transportation options?": "Ben je een reis aan het plannen en heb je betrouwbare vervoersopties nodig?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Boek sedans, SUV's, busjes, privé- en gedeelde bussen, limousines, treinen, en zelfs watertaxi's.",
  "Book with Mozio": "Boek met Mozio",
  "Booking tool for Travel Agents": "Boekingstool voor Reisagenten",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Merken zoals Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor en meer dan 5.000 reisagenten vertrouwen op Mozio voor hun grondtransportbehoeften.",
  Businesses: Businesses$9,
  "Discover our solutions": "Ontdek onze oplossingen",
  "Do you manage travel arrangements for clients?": "Beheer je reisarrangementen voor klanten?",
  "Do you offer ground transportation services and want to expand your reach?": "Bied je grondtransportdiensten aan en wil je je bereik vergroten?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Verhoog de klanttevredenheid door gemakkelijke boekingsopties voor vervoer over de weg te integreren in uw bestaande systemen.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Versterk je merk met Mozio’s White Label-oplossing, een volledig aangepaste boekingsstroom voor vervoer die je branding integreert—van kleuren en logo's tot URL's—en je klanten een naadloze ervaring biedt onder je naam.",
  Expertise: Expertise$8,
  "Extensive network and reach": "Uitgebreid netwerk en bereik",
  "Flight delayed? We wait.": "Vlucht vertraagd? Wij wachten.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Vlucht vertraagd? Wij wachten. Hulp nodig met uw boeking? Ontvang directe hulp met onze 24/7 ondersteuning.",
  "Free cancellations within 24 hours": "Gratis annuleringen binnen 24 uur",
  "Free online cancellations": "Gratis online annuleringen",
  "Global coverage": "Wereldwijde dekking",
  "Innovative technology": "Innovatieve technologie",
  "Instantly guaranteed booking": "Direct gegarandeerde boeking",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integreer Mozio's krachtige API in je bestaande systemen en laat je klanten naadloos transfers boeken.",
  "Integrate with Mozio": "Integreer met Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Sluit u aan bij Mozio's wereldwijde netwerk en verbind met miljoenen Reizigers.",
  "Learn more": "Meer informatie",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Profiteer van onze branche-expertise met meer dan 12 jaar specialisatie in vervoer over de weg.",
  "Licensed partners": "Gecertificeerde partners",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Beheer wijzigingen eenvoudig met gratis online annuleringen op 99% van de boekingen.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Bied uw klanten probleemloze opties voor Luchthavenparkeren, zodat hun reis soepel begint en eindigt.",
  "Partner with Us": "Werk met ons samen",
  "Partner with us": "Werk samen met ons",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Bied uw klanten wereldwijd naadloze internettoegang met eSIM's.",
  Provider: Provider$8,
  Providers: Providers$g,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Begin nu met boeken",
  "The largest Travel Businesses in the world trust Mozio": "De grootste Reisbedrijven ter wereld vertrouwen Mozio",
  Transparency: Transparency$8,
  "Travel Agency": "",
  "Travel Agent": "Reisagenten",
  "Travel Agent Booking Tool": "Reisagent Boekingstool",
  "Travel Agents": "Reisagenten",
  Travelers: Travelers$g,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Gebruik ons platform als one-stop-shop voor al uw boekingen voor vervoer over de weg, van luchthaventransfers tot lokale taxi's, wereldwijd.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Maak gebruik van onze geavanceerde technologie met geavanceerde functies en aanpasbare opties.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "We werken samen met geregistreerde aanbieders van vervoer over de weg, wat betrouwbaarheid bij elke boeking garandeert.",
  "What we offer": "Wat wij bieden",
  "White Label": "White Label",
  "Why choose Mozio": "Waarom kiezen voor Mozio",
  Widget: Widget$8,
  "World class customer service": "Klantenservice van wereldklasse",
  "Your go-to ground transportation platform": "Jouw go-to platform voor grondtransport",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Jouw go-to platform voor grondtransport voor Reizigers, Reisagenten, Hotels, Luchtvaartmaatschappijen en meer.",
  airports: airports$8,
  cities: cities$8,
  countries: countries$8,
  currencies: currencies$8,
  eSIMs: eSIMs$8,
  "in New York City": "",
  languages: languages$8,
  providers: providers$8
};
var Blog$7 = "Blog";
var Careers$7 = "Kariera";
var Contact$7 = "Kontakt";
var Coverage$7 = "Obszar, gdzie oferujemy przewozy";
var Guides$7 = "Przewodniki";
var Imprint$7 = "Dane kontaktowe";
var Parking$7 = "Parking";
var eSIM$7 = "eSIM";
var FooterPl = {
  Blog: Blog$7,
  Careers: Careers$7,
  Contact: Contact$7,
  Coverage: Coverage$7,
  Guides: Guides$7,
  Imprint: Imprint$7,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Znaki towarowe i marki są własnością ich odpowiednich właścicieli.",
  Parking: Parking$7,
  "Privacy policy": "Polityka prywatności",
  "Terms of service": "Warunki",
  eSIM: eSIM$7
};
var About$7 = "O";
var Close$7 = "Zamknij";
var Help$7 = "Pomoc";
var More$7 = "Więcej";
var OK$7 = "Ok";
var Providers$f = "Przewoźnicy";
var Send$7 = "Wyślij";
var Thanks$7 = "Dzięki";
var Travelers$f = "Podróżnicy";
var HeaderPl = {
  About: About$7,
  "An error occurred while sending the email.": "Wystąpił błąd podczas wysyłania wiadomości e-mail.",
  "Business Partners": "Partnerzy Biznesowi",
  Close: Close$7,
  "Create Account": "Utwórz konto",
  "Email address": "Adres e-mail",
  "Hello, {{name}}!": "Witaj, {{name}} !",
  Help: Help$7,
  "If any reservations are found we'll send them to you.": "Dziękujemy, jeśli zostaną znalezione jakiekolwiek rezerwacje, wyślemy je do Ciebie.",
  "Log out": "Wyloguj",
  More: More$7,
  "My account": "Moje konto",
  "My bookings": "Moje rezerwacje",
  OK: OK$7,
  Providers: Providers$f,
  "Resend Booking": "Wyślij potwierdzenie rezerwacji ponownie",
  "Resend Confirmation Email": "Wyślij potwierdzenie email ponownie",
  Send: Send$7,
  "Sign In": "Zaloguj ",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Podaj nam swój e-mail, wyślemy Ci listę wszystkich nadchodzących rezerwacji.",
  Thanks: Thanks$7,
  "Travel Agent": "Biuro podróży",
  "Travel Agents": "Agenci Turystyczni",
  Travelers: Travelers$f
};
var Businesses$8 = "Firmy";
var Expertise$7 = "Ekspertyza.";
var Provider$7 = "Przewoźnicy";
var Providers$e = "Przewoźnicy";
var Transparency$7 = "Przejrzystość";
var Travelers$e = "Podróżnicy";
var Widget$7 = "Widget";
var airports$7 = "lotnisk";
var cities$7 = "miast";
var countries$7 = "krajów";
var currencies$7 = "walut";
var eSIMs$7 = "eSIMs";
var languages$7 = "języków";
var providers$7 = "przewoźników";
var HomePl = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 krajów, ponad 3500 lotnisk, 3000+ dostawców, 17 języków, ponad 39 walut.",
  "24/7 customer support": "obsługa klienta 24/7",
  "771 reviews": "",
  "API Integration": "Integracja API",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Dodaj widżety wyszukiwania na swojej stronie internetowej, umożliwiając odwiedzającym bezpośrednie wyszukiwanie opcji transportu i przekierowanie ich na Mozio.com w celu dokonania rezerwacji.",
  "Airport Parking": "Parking lotniskowy",
  "All transfers in one place": "Wszystkie transfery w jednym miejscu.",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Jesteś agencją turystyczną, hotelem, linią lotniczą lub wypożyczalnią samochodów i chcesz poszerzyć swój zasięg?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Jesteś agencją turystyczną, hotelem, linią lotniczą lub wypożyczalnią samochodów i chcesz poszerzyć swój zasięg?",
  "Are you a Travel Agent?": "Jesteś Agentem Turystycznym?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Jesteś agentem turystycznym? Rezerwuj transport lądowy w imieniu swoich klientów bezproblemowo dzięki naszemu narzędziu rezerwacyjnemu dla agentów turystycznych.",
  "Are you a ground transportation Provider?": "Czy jesteś dostawcą transportu lądowego?",
  "Are you planning a trip and need reliable transportation options?": "Planujesz podróż i potrzebujesz niezawodnych opcji transportu?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Zarezerwuj sedany, SUV-y, vany, prywatne i współdzielone autobusy, limuzyny, pociągi, a nawet wodne taksówki.",
  "Book with Mozio": "Zarezerwuj z Mozio",
  "Booking tool for Travel Agents": "Narzędzie rezerwacyjne dla agentów turystycznych",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Marki takie jak Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, ponad 5 000 agentów turystycznych ufają Mozio w kwestii ich potrzeb transportu lądowego.",
  Businesses: Businesses$8,
  "Discover our solutions": "Odkryj nasze rozwiązania",
  "Do you manage travel arrangements for clients?": "Zarządzasz organizacją podróży dla klientów?",
  "Do you offer ground transportation services and want to expand your reach?": "Oferujesz usługi transportu lądowego i chcesz poszerzyć swój zasięg?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Zwiększ zadowolenie klientów, integrując wygodne opcje rezerwacji transportu lądowego z istniejącymi systemami.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Wzmacniaj swoją markę dzięki rozwiązaniu White Label od Mozio, oferującemu w pełni dostosowany proces rezerwacji transportu, który integruje Twoją identyfikację wizualną — od kolorów i logo po adresy URL — zapewniając Twoim klientom bezproblemowe doświadczenie pod Twoją marką.",
  Expertise: Expertise$7,
  "Extensive network and reach": "Rozległa sieć i zasięg.",
  "Flight delayed? We wait.": "Lot opóźniony? Poczekamy.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Lot opóźniony? Czekamy. Potrzebujesz pomocy przy rezerwacji? Otrzymaj natychmiastową pomoc dzięki naszemu wsparciu dostępnemu 24/7.",
  "Free cancellations within 24 hours": "Bezpłatne odwołanie rezerwacji do 24h",
  "Free online cancellations": "Bezpłatne anulacje online.",
  "Global coverage": "Globalny zasięg",
  "Innovative technology": "Innowacyjna technologia",
  "Instantly guaranteed booking": "Natychmiastowa gwarancja rezerwacji",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Zintegruj potężne API Mozio z istniejącymi systemami i pozwól swoim klientom bezproblemowo rezerwować transfery.",
  "Integrate with Mozio": "Zintegruj się z Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Dołącz do globalnej sieci Mozio i nawiąż kontakt z milionami podróżnych",
  "Learn more": "Dowiedz się więcej",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Wykorzystaj naszą branżową ekspertyzę, opartą na ponad 12 latach specjalizacji w transporcie lądowym",
  "Licensed partners": "Licencjonowani partnerzy",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Zarządzaj zmianami z łatwością dzięki bezpłatnym anulacjom online przy 99% rezerwacji.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Oferuj swoim klientom bezproblemowe opcje parkingu na lotnisku, zapewniając płynny początek i zakończenie ich podróży.",
  "Partner with Us": "Współpracuj z nami.",
  "Partner with us": "Nawiąż z nami współpracę",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Zapewnij swoim klientom bezproblemowy dostęp do internetu na całym świecie dzięki kartom eSIM.",
  Provider: Provider$7,
  Providers: Providers$e,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Rozpocznij rezerwację już teraz.",
  "The largest Travel Businesses in the world trust Mozio": "Największe firmy turystyczne na świecie ufają Mozio.",
  Transparency: Transparency$7,
  "Travel Agency": "",
  "Travel Agent": "Agenci Turystyczni",
  "Travel Agent Booking Tool": "Narzędzie rezerwacyjne dla agentów turystycznych",
  "Travel Agents": "Agenci Turystyczni",
  Travelers: Travelers$e,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Skorzystaj z naszej platformy jako kompleksowego rozwiązania do rezerwacji transportu lądowego, od transferów lotniskowych po lokalne taksówki, na całym świecie",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Skorzystaj z naszej nowoczesnej technologii z zaawansowanymi funkcjami i opcjami dostosowywania.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Współpracujemy z licencjonowanymi dostawcami transportu lądowego, zapewniając niezawodność przy każdej rezerwacji",
  "What we offer": "Co oferujemy",
  "White Label": "White Label",
  "Why choose Mozio": "Dlaczego warto wybrać Mozio",
  Widget: Widget$7,
  "World class customer service": "Światowej klasy obsługa klienta",
  "Your go-to ground transportation platform": "Twoja niezawodna platforma transportu lądowego.",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Twoja niezawodna platforma transportu lądowego dla podróżnych, agentów turystycznych, hoteli, linii lotniczych i innych.",
  airports: airports$7,
  cities: cities$7,
  countries: countries$7,
  currencies: currencies$7,
  eSIMs: eSIMs$7,
  "in New York City": "",
  languages: languages$7,
  providers: providers$7
};
var Blog$6 = "Blog";
var Careers$6 = "Carreiras";
var Contact$6 = "Contactos";
var Coverage$6 = "Cobertura";
var Guides$6 = "Guias";
var Imprint$6 = "Impressão";
var Parking$6 = "Estacionamento";
var eSIM$6 = "eSIM";
var FooterPt = {
  Blog: Blog$6,
  Careers: Careers$6,
  Contact: Contact$6,
  Coverage: Coverage$6,
  Guides: Guides$6,
  Imprint: Imprint$6,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. As marcas registadas e as marcas são propriedade dos seus respectivos proprietários.",
  Parking: Parking$6,
  "Privacy policy": "Política de privacidade",
  "Terms of service": "Termos de serviço",
  eSIM: eSIM$6
};
var About$6 = "Sobre";
var Close$6 = "Fechar";
var Help$6 = "Ajuda";
var More$6 = "Mais";
var OK$6 = "Ok";
var Providers$d = "Fornecedores";
var Send$6 = "Enviar";
var Thanks$6 = "Obrigado";
var Travelers$d = "Viajantes";
var HeaderPt = {
  About: About$6,
  "An error occurred while sending the email.": "Ocorreu um erro ao enviar o e-mail.",
  "Business Partners": "Parceiros comerciais",
  Close: Close$6,
  "Create Account": "Criar Conta",
  "Email address": "Endereço de E-mail",
  "Hello, {{name}}!": "Olá, {{name}} !",
  Help: Help$6,
  "If any reservations are found we'll send them to you.": "Obrigado, iremos enviar as reservas que encontrarmos.",
  "Log out": "Sair",
  More: More$6,
  "My account": "Minha conta",
  "My bookings": "Minhas reservas",
  OK: OK$6,
  Providers: Providers$d,
  "Resend Booking": "Reenviar reserva",
  "Resend Confirmation Email": "Reenviar confirmação de E-mail",
  Send: Send$6,
  "Sign In": "Entrar",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Nos informe seu e-mail e enviaremos cópias de todas as suas reservas futuras.",
  Thanks: Thanks$6,
  "Travel Agent": "Agente de Viagens",
  "Travel Agents": "Agentes de viagens",
  Travelers: Travelers$d
};
var Businesses$7 = "Empresas";
var Expertise$6 = "Especialização";
var Provider$6 = "Fornecedores";
var Providers$c = "Fornecedores";
var Transparency$6 = "Transparência";
var Travelers$c = "Viajantes";
var Widget$6 = "Widget";
var airports$6 = "aeroportos";
var cities$6 = "cidades";
var countries$6 = "países";
var currencies$6 = "moedas aceitas";
var eSIMs$6 = "eSIMs";
var languages$6 = "idiomas";
var providers$6 = "fornecedores";
var HomePt = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 países, mais de 3500 aeroportos, mais de 3000 fornecedores, 17 idiomas, mais de 39 moedas aceitas.",
  "24/7 customer support": "Apoio ao cliente 24/7",
  "771 reviews": "",
  "API Integration": "Integração API",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Adicione Widgets de pesquisa ao seu site, permitindo aos visitantes pesquisar opções de transporte diretamente na sua página e redirecioná-los para Mozio.com para fazer a reserva.",
  "Airport Parking": "Estacionamento no aeroporto",
  "All transfers in one place": "Todos os transfers num só lugar",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Tem uma agência de viagens, um hotel, uma companhia aérea ou uma empresa de aluguer de automóveis e pretende expandir o seu alcance?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Tem uma agência de viagens, um hotel, uma companhia aérea ou uma empresa de aluguer de automóveis e pretende expandir o seu alcance?",
  "Are you a Travel Agent?": "É um agente de viagens?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "É um agente de viagens? Reserve translados em em nome dos seus clientes, sem problemas, com a nossa ferramenta de reservas para agentes de viagens.",
  "Are you a ground transportation Provider?": "É um fornecedor de translados?",
  "Are you planning a trip and need reliable transportation options?": "Está planejando uma viagem e precisa de opções de transporte viáveis?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Reserve sedans, SUVs, vans, ônibus privados e compartilhados, limusines, trems e até táxis aquáticos",
  "Book with Mozio": "Reserve com a Mozio",
  "Booking tool for Travel Agents": "Ferramenta de reserva para agentes de viagens",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Marcas como Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, e mais de 5.000 agentes de viagens confiam na Mozio para as suas necessidades de transporte terrestre.",
  Businesses: Businesses$7,
  "Discover our solutions": "Descubra as nossas soluções",
  "Do you manage travel arrangements for clients?": "Você gere a organização de viagens para os seus clientes?",
  "Do you offer ground transportation services and want to expand your reach?": "Oferece serviços de translados e pretende expandir o seu alcance?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Melhore a experiência do cliente integrando opções convenientes de reserva de transporte terrestre nos seus sistemas existentes.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Melhore a sua marca com a solução White Label da Mozio, oferecendo um fluxo de reserva de transporte totalmente personalizado que integra a sua marca - desde cores e logótipos a URLs - proporcionando aos seus clientes uma experiência uma experiência perfeita com o seu nome.",
  Expertise: Expertise$6,
  "Extensive network and reach": "Extensa rede e alcance",
  "Flight delayed? We wait.": "Vôo atrasado? Nós esperamos.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Vôo atrasado? Nós esperamos. Precisa de ajuda com a sua reserva? Receba assistência imediata com o nosso apoio 24 horas por dia, 7 dias por semana.",
  "Free cancellations within 24 hours": "Cancelamentos gratuitos num prazo de 24 horas",
  "Free online cancellations": "Cancelamentos online gratuitos",
  "Global coverage": "Cobertura global",
  "Innovative technology": "Tecnologia inovadora",
  "Instantly guaranteed booking": "Reserva garantida instantaneamente",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integre a poderosa API do Mozio nos seus sistemas existentes e permita que seus clientes reservem translados sem problemas.",
  "Integrate with Mozio": "Integrar com Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Junte-se à rede global da Mozio e conecte-se a milhões de Viajantes",
  "Learn more": "Saiba mais",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Aproveite da nossa experiência no setor, com mais de 12 anos de especialização em transporte terrestre",
  "Licensed partners": "Parceiros licenciados",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Faça a gestão de alterações facilmente com cancelamentos online gratuitos em 99% das reservas",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Ofereça aos seus clientes opções de estacionamento no aeroporto sem complicações, garantindo um início e um fim de viagem sem problemas",
  "Partner with Us": "Seja nosso parceiro",
  "Partner with us": "Seja nosso parceiro",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Proporcione aos seus clientes um acesso contínuo à Internet em todo o mundo com os eSIMs.",
  Provider: Provider$6,
  Providers: Providers$c,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Comece a reservar agora",
  "The largest Travel Businesses in the world trust Mozio": "As maiores empresas de viagens do mundo confiam na Mozio",
  Transparency: Transparency$6,
  "Travel Agency": "",
  "Travel Agent": "Agentes de viagens",
  "Travel Agent Booking Tool": "Ferramenta de reserva para agentes de viagens",
  "Travel Agents": "Agentes de viagens",
  Travelers: Travelers$c,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Utilize a nossa plataforma como um balcão único para todas as suas reservas de translados, desde transferes de aeroporto a táxis locais táxis locais, em todo o mundo.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Utilize a nossa tecnologia de ponta com funcionalidades avançadas avançadas e opções personalizáveis.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Temos parcerias com fornecedores de translados licenciados, garantindo fiabilidade em cada reserva.",
  "What we offer": "O que oferecemos",
  "White Label": "White Label",
  "Why choose Mozio": "Porquê escolher o Mozio",
  Widget: Widget$6,
  "World class customer service": "Serviço ao cliente de classe mundial",
  "Your go-to ground transportation platform": "A sua plataforma de transportes terrestres",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "A sua plataforma de transporte terrestre para viajantes, agentes de viagens, hotéis, companhias aéreas e muito mais.",
  airports: airports$6,
  cities: cities$6,
  countries: countries$6,
  currencies: currencies$6,
  eSIMs: eSIMs$6,
  "in New York City": "",
  languages: languages$6,
  providers: providers$6
};
var Blog$5 = "Блог";
var Careers$5 = "Карьера";
var Contact$5 = "Контакты";
var Coverage$5 = "Покрытие";
var Guides$5 = "Руководства";
var Imprint$5 = "Распечатать";
var Parking$5 = "Парковка";
var eSIM$5 = "eSIM";
var FooterRu = {
  Blog: Blog$5,
  Careers: Careers$5,
  Contact: Contact$5,
  Coverage: Coverage$5,
  Guides: Guides$5,
  Imprint: Imprint$5,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Товарные знаки и бренды являются собственностью их владельцев.",
  Parking: Parking$5,
  "Privacy policy": "Политика конфиденциальности",
  "Terms of service": "Условия использования",
  eSIM: eSIM$5
};
var About$5 = "О нас";
var Close$5 = "Закрыть";
var Help$5 = "Помощь";
var More$5 = "Более";
var OK$5 = "ОК";
var Providers$b = "Поставщики";
var Send$5 = "Отправить";
var Thanks$5 = "Спасибо";
var Travelers$b = "Путешественники";
var HeaderRu = {
  About: About$5,
  "An error occurred while sending the email.": "При отправке письма произошла ошибка.",
  "Business Partners": "Бизнес-партнеры",
  Close: Close$5,
  "Create Account": "Создать аккаунт",
  "Email address": "Адрес эл. почты",
  "Hello, {{name}}!": "Здравствуйте, {{name}} !",
  Help: Help$5,
  "If any reservations are found we'll send them to you.": "Спасибо! Мы будем отправлять вам найденные брони.",
  "Log out": "Выйти",
  More: More$5,
  "My account": "Мой счет",
  "My bookings": "Мои бронирования",
  OK: OK$5,
  Providers: Providers$b,
  "Resend Booking": "Отправить бронь снова",
  "Resend Confirmation Email": "Отправить письмо с подтверждением снова",
  Send: Send$5,
  "Sign In": "Войти",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Сообщите нам свой адрес электронной почты, и мы будем отправлять вам копии всех ваших заказов.",
  Thanks: Thanks$5,
  "Travel Agent": "Турагент",
  "Travel Agents": "Туристические агенты",
  Travelers: Travelers$b
};
var Businesses$6 = "Бизнес";
var Expertise$5 = "Экспертиза";
var Provider$5 = "Поставщики";
var Providers$a = "Поставщики";
var Transparency$5 = "Прозрачность";
var Travelers$a = "Путешественники";
var Widget$5 = "Виджет";
var airports$5 = "аэропортов";
var cities$5 = "городов";
var countries$5 = "стран";
var currencies$5 = "валют";
var eSIMs$5 = "eSIMs";
var languages$5 = "языков";
var providers$5 = "поставщиков";
var HomeRu = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 стран, более 3500 аэропортов, более 3000 поставщиков, 17 языков, более 39 валют.",
  "24/7 customer support": "Поддержка клиентов 24/7",
  "771 reviews": "",
  "API Integration": "API-интеграция",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Добавьте виджеты поиска на ваш веб-сайт, позволяя посетителям искать варианты транспорта прямо на вашей странице и перенаправляя их на Mozio.com для бронирования.",
  "Airport Parking": "Парковка в аэропорту",
  "All transfers in one place": "Все трансферы в одном месте",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Вы туристическое агентство, отель, авиакомпания или прокат автомобилей, желающие расширить охват?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Вы туристическое агентство, отель, авиакомпания или прокат автомобилей, желающие расширить охват?",
  "Are you a Travel Agent?": "Вы туристический агент?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Вы туристический агент? Бронируйте наземный транспорт от имени ваших клиентов без проблем с нашим инструментом бронирования для туристических агентов.",
  "Are you a ground transportation Provider?": "Вы поставщик наземного транспорта?",
  "Are you planning a trip and need reliable transportation options?": "Планируете поездку и вам нужны надежные варианты транспорта?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Бронируйте седаны, внедорожники, фургоны, частные и общие автобусы, лимузины, поезда и даже водные такси.",
  "Book with Mozio": "Забронируйте с Mozio",
  "Booking tool for Travel Agents": "Инструмент бронирования для туристических агентов",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Такие бренды, как Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor и более 5000 туристических агентов доверяют Mozio для нужд наземного транспорта.",
  Businesses: Businesses$6,
  "Discover our solutions": "Откройте для себя наши решения",
  "Do you manage travel arrangements for clients?": "Вы управляете организацией поездок для клиентов?",
  "Do you offer ground transportation services and want to expand your reach?": "Вы предоставляете услуги наземного транспорта и хотите расширить охват?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Улучшите впечатления клиентов, интегрировав удобные варианты бронирования наземного транспорта в свои существующие системы.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Улучшите ваш бренд с помощью решения White Label от Mozio, предлагая полностью настраиваемый процесс бронирования транспорта с интеграцией вашего брендинга — от цветов и логотипов до URL-адресов, предоставляя вашим клиентам безупречный опыт под вашим именем.",
  Expertise: Expertise$5,
  "Extensive network and reach": "Обширная сеть и охват",
  "Flight delayed? We wait.": "Рейс задержан? Мы подождем.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Рейс задержан? Мы подождем. Нужна помощь с бронированием? Получите мгновенную помощь с нашей поддержкой 24/7.",
  "Free cancellations within 24 hours": "Бесплатная отмена в течение 24 часов",
  "Free online cancellations": "Бесплатные онлайн-отмены",
  "Global coverage": "Глобальное покрытие",
  "Innovative technology": "Инновационные технологии",
  "Instantly guaranteed booking": "Гарантированное бронирование мгновенно",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Интегрируйте эффективний API Mozio в свои существующие системы и позвольте вашим клиентам бронировать трансферы без проблем.",
  "Integrate with Mozio": "Интегрируйтесь с Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Присоединяйтесь к глобальной сети Mozio и свяжитесь с миллионами путешественников.",
  "Learn more": "Узнать больше",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Используйте наш отраслевой опыт с более чем 12-летней специализацией в наземных перевозках.",
  "Licensed partners": "Лицензированные партнеры",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Легко управляйте изменениями с помощью бесплатных онлайн-отмен для 99% бронирований.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Предложите своим клиентам удобные варианты парковки в аэропорту, чтобы обеспечить их поездке плавное начало и окончание.",
  "Partner with Us": "Сотрудничайте с нами",
  "Partner with us": "Сотрудничайте с нами",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Обеспечьте своим клиентам бесперебойный доступ в интернет по всему миру с помощью eSIM.",
  Provider: Provider$5,
  Providers: Providers$a,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Начать бронирование сейчас",
  "The largest Travel Businesses in the world trust Mozio": "Крупнейшие туристические компании в мире доверяют Mozio",
  Transparency: Transparency$5,
  "Travel Agency": "",
  "Travel Agent": "Туристические агенты",
  "Travel Agent Booking Tool": "Инструмент бронирования для туристических агентов",
  "Travel Agents": "Туристические агенты",
  Travelers: Travelers$a,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Используйте нашу платформу как универсальное решение для всех ваших бронирований наземного транспорта, от трансферов из аэропорта до местных такси по всему миру.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Используйте наши передовые технологии с расширенными функциями и возможностями настройки.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Мы сотрудничаем с лицензированными поставщиками наземного транспорта, что гарантирует надежность каждого бронирования.",
  "What we offer": "Что мы предлагаем",
  "White Label": "White Label",
  "Why choose Mozio": "Почему выбрать Mozio",
  Widget: Widget$5,
  "World class customer service": "Обслуживание клиентов мирового уровня",
  "Your go-to ground transportation platform": "Ваша идеальная платформа для наземного транспорта",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Ваша идеальная платформа для наземного транспорта для путешественников, туристических агентов, отелей, авиакомпаний и других.",
  airports: airports$5,
  cities: cities$5,
  countries: countries$5,
  currencies: currencies$5,
  eSIMs: eSIMs$5,
  "in New York City": "",
  languages: languages$5,
  providers: providers$5
};
var Blog$4 = "Blogg";
var Careers$4 = "Karriärer";
var Contact$4 = "Kontakt";
var Coverage$4 = "Täckning";
var Guides$4 = "Guider";
var Imprint$4 = "Avtryck";
var Parking$4 = "Parkering";
var eSIM$4 = "eSIM";
var FooterSv = {
  Blog: Blog$4,
  Careers: Careers$4,
  Contact: Contact$4,
  Coverage: Coverage$4,
  Guides: Guides$4,
  Imprint: Imprint$4,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Varumärken och varumärken tillhör sina respektive ägare.",
  Parking: Parking$4,
  "Privacy policy": "Sekretesspolicy",
  "Terms of service": "Användarvillkor",
  eSIM: eSIM$4
};
var About$4 = "Om";
var Close$4 = "Nära";
var Help$4 = "Hjälp";
var More$4 = "Mer";
var OK$4 = "Okej";
var Providers$9 = "Leverantörer";
var Send$4 = "Skicka";
var Thanks$4 = "Tack";
var Travelers$9 = "Resenärer";
var HeaderSv = {
  About: About$4,
  "An error occurred while sending the email.": "Ett fel uppstod när e-postmeddelandet skickades.",
  "Business Partners": "Affärspartner",
  Close: Close$4,
  "Create Account": "Skapa konto",
  "Email address": "E-postadress",
  "Hello, {{name}}!": "Hej, {{name}} !",
  Help: Help$4,
  "If any reservations are found we'll send them to you.": "Tack, om några reservationer hittas skickar vi dem till dig.",
  "Log out": "Logga ut",
  More: More$4,
  "My account": "Mitt konto",
  "My bookings": "Mina bokningar",
  OK: OK$4,
  Providers: Providers$9,
  "Resend Booking": "Bokningsbekräftelse",
  "Resend Confirmation Email": "Skicka bekräftelsemeddelande igen",
  Send: Send$4,
  "Sign In": "Logga in",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Berätta din e-post så skickar vi kopior av alla dina kommande bokningar.",
  Thanks: Thanks$4,
  "Travel Agent": "Resebyrå",
  "Travel Agents": "Resebyråer",
  Travelers: Travelers$9
};
var Businesses$5 = "Företag";
var Expertise$4 = "Expertis";
var Provider$4 = "Leverantörer";
var Providers$8 = "Leverantörer";
var Transparency$4 = "Öppenhet";
var Travelers$8 = "Resenärer";
var Widget$4 = "Widget";
var airports$4 = "flygplatser";
var cities$4 = "städer";
var countries$4 = "länder";
var currencies$4 = "valutor";
var eSIMs$4 = "eSIMs";
var languages$4 = "språk";
var providers$4 = "leverantörer";
var HomeSv = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 länder, 3500+ flygplatser, 3000+ leverantörer, 17 språk, 39+ valutor.",
  "24/7 customer support": "Kundtjänst 24/7",
  "771 reviews": "",
  "API Integration": "API-integration",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Lägg till sökwidgets på din webbplats, så att besökarna kan söka efter transportalternativ direkt på din sida och omdirigeras till Mozio.com för bokning.",
  "Airport Parking": "Parkering vid flygplatsen",
  "All transfers in one place": "Alla överföringar på ett ställe",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Är du en resebyrå, ett hotell, ett flygbolag eller en biluthyrare som vill utöka din räckvidd?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Är du en resebyrå, ett hotell, ett flygbolag eller en biluthyrare som vill utöka din räckvidd?",
  "Are you a Travel Agent?": "Är du en resebyrå?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Är du en resebyrå? Boka marktransport på uppdrag av dina kunder sömlöst med vårt bokningsverktyg för resebyråer.",
  "Are you a ground transportation Provider?": "Är du en leverantör av marktransporter?",
  "Are you planning a trip and need reliable transportation options?": "Planerar du en resa och behöver pålitliga transportalternativ?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Boka sedaner, SUV:ar, skåpbilar, privata och delade bussar, limousiner, tåg och till och med vattentaxibilar.",
  "Book with Mozio": "Boka med Mozio",
  "Booking tool for Travel Agents": "Bokningsverktyg för resebyråer",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Varumärken som Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, och över 5.000 resebyråer litar på Mozio för sina marktransportbehov.",
  Businesses: Businesses$5,
  "Discover our solutions": "Upptäck våra lösningar",
  "Do you manage travel arrangements for clients?": "Sköter du researrangemang för kunder?",
  "Do you offer ground transportation services and want to expand your reach?": "Erbjuder du marktransporttjänster och vill utöka din räckvidd?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Förbättra kundupplevelsen genom att integrera praktiska bokningsalternativ för marktransporter i dina befintliga system.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Stärk ditt varumärke med Mozios White Label-lösning, som erbjuder ett helt anpassat bokningsflöde för transport som integrerar ditt varumärke - från färger och logotyper till webbadresser - och ger dina kunder den bästa upplevelse under ditt namn.",
  Expertise: Expertise$4,
  "Extensive network and reach": "Brett nätverk och stor räckvidd",
  "Flight delayed? We wait.": "Försenat flyg? Vi väntar.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Försenat flyg? Vi väntar. Behöver du hjälp med din bokning? Få omedelbar hjälp med vår support 24/7.",
  "Free cancellations within 24 hours": "Gratis avbokning inom 24 timmar",
  "Free online cancellations": "Gratis avbokningar online",
  "Global coverage": "Global täckning",
  "Innovative technology": "Innovativ teknik",
  "Instantly guaranteed booking": "Omedelbar garanterad bokning",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Integrera Mozios kraftfulla API i dina befintliga system och låt dina kunder boka överföringar på ett smidigt sätt.",
  "Integrate with Mozio": "Integrera med Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Gå med i Mozios globala nätverk och få kontakt med miljontals resenärer.",
  "Learn more": "Läs mer ",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Dra nytta av vår branschexpertis med över 12 års specialisering inom marktransporter.",
  "Licensed partners": "Licensierade partners",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Hantera ändringar enkelt med gratis avbokningar online för 99 % av bokningarna.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Erbjud dina kunder problemfria alternativ för flygplatsparkering, så att de får en smidig start och ett smidigt slut på sin resa.",
  "Partner with Us": "Samarbeta med oss",
  "Partner with us": "Bli vår partner",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Ge dina kunder sömlös tillgång till internet över hela världen med eSIM.",
  Provider: Provider$4,
  Providers: Providers$8,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Börja boka nu",
  "The largest Travel Businesses in the world trust Mozio": "De största resebyråerna i världen litar på Mozio",
  Transparency: Transparency$4,
  "Travel Agency": "",
  "Travel Agent": "Resebyråer",
  "Travel Agent Booking Tool": "Reseagentens bokningsverktyg",
  "Travel Agents": "Resebyråer",
  Travelers: Travelers$8,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Använd vår plattform som en one-stop-shop för alla dina bokningar av marktransporter, från flygplatstransfer till lokala taxibilar, över hela världen.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Utnyttja vår banbrytande teknik med avancerade funktioner och anpassningsbara alternativ.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Vi samarbetar med licensierade leverantörer av marktransporter, vilket garanterar tillförlitlighet i varje bokning.",
  "What we offer": "Vad vi erbjuder",
  "White Label": "White Label",
  "Why choose Mozio": "Varför välja Mozio",
  Widget: Widget$4,
  "World class customer service": "Kundservice i världsklass",
  "Your go-to ground transportation platform": "Din plattform för marktransporter",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Din go-to plattform för marktransport för resenärer, resebyråer, hotell, flygbolag och mer.",
  airports: airports$4,
  cities: cities$4,
  countries: countries$4,
  currencies: currencies$4,
  eSIMs: eSIMs$4,
  "in New York City": "",
  languages: languages$4,
  providers: providers$4
};
var Blog$3 = "บล็อก";
var Careers$3 = "Карьера";
var Contact$3 = "Контакты";
var Coverage$3 = "Покрытие";
var Guides$3 = "Руководства";
var Imprint$3 = "Импрессум";
var Parking$3 = "Парковка";
var eSIM$3 = "eSIM";
var FooterTh = {
  Blog: Blog$3,
  Careers: Careers$3,
  Contact: Contact$3,
  Coverage: Coverage$3,
  Guides: Guides$3,
  Imprint: Imprint$3,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. Товарные знаки и бренды являются собственностью их владельцев.",
  Parking: Parking$3,
  "Privacy policy": "Политика конфиденциальности",
  "Terms of service": "Условия использования",
  eSIM: eSIM$3
};
var About$3 = "О компании";
var Close$3 = "ปิด";
var Help$3 = "Помощь";
var More$3 = "มากกว่า";
var OK$3 = "ตกลง";
var Providers$7 = "Поставщики";
var Send$3 = "ส่ง";
var Thanks$3 = "ขอบคุณ";
var Travelers$7 = "Путешественники";
var HeaderTh = {
  About: About$3,
  "An error occurred while sending the email.": "เกิดข้อผิดพลาดขณะส่งอีเมล",
  "Business Partners": "Бизнес-партнеры",
  Close: Close$3,
  "Create Account": "สร้างบัญชี",
  "Email address": "ที่อยู่อีเมล",
  "Hello, {{name}}!": "สวัสดี {{name}} !",
  Help: Help$3,
  "If any reservations are found we'll send them to you.": "ขอบคุณ หากเราพบการจองใด ๆ เราจะส่งให้คุณ",
  "Log out": "ออกจากระบบ",
  More: More$3,
  "My account": "บัญชีของฉัน",
  "My bookings": "การจองของฉัน",
  OK: OK$3,
  Providers: Providers$7,
  "Resend Booking": "ส่งการจองอีกครั้ง",
  "Resend Confirmation Email": "ส่งอีเมลยืนยันอีกครั้ง",
  Send: Send$3,
  "Sign In": "ลงชื่อเช้าใช้",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "บอกอีเมลของคุณกับเราแล้วเราจะส่งสำเนาของการจองที่กำลังจะมาถึงทั้งหมดของคุณให้",
  Thanks: Thanks$3,
  "Travel Agent": "ตัวแทนนำเที่ยว",
  "Travel Agents": "Туристические агенты",
  Travelers: Travelers$7
};
var Businesses$4 = "Бизнес";
var Expertise$3 = "Экспертиза";
var Provider$3 = "Поставщики";
var Providers$6 = "Поставщики";
var Transparency$3 = "Прозрачность";
var Travelers$6 = "Путешественники";
var Widget$3 = "Виджет";
var airports$3 = "аэропортов";
var cities$3 = "городов";
var countries$3 = "стран";
var currencies$3 = "валют";
var eSIMs$3 = "eSIMs";
var languages$3 = "языков";
var providers$3 = "поставщиков";
var HomeTh = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 стран, более 3500 аэропортов, более 3000 поставщиков, 17 языков, более 39 валют.",
  "24/7 customer support": "Поддержка клиентов 24/7",
  "771 reviews": "",
  "API Integration": "API-интеграция",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Добавьте виджеты поиска на ваш веб-сайт, позволяя посетителям искать варианты транспорта прямо на вашей странице и перенаправляя их на Mozio.com для бронирования.",
  "Airport Parking": "Парковка в аэропорту",
  "All transfers in one place": "Все трансферы в одном месте",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Вы туристическое агентство, отель, авиакомпания или прокат автомобилей, желающие расширить охват?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Вы туристическое агентство, отель, авиакомпания или прокат автомобилей, желающие расширить охват?",
  "Are you a Travel Agent?": "Вы туристический агент?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Вы туристический агент? Бронируйте наземный транспорт от имени ваших клиентов без проблем с нашим инструментом бронирования для туристических агентов.",
  "Are you a ground transportation Provider?": "Вы поставщик наземного транспорта?",
  "Are you planning a trip and need reliable transportation options?": "Планируете поездку и вам нужны надежные варианты транспорта?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Бронируйте седаны, внедорожники, фургоны, частные и общие автобусы, лимузины, поезда и даже водные такси.",
  "Book with Mozio": "Забронируйте с Mozio",
  "Booking tool for Travel Agents": "Инструмент бронирования для туристических агентов",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Такие бренды, как Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor и более 5000 туристических агентов доверяют Mozio для нужд наземного транспорта.",
  Businesses: Businesses$4,
  "Discover our solutions": "Откройте для себя наши решения",
  "Do you manage travel arrangements for clients?": "Вы управляете организацией поездок для клиентов?",
  "Do you offer ground transportation services and want to expand your reach?": "Вы предоставляете услуги наземного транспорта и хотите расширить охват?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Улучшите впечатления клиентов, интегрировав удобные варианты бронирования наземного транспорта в свои существующие системы.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Улучшите ваш бренд с помощью решения White Label от Mozio, предлагая полностью настраиваемый процесс бронирования транспорта с интеграцией вашего брендинга — от цветов и логотипов до URL-адресов, предоставляя вашим клиентам бесшовный опыт под вашим именем.",
  Expertise: Expertise$3,
  "Extensive network and reach": "Обширная сеть и охват",
  "Flight delayed? We wait.": "Рейс задержан? Мы подождем.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Рейс задержан? Мы подождем. Нужна помощь с бронированием? Получите мгновенную помощь с нашей поддержкой 24/7.",
  "Free cancellations within 24 hours": "Бесплатная отмена в течение 24 часов",
  "Free online cancellations": "Бесплатные онлайн-отмены",
  "Global coverage": "Глобальное покрытие",
  "Innovative technology": "Инновационные технологии",
  "Instantly guaranteed booking": "Гарантированное бронирование мгновенно",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Интегрируйте мощный API Mozio в свои существующие системы и позвольте вашим клиентам бронировать трансферы без проблем.",
  "Integrate with Mozio": "Интегрируйтесь с Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Присоединяйтесь к глобальной сети Mozio и свяжитесь с миллионами путешественников.",
  "Learn more": "Узнать больше",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Используйте наш отраслевой опыт с более чем 12-летней специализацией в наземных перевозках.",
  "Licensed partners": "Лицензированные партнеры",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Легко управляйте изменениями с помощью бесплатных онлайн-отмен для 99% бронирований.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Предложите своим клиентам удобные варианты парковки в аэропорту, чтобы обеспечить их поездке плавное начало и окончание.",
  "Partner with Us": "Сотрудничайте с нами",
  "Partner with us": "Сотрудничайте с нами",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Обеспечьте своим клиентам бесперебойный доступ в интернет по всему миру с помощью eSIM.",
  Provider: Provider$3,
  Providers: Providers$6,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Начать бронирование сейчас",
  "The largest Travel Businesses in the world trust Mozio": "Крупнейшие туристические компании в мире доверяют Mozio",
  Transparency: Transparency$3,
  "Travel Agency": "",
  "Travel Agent": "Туристические агенты",
  "Travel Agent Booking Tool": "Инструмент бронирования для туристических агентов",
  "Travel Agents": "Туристические агенты",
  Travelers: Travelers$6,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Используйте нашу платформу как универсальное решение для всех ваших бронирований наземного транспорта, от трансферов из аэропорта до местных такси по всему миру.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Используйте наши передовые технологии с расширенными функциями и возможностями настройки.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Мы сотрудничаем с лицензированными поставщиками наземного транспорта, что гарантирует надежность каждого бронирования.",
  "What we offer": "Что мы предлагаем",
  "White Label": "White Label",
  "Why choose Mozio": "Почему выбрать Mozio",
  Widget: Widget$3,
  "World class customer service": "Обслуживание клиентов мирового уровня",
  "Your go-to ground transportation platform": "Ваша основная платформа для наземного транспорта",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Ваша основная платформа для наземного транспорта для путешественников, туристических агентов, отелей, авиакомпаний и других.",
  airports: airports$3,
  cities: cities$3,
  countries: countries$3,
  currencies: currencies$3,
  eSIMs: eSIMs$3,
  "in New York City": "",
  languages: languages$3,
  providers: providers$3
};
var Blog$2 = "Blog";
var Careers$2 = "Nghề nghiệp";
var Contact$2 = "Liên hệ";
var Coverage$2 = "Phủ sóng";
var Guides$2 = "Hướng dẫn";
var Imprint$2 = "Dấu ấn";
var Parking$2 = "Đậu xe";
var eSIM$2 = "eSIM";
var FooterVi = {
  Blog: Blog$2,
  Careers: Careers$2,
  Contact: Contact$2,
  Coverage: Coverage$2,
  Guides: Guides$2,
  Imprint: Imprint$2,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": " Thương hiệu của Mozio Inc. là tài sản của chủ sở hữu tương ứng.",
  Parking: Parking$2,
  "Privacy policy": "Chính sách bảo mật",
  "Terms of service": "Điều khoản dịch vụ",
  eSIM: eSIM$2
};
var About$2 = "Về chúng tôi";
var Close$2 = "Đóng";
var Help$2 = "Giúp đỡ";
var More$2 = "Hơn";
var OK$2 = "Ok";
var Providers$5 = "Nhà cung cấp";
var Send$2 = "Gửi";
var Thanks$2 = "Cảm ơn";
var Travelers$5 = "Du khách";
var HeaderVi = {
  About: About$2,
  "An error occurred while sending the email.": "Có lỗi xảy ra trong khi gửi email.",
  "Business Partners": "Đối tác kinh doanh",
  Close: Close$2,
  "Create Account": "Tạo tài khoản",
  "Email address": "Địa chỉ email",
  "Hello, {{name}}!": "Xin chào, {{name}} !",
  Help: Help$2,
  "If any reservations are found we'll send them to you.": "Cảm ơn, nếu có đặt chỗ phù hợp chúng tôi sẽ gửi cho bạn.",
  "Log out": "Đăng xuất",
  More: More$2,
  "My account": "Tài khoản của tôi",
  "My bookings": "Đặt chỗ của tôi",
  OK: OK$2,
  Providers: Providers$5,
  "Resend Booking": "Gửi lại đặt chỗ",
  "Resend Confirmation Email": "Gửi lại email xác nhận",
  Send: Send$2,
  "Sign In": "Đăng nhập",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "Cho chúng tôi biết email của bạn và chúng tôi sẽ gửi bản sao toàn bộ lượt đặt chỗ sắp tới của bạn.",
  Thanks: Thanks$2,
  "Travel Agent": "Đại lý du lịch",
  "Travel Agents": "Đại lý du lịch",
  Travelers: Travelers$5
};
var Businesses$3 = "Doanh nghiệp";
var Expertise$2 = "Chuyên môn";
var Provider$2 = "Nhà cung cấp";
var Providers$4 = "Nhà cung cấp";
var Transparency$2 = "Minh bạch";
var Travelers$4 = "Du khách";
var Widget$2 = "Tiện ích";
var airports$2 = "sân bay";
var cities$2 = "thành phố";
var countries$2 = "quốc gia";
var currencies$2 = "loại tiền tệ";
var eSIMs$2 = "eSIMs";
var languages$2 = "ngôn ngữ";
var providers$2 = "nhà cung cấp";
var HomeVi = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 quốc gia, hơn 3500 sân bay, hơn 3000 nhà cung cấp, 17 ngôn ngữ, hơn 39 loại tiền tệ.",
  "24/7 customer support": "Hỗ trợ khách hàng 24/7",
  "771 reviews": "",
  "API Integration": "Tích hợp API",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "Thêm Widget tìm kiếm vào trang web của bạn, cho phép khách truy cập tìm kiếm các tùy chọn phương tiện di chuyển trực tiếp trên trang của bạn và chuyển hướng họ đến Mozio.com để đặt chỗ.",
  "Airport Parking": "Bãi đậu xe sân bay",
  "All transfers in one place": "Tất cả chuyến đi ở một nơi",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "Bạn là Đại lý du lịch, Khách sạn, Hãng hàng không hoặc Cho thuê ô tô muốn mở rộng phạm vi tiếp cận của mình?",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "Bạn là Đại lý du lịch, Khách sạn, Hãng hàng không hoặc Cho thuê ô tô muốn mở rộng phạm vi tiếp cận của mình?",
  "Are you a Travel Agent?": "Bạn có phải là đại lý du lịch?",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "Bạn có phải là đại lý du lịch? Đặt vé vận chuyển mặt đất thay mặt cho khách hàng của bạn một cách liền mạch bằng Công cụ đặt chỗ đại lý du lịch của chúng tôi.",
  "Are you a ground transportation Provider?": "Bạn có phải là nhà cung cấp dịch vụ vận tải mặt đất?",
  "Are you planning a trip and need reliable transportation options?": "Bạn đang lên kế hoạch cho một chuyến đi và cần các phương tiện di chuyển đáng tin cậy?",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "Đặt xe sedan, SUV, xe tải, xe buýt riêng và chung, xe limo, xe lửa và thậm chí cả taxi nước.",
  "Book with Mozio": "Đặt chỗ với Mozio",
  "Booking tool for Travel Agents": "Công cụ đặt chỗ dành cho đại lý du lịch",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Các thương hiệu như Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, và hơn 5.000 đại lý du lịch tin tưởng Mozio cho nhu cầu vận chuyển mặt đất của họ.",
  Businesses: Businesses$3,
  "Discover our solutions": "Khám phá các giải pháp của chúng tôi",
  "Do you manage travel arrangements for clients?": "Bạn có quản lý việc sắp xếp chuyến đi cho khách hàng không?",
  "Do you offer ground transportation services and want to expand your reach?": "Bạn có cung cấp dịch vụ vận chuyển mặt đất và muốn mở rộng phạm vi tiếp cận của mình không?",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "Nâng cao trải nghiệm của khách hàng bằng cách tích hợp các tùy chọn đặt chỗ vận chuyển mặt đất thuận tiện vào hệ thống hiện có của bạn.",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "Nâng cao thương hiệu của bạn bằng giải pháp White Label của Mozio, cung cấp quy trình đặt chỗ vận chuyển được tùy chỉnh hoàn toàn tích hợp thương hiệu của bạn—từ màu sắc và biểu tượng đến URL—cung cấp cho khách hàng trải nghiệm liền mạch dưới tên của bạn.",
  Expertise: Expertise$2,
  "Extensive network and reach": "Mạng lưới và phạm vi tiếp cận rộng khắp",
  "Flight delayed? We wait.": "Chuyến bay bị trì hoãn? Chúng tôi chờ đợi.",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "Chuyến bay bị trì hoãn? Chúng tôi chờ đợi. Cần trợ giúp về việc đặt chỗ của bạn? Nhận hỗ trợ ngay lập tức với sự hỗ trợ 24/7 của chúng tôi.",
  "Free cancellations within 24 hours": "Hủy miễn phí trong vòng 24 giờ",
  "Free online cancellations": "Hủy trực tuyến miễn phí",
  "Global coverage": "Phủ sóng toàn cầu",
  "Innovative technology": "Công nghệ đổi mới",
  "Instantly guaranteed booking": "Đặt chỗ được xác nhận ngay lập tức",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "Tích hợp API mạnh mẽ của Mozio vào các hệ thống hiện có của bạn và cho phép khách hàng của bạn đặt chỗ một cách liền mạch.",
  "Integrate with Mozio": "Интегрируйтесь с Mozio",
  "Join Mozio's global network and connect with millions of Travelers. ": "Tham gia mạng lưới toàn cầu của Mozio và kết nối với hàng triệu Khách du lịch.",
  "Learn more": "Tìm hiểu thêm",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "Tận dụng kiến ​​thức chuyên môn trong ngành của chúng tôi với hơn 12 năm chuyên môn về vận tải mặt đất.",
  "Licensed partners": "Đối tác được cấp phép",
  "Manage changes easily with free online cancellations on 99% of bookings.": "Quản lý các thay đổi dễ dàng với tính năng hủy trực tuyến miễn phí trên 99% số lượt đặt chỗ.",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "Cung cấp cho khách hàng của bạn các lựa chọn Đỗ xe sân bay thuận tiện, đảm bảo hành trình của họ khởi đầu và kết thúc suôn sẻ.",
  "Partner with Us": "Hợp tác với chúng tôi",
  "Partner with us": "Hợp tác với chúng tôi",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "Cung cấp cho khách hàng của bạn khả năng truy cập Internet liền mạch trên toàn thế giới với eSIM.",
  Provider: Provider$2,
  Providers: Providers$4,
  "Rating: 4.75 / 5": "",
  "Start booking now": "Bắt đầu đặt chỗ ngay bây giờ",
  "The largest Travel Businesses in the world trust Mozio": "Các doanh nghiệp du lịch lớn nhất thế giới tin tưởng Mozio",
  Transparency: Transparency$2,
  "Travel Agency": "",
  "Travel Agent": "Đại lý du lịch",
  "Travel Agent Booking Tool": "Công cụ đặt chỗ đại lý du lịch",
  "Travel Agents": "Đại lý du lịch",
  Travelers: Travelers$4,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "Sử dụng nền tảng của chúng tôi như một điểm dừng duy nhất cho tất cả các yêu cầu đặt dịch vụ vận chuyển mặt đất của bạn, từ vận chuyển sân bay đến taxi địa phương trên toàn cầu.",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "Sử dụng công nghệ tiên tiến của chúng tôi với các tính năng nâng cao và các tùy chọn có thể tùy chỉnh.",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "Chúng tôi hợp tác với các Nhà cung cấp dịch vụ vận tải mặt đất được cấp phép, đảm bảo độ tin cậy trong mỗi lần đặt chỗ.",
  "What we offer": "Những gì chúng tôi cung cấp",
  "White Label": "White Label",
  "Why choose Mozio": "Tại sao chọn Mozio",
  Widget: Widget$2,
  "World class customer service": "Dịch vụ khách hàng đẳng cấp thế giới",
  "Your go-to ground transportation platform": "Nền tảng vận chuyển mặt đất của bạn",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "Nền tảng vận chuyển mặt đất dành cho Khách du lịch, Đại lý du lịch, Khách sạn, Hãng hàng không, v.v.",
  airports: airports$2,
  cities: cities$2,
  countries: countries$2,
  currencies: currencies$2,
  eSIMs: eSIMs$2,
  "in New York City": "",
  languages: languages$2,
  providers: providers$2
};
var Blog$1 = "博客";
var Careers$1 = "工作机会";
var Contact$1 = "联系我们";
var Coverage$1 = "覆盖地区";
var Guides$1 = "指南";
var Imprint$1 = "版本说明";
var Parking$1 = "停车场";
var eSIM$1 = "eSIM";
var FooterZh = {
  Blog: Blog$1,
  Careers: Careers$1,
  Contact: Contact$1,
  Coverage: Coverage$1,
  Guides: Guides$1,
  Imprint: Imprint$1,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. 商标和品牌为其各自所有者的财产。",
  Parking: Parking$1,
  "Privacy policy": "隐私政策",
  "Terms of service": "服务条款",
  eSIM: eSIM$1
};
var About$1 = "关于我们";
var Close$1 = "关闭";
var Help$1 = "帮助";
var More$1 = "更多信息";
var OK$1 = "好";
var Providers$3 = "供应商";
var Send$1 = "发送";
var Thanks$1 = "谢谢";
var Travelers$3 = "旅行者";
var HeaderZh = {
  About: About$1,
  "An error occurred while sending the email.": "发送电子邮件时出现错误。",
  "Business Partners": "商业合作伙伴",
  Close: Close$1,
  "Create Account": "创建帐户",
  "Email address": "电子邮件地址",
  "Hello, {{name}}!": "你好， {{name}} ！",
  Help: Help$1,
  "If any reservations are found we'll send them to you.": "谢谢，如果发现任何预订，我们会将其发送给您。",
  "Log out": "退出登录",
  More: More$1,
  "My account": "我的账户",
  "My bookings": "我的预订",
  OK: OK$1,
  Providers: Providers$3,
  "Resend Booking": "重新发送预订",
  "Resend Confirmation Email": "重新发送确认电子邮件",
  Send: Send$1,
  "Sign In": "登录",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "告诉我们您的电子邮件，我们将向您发送所有即将到来的预订的副本。",
  Thanks: Thanks$1,
  "Travel Agent": "旅行社",
  "Travel Agents": "旅行社",
  Travelers: Travelers$3
};
var Businesses$2 = "商业机构";
var Expertise$1 = "专业知识";
var Provider$1 = "供应商";
var Providers$2 = "供应商";
var Transparency$1 = "透明性";
var Travelers$2 = "旅行者";
var Widget$1 = "小工具";
var airports$1 = "多个机场";
var cities$1 = "多个城市";
var countries$1 = "多个国家";
var currencies$1 = "种货币";
var eSIMs$1 = "eSIMs";
var languages$1 = "种语言";
var providers$1 = "多家供应商";
var HomeZh = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180 个国家，3500 多个机场，3000 多家供应商，17 种语言，39 多种货币。",
  "24/7 customer support": "24/7 全天候客户支持",
  "771 reviews": "",
  "API Integration": "API 集成",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "在您的网站上添加搜索小部件，允许访客直接在您的页面上搜索交通选项，并跳转到 mozio.com 进行预订。",
  "Airport Parking": "机场停车",
  "All transfers in one place": "所有接送服务一站搞定",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "您是想扩大业务范围的旅行社、酒店、航空公司或租车公司吗？",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "您是想扩大业务范围的旅行社、酒店、航空公司或租车公司吗？",
  "Are you a Travel Agent?": "您是旅行代理吗？",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "您是旅行社吗？使用我们的旅行社预订工具，为您的客户无缝预订地面交通服务。",
  "Are you a ground transportation Provider?": "您是地面交通供应商吗？",
  "Are you planning a trip and need reliable transportation options?": "您正在计划旅行并需要可靠的交通选择吗？",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "预订轿车、SUV、面包车、私家车和共享巴士、豪华轿车、火车，甚至水上出租车。",
  "Book with Mozio": "通过 Mozio 预订",
  "Booking tool for Travel Agents": "旅行社预订工具",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "像Hertz、法国航空、途易、Priceline、捷蓝航空、booking.com、CruisePlanners、雅高酒店这样的品牌",
  Businesses: Businesses$2,
  "Discover our solutions": "了解我们的解决方案",
  "Do you manage travel arrangements for clients?": "您是为客户安排旅行吗？",
  "Do you offer ground transportation services and want to expand your reach?": "您提供地面交通服务，并想要扩大业务范围吗？",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "通过集成便捷的地面交通预订选项，提升客户体验。",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "通过 Mozio 的白标解决方案提升您的品牌，提供完全自定义的交通预订流程，集成您的品牌元素——从颜色、标志到网址——为您的客户提供无缝的专属体验。",
  Expertise: Expertise$1,
  "Extensive network and reach": "广泛的网络和覆盖范围",
  "Flight delayed? We wait.": "航班延误？我们等候您。",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "航班延误？我们等您。预订有问题？我们的 24/7 支持为您提供即时帮助。",
  "Free cancellations within 24 hours": "24 小时内免费取消预订",
  "Free online cancellations": "免费在线取消",
  "Global coverage": "全球覆盖",
  "Innovative technology": "创新技术",
  "Instantly guaranteed booking": "即时预订保障",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "将 Mozio 强大的 API 集成到您的现有系统中，让您的客户能够无缝预订接送服务。",
  "Integrate with Mozio": "与 Mozio 整合",
  "Join Mozio's global network and connect with millions of Travelers. ": "加入 Mozio 的全球网络，连接数百万旅行者。",
  "Learn more": "了解更多",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "凭借 12 年以上地面交通领域的专业经验，充分利用我们的行业专长。",
  "Licensed partners": "持牌合作伙伴",
  "Manage changes easily with free online cancellations on 99% of bookings.": "99% 的预订可免费在线取消，轻松管理变更。",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "为您的客户提供无忧的机场停车选项，确保他们旅程的顺利开始和结束。",
  "Partner with Us": "与我们合作",
  "Partner with us": "与我们合作",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "为您的客户提供全球无缝互联网接入，使用 eSIM。",
  Provider: Provider$1,
  Providers: Providers$2,
  "Rating: 4.75 / 5": "",
  "Start booking now": "立即开始预订",
  "The largest Travel Businesses in the world trust Mozio": "全球最大的旅游企业信赖 Mozio",
  Transparency: Transparency$1,
  "Travel Agency": "",
  "Travel Agent": "旅行社",
  "Travel Agent Booking Tool": "旅行社预订工具",
  "Travel Agents": "旅行代理",
  Travelers: Travelers$2,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "使用我们的平台作为一站式服务，预订全球范围内的地面交通，从机场接送到本地出租车，应有尽有",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "利用我们先进的技术，提供定制化选项和高级功能。",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "我们与获得许可的地面运输供应商合作，确保每次预订的可靠性。",
  "What we offer": "我们提供",
  "White Label": "白标",
  "Why choose Mozio": "为什么选择 Mozio",
  Widget: Widget$1,
  "World class customer service": "世界一流的客户服务",
  "Your go-to ground transportation platform": "您值得信赖的地面交通平台",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "您值得信赖的地面交通平台，服务于旅行者、旅行社、酒店、航空公司等。",
  airports: airports$1,
  cities: cities$1,
  countries: countries$1,
  currencies: currencies$1,
  eSIMs: eSIMs$1,
  "in New York City": "",
  languages: languages$1,
  providers: providers$1
};
var Blog = "部落格";
var Careers = "職業";
var Contact = "聯繫我們";
var Coverage = "覆蓋範圍";
var Guides = "指南";
var Imprint = "版權聲明";
var Parking = "停車";
var eSIM = "eSIM";
var FooterZhTw = {
  Blog: Blog,
  Careers: Careers,
  Contact: Contact,
  Coverage: Coverage,
  Guides: Guides,
  Imprint: Imprint,
  "Mozio Inc. Trademarks and brands are property of their respective owners.": "Mozio Inc. 商標和品牌均屬於其各自所有者的財產",
  Parking: Parking,
  "Privacy policy": "隱私政策",
  "Terms of service": "服務條款",
  eSIM: eSIM
};
var About = "關於";
var Close = "關閉 ";
var Help = "幫助";
var More = "更多的";
var OK = "好";
var Providers$1 = "供應商";
var Send = "發送";
var Thanks = "謝謝";
var Travelers$1 = "旅行者";
var HeaderZhTw = {
  About: About,
  "An error occurred while sending the email.": "發送電子郵件時發生錯誤。",
  "Business Partners": "商業夥伴",
  Close: Close,
  "Create Account": "創建帳戶",
  "Email address": "電子郵件地址",
  "Hello, {{name}}!": "你好， {{name}} ！",
  Help: Help,
  "If any reservations are found we'll send them to you.": "謝謝，如果發現任何預訂，我們會將其發送給您。",
  "Log out": "登出",
  More: More,
  "My account": "我的帳戶",
  "My bookings": "我的預訂",
  OK: OK,
  Providers: Providers$1,
  "Resend Booking": "重發預訂",
  "Resend Confirmation Email": "重發確認電子郵件",
  Send: Send,
  "Sign In": "登錄",
  "Tell us your email and we'll send you copies of all your upcoming bookings.": "告訴我們您的電子郵件，我們將向您發送所有即將到來的預訂的副本。",
  Thanks: Thanks,
  "Travel Agent": "旅行社",
  "Travel Agents": "旅行代理商",
  Travelers: Travelers$1
};
var Businesses$1 = "企業";
var Expertise = "專業知識";
var Provider = "供應商";
var Providers = "供應商";
var Transparency = "透明度";
var Travelers = "旅客";
var Widget = "小工具";
var airports = "多個機場";
var cities = "多個城市";
var countries = "多個國家";
var currencies = "多種貨幣";
var eSIMs = "eSIMs";
var languages = "種語言";
var providers = "多個供應商";
var HomeZhTw = {
  "#28 of 254 Transportation": "",
  "180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.": "180個國家、3500多個機場、3000多個供應商、17種語言、39多種貨幣。",
  "24/7 customer support": "24/7 客戶支援",
  "771 reviews": "",
  "API Integration": "API整合",
  "Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking.": "將搜索小工具添加到您的網站，使訪問者能夠直接在您的頁面上搜索交通選項，並將他們重定向到Mozio.com進行預訂。",
  "Airport Parking": "機場停車",
  "All transfers in one place": "所有接送服務一站式完成",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?": "您是旅行社、飯店、航空公司或租車公司，想要擴大您的影響力嗎？",
  "Are you a Travel Agency, Hotel, Airline, or Car Rental?": "您是旅行社、飯店、航空公司或租車公司，想要擴大您的影響力嗎？",
  "Are you a Travel Agent?": "您是旅行代理商嗎？",
  "Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool.": "您是旅行代理商嗎？使用我們的旅行代理預訂工具，為您的客戶無縫預訂地面交通服務。",
  "Are you a ground transportation Provider?": "您是地面交通服務供應商嗎？",
  "Are you planning a trip and need reliable transportation options?": "您是否正在計劃旅行並需要可靠的交通選擇？",
  "Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.": "預訂轎車、SUV、貨車、私人和共享巴士、豪華轎車、火車，甚至水上計程車。",
  "Book with Mozio": "與Mozio預訂",
  "Booking tool for Travel Agents": "旅行代理商預訂工具",
  "Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.": "Hertz、法國航空、TUI、Priceline、JetBlue、Booking.com、CruisePlanners、Accor等品牌超以及超過5,000家旅行代理商信賴Mozio來滿足他們的地面交通需求。",
  Businesses: Businesses$1,
  "Discover our solutions": "探索我們的解決方案",
  "Do you manage travel arrangements for clients?": "您是否為客戶管理旅行安排？",
  "Do you offer ground transportation services and want to expand your reach?": "您是否提供地面交通服務，並希望擴大您的影響力？",
  "Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.": "通過將便捷的地面交通預訂選項整合到現有系統中，提高客戶體驗。",
  "Enhance your brand with Mozio’s White Label solution, offering a fully customized transportation booking flow that integrates your branding—from colors and logos to URLs—providing your clients with a seamless experience under your name.": "使用Mozio的白標解決方案提升您的品牌形象，提供完全客製化的交通預訂流程，集合您的品牌元素從顏色、標誌到網址，為您的客戶提供無縫的體驗。",
  Expertise: Expertise,
  "Extensive network and reach": "廣泛的網絡和覆蓋",
  "Flight delayed? We wait.": "航班延誤？我們等待。",
  "Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.": "航班延誤？我們等您。需要預訂協助？我們的24/7支援會立即幫助您。",
  "Free cancellations within 24 hours": "24小時內免費取消",
  "Free online cancellations": "免費在線取消",
  "Global coverage": "全球覆蓋",
  "Innovative technology": "創新技術",
  "Instantly guaranteed booking": "即時保證預訂",
  "Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly.": "將Mozio強大的API整合到您的現有系統中，讓您的客戶無縫預訂接送服務。",
  "Integrate with Mozio": "與Mozio整合",
  "Join Mozio's global network and connect with millions of Travelers. ": "加入Mozio的全球網絡，與數百萬旅行者建立聯繫。",
  "Learn more": "瞭解更多",
  "Leverage our industry expertise with over 12 years of specialization in ground transportation.": "利用我們在地面交通領域12年以上的專業經驗。",
  "Licensed partners": "授權合作夥伴",
  "Manage changes easily with free online cancellations on 99% of bookings.": "輕鬆管理變更，99%的預訂可享受免費在線取消。",
  "Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ": "為您的客戶提供無憂的機場停車選擇，確保他們的旅程順利開始和結束。",
  "Partner with Us": "與我們合作",
  "Partner with us": "與我們合作",
  "Provide your clients with seamless internet access worldwide with eSIMs. ": "使用eSIM為您的客戶提供全球無縫的網絡連接。",
  Provider: Provider,
  Providers: Providers,
  "Rating: 4.75 / 5": "",
  "Start booking now": "現在開始預訂",
  "The largest Travel Businesses in the world trust Mozio": "全球最大的旅行公司信賴Mozio",
  Transparency: Transparency,
  "Travel Agency": "",
  "Travel Agent": "旅行代理商",
  "Travel Agent Booking Tool": "旅行代理商預訂工具",
  "Travel Agents": "旅行代理商",
  Travelers: Travelers,
  "Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.": "使用我們的平台作為您地面交通預訂的一站式服務，從機場接送到本地計程車，遍及全球。",
  "Utilize our cutting-edge technology with advanced features and customizable options.": "利用我們的尖端技術，提供先進的功能和可客製化的選項。",
  "We partner with licensed ground transportation Providers, ensuring reliability in every booking.": "我們與持牌的地面交通供應商合作，確保每次預訂的可靠性。",
  "What we offer": "我們的服務",
  "White Label": "白標",
  "Why choose Mozio": "為何選擇Mozio",
  Widget: Widget,
  "World class customer service": "世界級客戶服務",
  "Your go-to ground transportation platform": "您的首選地面交通平台",
  "Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.": "您的首選地面交通平台，適用於旅客、旅行代理商、飯店、航空公司等。",
  airports: airports,
  cities: cities,
  countries: countries,
  currencies: currencies,
  eSIMs: eSIMs,
  "in New York City": "",
  languages: languages,
  providers: providers
};
var headerNamespace = "transfer-widgets:header";
var homeNamespace = "transfer-widgets:home";
var footerNamespace = "transfer-widgets:footer";
var resources = {
  en: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderEn), homeNamespace, HomeEn), footerNamespace, FooterEn),
  de: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderDe), homeNamespace, HomeDe), footerNamespace, FooterDe),
  es: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderEs), homeNamespace, HomeEs), footerNamespace, FooterEs),
  fr: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderFr), homeNamespace, HomeFr), footerNamespace, FooterFr),
  id: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderId), homeNamespace, HomeId), footerNamespace, FooterId),
  it: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderIt), homeNamespace, HomeIt), footerNamespace, FooterIt),
  ja: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderJa), homeNamespace, HomeJa), footerNamespace, FooterJa),
  ko: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderKo), homeNamespace, HomeKo), footerNamespace, FooterKo),
  nl: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderNl), homeNamespace, HomeNl), footerNamespace, FooterNl),
  pl: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderPl), homeNamespace, HomePl), footerNamespace, FooterPl),
  pt: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderPt), homeNamespace, HomePt), footerNamespace, FooterPt),
  ru: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderRu), homeNamespace, HomeRu), footerNamespace, FooterRu),
  sv: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderSv), homeNamespace, HomeSv), footerNamespace, FooterSv),
  th: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderTh), homeNamespace, HomeTh), footerNamespace, FooterTh),
  vi: _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderVi), homeNamespace, HomeVi), footerNamespace, FooterVi),
  "zh-CN": _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderZh), homeNamespace, HomeZh), footerNamespace, FooterZh),
  "zh-TW": _defineProperty(_defineProperty(_defineProperty({}, headerNamespace, HeaderZhTw), homeNamespace, HomeZhTw), footerNamespace, FooterZhTw)
};

var ensureKeyEqualValue = function ensureKeyEqualValue(langs) {
  Object.keys(langs).forEach(function (k) {
    return langs[k].value = k;
  });
  return langs;
};

var LANGUAGES = ensureKeyEqualValue({
  "en-us": {
    name: "English",
    englishName: "English",
    value: "en-us",
    intl: "en",
    code: "us",
    zendeskLocale: "en-us"
  },
  // 'en-gb': {
  //   name: 'English (UK)',
  //   value: 'en-gb',
  //   intl: 'en',
  //   code: 'gb',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'en-ca': {
  //   name: 'English (CA)',
  //   value: 'en-ca',
  //   intl: 'en',
  //   code: 'ca',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'af-za': {
  //   name: 'Afrikaans',
  //   value: 'af-za',
  //   intl: 'en',
  //   code: 'za',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'cs-cz': {
  //   name: 'čeština',
  //   value: 'cs-cz',
  //   intl: 'cs',
  //   moment: 'cs',
  //   code: 'cz',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  "de-de": {
    name: "Deutsch",
    englishName: "German",
    value: "de-de",
    intl: "de",
    moment: "de",
    code: "de",
    zendeskLocale: "de"
  },
  // 'fi-fi': {
  //   name: 'Suomi',
  //   value: 'fi-fi',
  //   intl: 'fi',
  //   moment: 'fi',
  //   code: 'fi',
  //   zendeskLocale: 'fi',
  // },
  // 'hr-hr': {
  //   name: 'Hrvatski',
  //   value: 'hr-hr',
  //   intl: 'hr',
  //   moment: 'hr',
  //   code: 'hr',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  "ja-jp": {
    name: "\u65E5\u672C\u8A9E",
    englishName: "Japanese",
    value: "ja-jp",
    intl: "ja",
    code: "jp",
    zendeskLocale: "ja"
  },
  // 'ms-my': {
  //   name: 'Bahasa Melayu',
  //   value: 'ms-my',
  //   intl: 'ms',
  //   code: 'my',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  nl: {
    name: "Dutch",
    englishName: "Dutch",
    value: "nl",
    intl: "nl",
    moment: "nl",
    code: "nl",
    zendeskLocale: "nl"
  },
  // 'no-no': {
  //   name: 'Norsk',
  //   value: 'no-no',
  //   intl: 'no',
  //   code: 'no',
  //   alias: 'en-us',
  //   zendeskLocale: 'no',
  // },
  // 'pt-pt': {
  //   name: 'Português (PT)',
  //   value: 'pt-pt',
  //   intl: 'pt',
  //   moment: 'pt',
  //   code: 'pt',
  //   alias: 'pt-br',
  //   zendeskLocale: 'pt-br',
  // },
  "pt-br": {
    name: "Portugu\xEAs",
    englishName: "Portuguese",
    value: "pt-br",
    intl: "pt",
    moment: "pt",
    code: "br",
    zendeskLocale: "pt-br"
  },
  es: {
    name: "Espa\xF1ol",
    englishName: "Spanish",
    value: "es",
    intl: "es",
    moment: "es",
    code: "es",
    zendeskLocale: "es"
  },
  // 'tr-tr': {
  //   name: 'Türkçe',
  //   value: 'tr-tr',
  //   intl: 'tr',
  //   moment: 'tr',
  //   code: 'tr',
  //   zendeskLocale: 'tr',
  // },
  fr: {
    name: "Fran\xE7ais",
    englishName: "French",
    value: "fr",
    intl: "fr",
    moment: "fr",
    code: "fr",
    zendeskLocale: "fr"
  },
  // 'fr-ca': {
  //   name: 'Français (CA)',
  //   value: 'fr-ca',
  //   intl: 'fr',
  //   moment: 'fr',
  //   code: 'ca',
  //   alias: 'fr-fr',
  //   zendeskLocale: 'fr',
  // },
  "id-id": {
    name: "Bahasa Indonesia",
    englishName: "Indonesian",
    value: "id-id",
    intl: "en",
    code: "id",
    zendeskLocale: "en-us"
  },
  // 'el-gr': {
  //   name: 'ελληνικά',
  //   value: 'el-gr',
  //   intl: 'el',
  //   code: 'gr',
  //   zendeskLocale: 'el',
  // },
  "it-it": {
    name: "Italiano",
    englishName: "Italian",
    value: "it-it",
    intl: "it",
    moment: "it",
    code: "it",
    zendeskLocale: "it"
  },
  // 'lt-lt': {
  //   name: 'lietuvių kalba',
  //   value: 'lt-lt',
  //   intl: 'lt',
  //   moment: 'lt',
  //   code: 'lt',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'lv-lv': {
  //   name: 'latviešu valoda',
  //   value: 'lv-lv',
  //   intl: 'lv',
  //   moment: 'lv',
  //   code: 'lv',
  //   zendeskLocale: 'en-us',
  // },
  pl: {
    name: "Polski",
    englishName: "Polish",
    value: "pl",
    intl: "pl",
    moment: "pl",
    code: "pl",
    zendeskLocale: "pl"
  },
  // 'ro-ro': {
  //   name: 'limba română',
  //   value: 'ro-ro',
  //   intl: 'ro',
  //   moment: 'ro',
  //   code: 'ro',
  //   alias: 'en-us',
  //   zendeskLocale: 'ro',
  // },
  sv: {
    name: "Svenska",
    englishName: "Swedish",
    value: "sv",
    intl: "sv",
    moment: "sv",
    code: "sv",
    zendeskLocale: "sv"
  },
  "ru-ru": {
    name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    englishName: "Russian",
    value: "ru-ru",
    intl: "ru",
    moment: "ru",
    code: "ru",
    zendeskLocale: "ru"
  },
  // 'sv-se': {
  //   name: 'svenska',
  //   value: 'sv-se',
  //   intl: 'sv',
  //   moment: 'sv',
  //   code: 'se',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'tl-ph': {
  //   name: 'Tagalog',
  //   value: 'tl-ph',
  //   intl: 'tl',
  //   moment: 'tl-ph',
  //   code: 'ph',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'uk-ua': {
  //   name: 'українська',
  //   value: 'uk-ua',
  //   intl: 'uk',
  //   code: 'ua',
  //   alias: 'ru-ru',
  //   zendeskLocale: 'ru',
  // },
  "vi-vn": {
    name: "ti\u1EBFng Vi\u1EC7t",
    englishName: "Vietnamese",
    value: "vi-vn",
    intl: "vi",
    code: "vn",
    zendeskLocale: "vi"
  },
  "zh-cn": {
    name: "\u7B80\u4F53\u4E2D\u6587",
    englishName: "Simplified Chinese",
    value: "zh-cn",
    intl: "zh",
    code: "cn",
    zendeskLocale: "zh-cn"
  },
  "zh-tw": {
    name: "\u6B63\u9AD4\u4E2D\u6587",
    englishName: "Traditional Chinese",
    value: "zh-tw",
    intl: "zh",
    code: "tw",
    zendeskLocale: "zh-tw"
  },
  "ko-kr": {
    name: "\uD55C\uAD6D\uC778",
    englishName: "Korean",
    value: "ko-kr",
    intl: "ko",
    code: "kr",
    zendeskLocale: "ko"
  },
  // 'ar-eg': {
  //   name: 'العربية',
  //   value: 'ar-eg',
  //   intl: 'ar',
  //   code: 'eg',
  //   alias: 'en-us',
  //   zendeskLocale: 'ar',
  // },
  // 'he-il': {
  //   name: 'עברית',
  //   value: 'he-il',
  //   intl: 'he',
  //   code: 'il',
  //   alias: 'en-us',
  //   zendeskLocale: 'he',
  // },
  // 'da-dk': {
  //   name: 'dansk',
  //   value: 'da-dk',
  //   intl: 'da',
  //   moment: 'da',
  //   code: 'dk',
  //   alias: 'en-us',
  //   zendeskLocale: 'da',
  // },
  // 'et-ee': {
  //   name: 'eesti',
  //   value: 'et-ee',
  //   intl: 'et',
  //   moment: 'et',
  //   code: 'ee',
  //   aslias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  "th-th": {
    name: "\u0E44\u0E17\u0E22",
    englishName: "Thai",
    value: "th-th",
    intl: "en",
    code: "th",
    zendeskLocale: "en-us"
  }
});
var CORE_LANGS = Object.entries(LANGUAGES).reduce(function (acc, _ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
      langName = _ref3[0],
      langObj = _ref3[1];

  var coreLang = langName.toLowerCase().split("-")[0];
  if (!coreLang || acc[coreLang]) return acc;
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, coreLang, langObj));
}, {});

var languageToOldFormat = function languageToOldFormat(language) {
  return language === null || language === void 0 ? void 0 : language.replace(/(_.*$)/, function (match) {
    return match.replace("_", "-").toLowerCase();
  });
};

var languageToNewFormat = function languageToNewFormat(language) {
  return language === null || language === void 0 ? void 0 : language.replace(/(-.*$)/, function (match) {
    return match.replace("-", "_").toUpperCase();
  });
};

var fallbackLng = "en_US";
var LOCALE_REGEX = /^\/?([a-z]{2}|[a-z]{2}-[a-z]{2})(\/|$)/i;

var findLanguage = function findLanguage(langName) {
  var defaultLang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";

  var _langName$toLowerCase = langName.toLowerCase().replaceAll(/[^a-z]+/gi, "-").split("-"),
      _langName$toLowerCase2 = _slicedToArray(_langName$toLowerCase, 2),
      _langName$toLowerCase3 = _langName$toLowerCase2[0],
      coreLang = _langName$toLowerCase3 === void 0 ? "en" : _langName$toLowerCase3,
      _langName$toLowerCase4 = _langName$toLowerCase2[1],
      subLang = _langName$toLowerCase4 === void 0 ? "" : _langName$toLowerCase4;

  var defaultLangObj = LANGUAGES[defaultLang] || CORE_LANGS[defaultLang] || CORE_LANGS.en;
  var fullName = "".concat(coreLang || "").concat(subLang ? "-".concat(subLang) : "") || defaultLangObj.value;
  return LANGUAGES[fullName] || CORE_LANGS[coreLang] || defaultLangObj;
};

var getInitialLocale = function getInitialLocale() {
  var locale = location.pathname.match(LOCALE_REGEX);
  return findLanguage(locale && locale[1] || "").value;
};

var setTranslation = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          i18n.use(initReactI18next).init({
            fallbackLng: fallbackLng,
            lng: getInitialLocale(),
            debug: false,
            ns: ["transfer-widgets:header", "transfer-widgets:home", "transfer-widgets:footer"],
            partialBundledLanguages: true,
            react: {
              useSuspense: false
            },
            resources: resources
          });

        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function setTranslation() {
    return _ref4.apply(this, arguments);
  };
}();

var _getEnvs = getEnvs(),
    QUERY_ENV = _getEnvs.QUERY_ENV;

var currencyQuery = createCurrencyQuery({
  ctx: {
    env: QUERY_ENV
  },
  headers: {
    "api-key": "c09cc3d01bbe22cb5d7afab4f82c8f3f",
    lang: getInitialLocale()
  }
});
var confirmationQuery = createConfirmationQuery({
  ctx: {
    env: QUERY_ENV
  },
  headers: {
    "api-key": "c09cc3d01bbe22cb5d7afab4f82c8f3f",
    "Content-Type": "application/json"
  }
});
var queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1e3 * 60 * 5,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      retry: false
    }
  }
});
var defaultWhiteLabelData = {
  metadata: {
    title: "Mozio",
    description: "",
    keywords: "taxi service, yellow cab, cab, chauffeur, super shuttle, limo, Airport Transfer, Express Train, Ground Transport, ground transportation, Transfer, Transfers, Holiday Taxis, airport transfers, airport taxi, taxis, taxi, transfer, transfers, taxi transfers, hotel transfers, minibus, coach, cities, airport, limousine, shuttles, esim, sim, parking",
    imageUrl: "https://static.mozio.com/assets/logo.svg",
    faviconUrl: "https://static.mozio.com/assets/favicon.ico",
    canonicalUrl: "https://mozio.com",
    url: "https://mozio.com"
  },
  themeVars: toThemeVars(defaultTheme),
  config: {
    name: "mozio",
    partnerRef: "mozio",
    domain: "mozio.com",
    locale: "en_US",
    currency: "USD",
    authRequired: false,
    showResendBooking: true,
    header: {
      logo: "https://static.mozio.com/assets/logo.svg",
      showESim: true,
      showTransfers: true,
      showSignInButton: true,
      showMyAccount: true,
      showMyBookings: true,
      headerUsername: "email",
      headerShowTaSubtext: true
    },
    banners: {
      showTransfers: true,
      showESim: true,
      showLounges: true
    },
    footer: {
      logo: "https://static.mozio.com/assets/logo.svg",
      phoneNumber: {
        default: "+1 (855) 980-7116"
      },
      emailLink: "travel-extras@mozio.com"
    },
    showRegisterTA: true,
    travelAgentCompany: "",
    tuiCSAdjustments: false
  }
};

var mapWhiteLabelInjectData = function mapWhiteLabelInjectData(data) {
  var domain = data.domain,
      locale = data.locale,
      currency = data.currency,
      config = data.config;
  var palette = extendPalette({
    primary: toThemeColors(config.FIRST_BACKGROUND_COLOR, config.FIRST_CONTRAST_COLOR),
    secondary: toThemeColors(config.FOURTH_BACKGROUND_COLOR, config.FOURTH_CONTRAST_COLOR)
  });
  var whiteLabelTheme = extendTheme({
    palette: palette,
    header: {
      logoHeight: config.HEADER_CUSTOM_LOGO_HEIGHT || void 0,
      height: config.HEADER_CUSTOM_HEIGHT || void 0,
      bg: getColor(palette, config.HEADER_BG),
      border: getColor(palette, config.HEADER_BORDER_COLOR),
      createAccountBtn: {
        bg: getColor(palette, config.HEADER_CREATE_ACCOUNT_BTN_BG),
        text: getColor(palette, config.HEADER_CREATE_ACCOUNT_BTN_TEXT),
        hover: {
          bg: getColor(palette, config.HEADER_CREATE_ACCOUNT_BTN_HOVER_BG),
          text: getColor(palette, config.HEADER_CREATE_ACCOUNT_BTN_HOVER_TEXT)
        }
      },
      signInBtn: {
        bg: getColor(palette, config.HEADER_SIGN_IN_BTN_BG),
        text: getColor(palette, config.HEADER_SIGN_IN_BTN_TEXT),
        hover: {
          bg: getColor(palette, config.HEADER_SIGN_IN_BTN_HOVER_BG),
          text: getColor(palette, config.HEADER_SIGN_IN_BTN_HOVER_TEXT)
        }
      },
      generalBtn: {
        bg: getColor(palette, config.HEADER_GENERAL_BTN_BG),
        text: getColor(palette, config.HEADER_GENERAL_BTN_TEXT),
        hover: {
          bg: getColor(palette, config.HEADER_GENERAL_BTN_HOVER_BG),
          text: getColor(palette, config.HEADER_GENERAL_BTN_HOVER_TEXT)
        }
      }
    }
  });
  return merge({}, defaultWhiteLabelData, {
    metadata: {
      imageUrl: config.CUSTOM_SOCIAL_LOGO,
      faviconUrl: config.CUSTOM_FAVICON
    },
    themeVars: toThemeVars(whiteLabelTheme),
    config: {
      id: config.ID,
      name: config.NAME,
      domain: domain,
      locale: locale,
      currency: currency || config.DEFAULT_CURRENCY || void 0,
      partnerRef: config.PARTNER_REF,
      heroImageUrl: config.PARKING_COVER_IMAGE,
      showResendBooking: config.SHOW_RESEND_BOOKING,
      showRegisterTA: config.REGISTER_TA_SHOW,
      travelAgentCompany: config.TRAVEL_AGENT_COMPANY,
      autoDetectCurrency: config.AUTODETECT_CURRENCY_BY_IP,
      tuiCsAdjustments: config.TUI_CS_ADJUSTMENTS,
      header: {
        logo: config.CUSTOM_LOGO || void 0,
        showESim: config.PARKING_SHOW_HEADER_ESIM,
        showTransfers: config.PARKING_SHOW_HEADER_TRANSFER,
        showSignInButton: config.SHOW_SIGNIN_BUTTON,
        customLogoLink: config.CUSTOM_LOGO_LINK || void 0,
        customLinks: config.HEADER_CUSTOM_LINKS,
        showMyAccount: config.SHOW_MY_ACCOUNT,
        showMyBookings: config.SHOW_MY_BOOKINGS,
        headerUsername: config.HEADER_USER_NAME,
        headerShowTaSubtext: config.HEADER_SHOW_TA_SUBTEXT
      },
      banners: {
        showTransfers: config.PARKING_SHOW_TRANSFER_BANNER,
        showESim: config.PARKING_SHOW_ESIM_BANNER,
        showLounges: config.PARKING_SHOW_LOUNGES_BANNER
      },
      footer: {
        logo: config.CUSTOM_FOOTER_LOGO || void 0,
        socials: Object.fromEntries(config.FOOTER_SOCIALS),
        phoneNumber: config.ESIM_SUPPORT_PHONE_NUMBERS ? Object.fromEntries(config.ESIM_SUPPORT_PHONE_NUMBERS) : void 0,
        emailLink: config.ESIM_SUPPORT_EMAIL
      }
    }
  });
};

var toHsl = function toHsl(hsla) {
  return hsla.replace("hsla", "hsl").replace(", 1)", ")").replaceAll(",", "");
};

var toThemeColors = function toThemeColors(color, contrastColor) {
  return {
    100: toHsl(toHsla(mix(color, "#FFFFFF", 0.8))),
    200: toHsl(toHsla(mix(color, "#FFFFFF", 0.3))),
    300: toHsl(toHsla(color)),
    400: toHsl(toHsla(mix(color, "#000000", 0.3))),
    500: toHsl(toHsla(mix(color, "#000000", 0.6))),
    contrast: toHsl(toHsla(contrastColor))
  };
};

var getColor = function getColor(palette, colorKey) {
  var _colorKey$split = colorKey.split("-"),
      _colorKey$split2 = _slicedToArray(_colorKey$split, 2),
      color = _colorKey$split2[0],
      shade = _colorKey$split2[1];

  var colorValue = palette[color];

  if (typeof colorValue === "string") {
    return colorValue;
  }

  return palette[color][shade];
};

var getWhiteLabelFromUrl = function getWhiteLabelFromUrl() {
  var params = new URLSearchParams(window.location.search);

  if (params.get("wl")) {
    return params.get("wl");
  }

  return location.hostname;
};

var setCssVariables = function setCssVariables(theme) {
  var root = document.documentElement;
  Object.entries(theme).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        property = _ref6[0],
        value = _ref6[1];

    root.style.setProperty(property, value);
  });
};

var setWhiteLabel = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var whiteLabelDomain, config2, themeVars2, wlObj, whiteLabelDomainData, _mapWhiteLabelInjectD, config, themeVars;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          whiteLabelDomain = getWhiteLabelFromUrl();

          if (!(!whiteLabelDomain || !window.WL_OBJ && !window.APP_CONFIG)) {
            _context2.next = 6;
            break;
          }

          config2 = defaultWhiteLabelData.config, themeVars2 = defaultWhiteLabelData.themeVars;
          setCssVariables(themeVars2);
          window.WHITE_LABEL_CONFIG = config2;
          return _context2.abrupt("return");

        case 6:
          wlObj = window.WL_OBJ || {
            config: window.APP_CONFIG
          };
          wlObj.defaultDomain = whiteLabelDomain;
          whiteLabelDomainData = whiteLabelServices.getWhiteLabelCustomDomains(wlObj).find(function (d) {
            return d.domain === whiteLabelDomain;
          });
          _mapWhiteLabelInjectD = mapWhiteLabelInjectData(whiteLabelDomainData), config = _mapWhiteLabelInjectD.config, themeVars = _mapWhiteLabelInjectD.themeVars;
          window.WHITE_LABEL_CONFIG = config;
          setCssVariables(themeVars);

        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function setWhiteLabel() {
    return _ref7.apply(this, arguments);
  };
}();

var getWhiteLabel = function getWhiteLabel() {
  if (!window.WHITE_LABEL_CONFIG) {
    console.error("window.WHITE_LABEL_CONFIG not found!");
    return defaultWhiteLabelData.config;
  }

  return window.WHITE_LABEL_CONFIG;
};

var useCurrency = function useCurrency() {
  var _getWhiteLabel = getWhiteLabel(),
      defaultCurrency = _getWhiteLabel.currency,
      autoDetectCurrency = _getWhiteLabel.autoDetectCurrency;

  var search = new URLSearchParams(window.location.search);
  var hasCurrency = search.get("currency");
  var userCurrencyQuery = useQuery({
    queryKey: ["userCurrency"],
    queryFn: function queryFn() {
      return currencyQuery.getCurrencyCodeByIp();
    },
    enabled: autoDetectCurrency
  }, queryClient);
  return {
    currency: hasCurrency ? search.get("currency") : userCurrencyQuery.data || defaultCurrency
  };
};

var removePrefix = function removePrefix(value, prefix) {
  if (value.startsWith(prefix)) {
    return value.slice(prefix.length);
  }

  return value;
};

var PROCESSORS = {
  DOMAIN_WO_PREFIX: function DOMAIN_WO_PREFIX() {
    var str = window.location.hostname;

    for (var _len = arguments.length, prefixes = new Array(_len), _key = 0; _key < _len; _key++) {
      prefixes[_key] = arguments[_key];
    }

    for (var _i = 0, _prefixes = prefixes; _i < _prefixes.length; _i++) {
      var prefix = _prefixes[_i];

      if (str.startsWith(prefix)) {
        return removePrefix(str, prefix);
      }
    }

    return str;
  },
  DOMAIN: function DOMAIN() {
    var removeLevels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "0";
    var str = window.location.hostname;
    var parts = str.split(".").slice(Number.parseInt(removeLevels, 10));
    return parts.join(".");
  },
  CURRENCY: function CURRENCY() {
    var _useCurrency = useCurrency(),
        currency = _useCurrency.currency;

    return currency || "USD";
  },
  LANGUAGE: function LANGUAGE() {
    var _useTranslation$2 = useTranslation$1(),
        _useTranslation$2$i = _useTranslation$2.i18n.language,
        language = _useTranslation$2$i === void 0 ? "en-us" : _useTranslation$2$i;

    return languageToNewFormat(language);
  },
  IF_LANG: function IF_LANG(lang, value) {
    var _useTranslation$3 = useTranslation$1(),
        language = _useTranslation$3.i18n.language;

    var activeLang = language || "en-us";
    var activeLangFormatted = languageToNewFormat(activeLang);
    return activeLangFormatted === lang ? value : "";
  },
  IF_DOMAIN: function IF_DOMAIN(domain, value) {
    var activeDomain = window.location.hostname;
    return activeDomain === domain ? value : "";
  }
};

var getLocalizedUrl = function getLocalizedUrl() {
  var tpl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return tpl && tpl.replaceAll && tpl.replaceAll(/{([^}]+)}/g, function (match, val) {
    var argsSeparator = val.indexOf(":");
    var parts = argsSeparator > 0 ? [val.slice(0, Math.max(0, argsSeparator)), val.slice(argsSeparator + 1)] : [val];

    if (PROCESSORS[parts[0]]) {
      var args = parts.length > 1 ? parts[1].split(",") : [];

      if (typeof PROCESSORS[parts[0]] === "function") {
        var processor = PROCESSORS[parts[0]];
        return processor.apply(void 0, _toConsumableArray(args));
      } else {
        return "";
      }
    } else if (vars && Object.prototype.hasOwnProperty.call(vars, parts[0])) {
      return vars[parts[0]];
    }

    return match || "";
  });
};

var getHelpCenterLink = function getHelpCenterLink(language) {
  var helpCenterLink = "https://www.mygroundbooking.com/hc/";

  switch (language) {
    case "en-US":
      {
        helpCenterLink += "en-us";
        break;
      }

    case "es":
      {
        helpCenterLink += "es";
        break;
      }

    case "fr":
      {
        helpCenterLink += "fr";
        break;
      }

    default:
      {
        helpCenterLink += "en-us";
        break;
      }
  }

  return helpCenterLink;
};

var _path$h, _path2$a, _circle$7, _circle2$5;

function _extends$l() {
  _extends$l = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$l.apply(this, arguments);
}

var SvgMyTrips = function SvgMyTrips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "M11.84 8.473v-3h-3M12.468 15.938v3h3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    d: "m12.469 18.937 3.516-3.516a2.497 2.497 0 0 0-3.532-3.532l-1.358 1.358a2.483 2.483 0 1 1-3.51-3.511l4.263-4.263",
    stroke: "currentColor"
  })), _circle$7 || (_circle$7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.968,
    cy: 3.33,
    r: 1.5,
    fill: "currentColor"
  })), _circle2$5 || (_circle2$5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.34,
    cy: 20.826,
    r: 1.5,
    fill: "currentColor"
  })));
};

var _path$g;

function _extends$k() {
  _extends$k = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$k.apply(this, arguments);
}

var SvgPassenger = function SvgPassenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M11.85 11.149a3.92 3.92 0 1 0 0-7.84 3.92 3.92 0 0 0 0 7.84ZM15.26 12.458a6.17 6.17 0 0 1-3.42 1.02c-1.26 0-2.45-.38-3.43-1.03-.62-.41-1.38-.52-2.06-.24l-.24.1c-.61.26-1.07.79-1.23 1.44l-.5 2c-.36 1.44-.04 3.01 1.01 4.06a4.3 4.3 0 0 0 3.05 1.26h6.74a4.3 4.3 0 0 0 3.05-1.26c1.05-1.05 1.37-2.62 1.01-4.06l-.5-2.01a2.11 2.11 0 0 0-1.22-1.43c-.583-.233-1.748-.183-2.26.15Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })));
};

var _path$f;

function _extends$j() {
  _extends$j = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$j.apply(this, arguments);
}

var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M16.595 7.904a6.5 6.5 0 1 1-9.192 0M11.999 3.5v6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$e;

function _extends$i() {
  _extends$i = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$i.apply(this, arguments);
}

var SvgTimes = function SvgTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16.365 16.434 5.638 5.707M5.638 16.305 16.365 5.578"
  })));
};

var _g$4, _defs$2;

function _extends$h() {
  _extends$h = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$h.apply(this, arguments);
}

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email_svg__a)",
    stroke: "#637280",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5,
    width: 18,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.844 5.428 8.08 5.708a1 1 0 0 0 1.154 0l8.08-5.708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.016 16.748 15 11.34M2.844 16.748l5.015-5.408",
    strokeLinecap: "round"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h22v22H0z"
  })))));
};

var _path$d, _path2$9, _path3$7;

function _extends$g() {
  _extends$g = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$g.apply(this, arguments);
}

var SvgResendBooking = function SvgResendBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8h16m-30 0h-3a4 4 0 0 0-4 4v11a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V12a4 4 0 0 0-4-4h-3",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.5h2A2.5 2.5 0 0 1 19 4v8a2.5 2.5 0 0 1-2.5 2.5h-2A2.5 2.5 0 0 1 12 12V4a2.5 2.5 0 0 1 2.5-2.5zm30 0h2A2.5 2.5 0 0 1 49 4v8a2.5 2.5 0 0 1-2.5 2.5h-2A2.5 2.5 0 0 1 42 12V4a2.5 2.5 0 0 1 2.5-2.5zM2.5 24v32a4 4 0 0 0 4 4h48a4 4 0 0 0 4-4V24",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.98 45.515c-1.067 0-1.951-.875-1.715-1.916a6.6 6.6 0 0 1 .683-1.741c.241-.493.503-.88.783-1.161.29-.29.62-.585.987-.885.377-.3.822-.721 1.335-1.263.397-.435.658-.86.784-1.277.135-.425.203-.89.203-1.393a3.22 3.22 0 0 0-.087-.755 1.483 1.483 0 0 0-.29-.638 1.89 1.89 0 0 0-.93-.682 3.367 3.367 0 0 0-1.218-.218c-.33 0-.653.039-.973.116-.31.078-.575.203-.798.378-.27.203-.474.46-.61.769-.216.534-.649 1.03-1.226 1.03h-.947c-1.162 0-2.09-1.032-1.648-2.107.104-.252.222-.498.354-.737.473-.861 1.088-1.539 1.842-2.032a6.573 6.573 0 0 1 1.829-.842 7.163 7.163 0 0 1 2.003-.29c1.103 0 2.143.174 3.12.523a5.3 5.3 0 0 1 2.423 1.683 5.33 5.33 0 0 1 .987 1.727c.232.648.348 1.301.348 1.959 0 1.055-.237 2.012-.71 2.873a11.978 11.978 0 0 1-1.757 2.41c-.3.319-.57.6-.812.841-.232.232-.445.455-.639.668a5.116 5.116 0 0 0-.493.638c-.271.445-.436.808-.494 1.089-.138.67-.641 1.233-1.325 1.233h-1.01zm.097 5.66a2 2 0 0 1-2-2v-.18a2 2 0 0 1 2-2h.15a2 2 0 0 1 2 2v.18a2 2 0 0 1-2 2h-.15z",
    fill: "currentColor"
  })));
};

var _path$c, _path2$8;

function _extends$f() {
  _extends$f = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$f.apply(this, arguments);
}

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: "1em",
    height: "1em",
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M80.662 54.436c-4.936 19.696-24.904 31.661-44.599 26.725-19.696-4.936-31.66-24.903-26.725-44.599 4.936-19.695 24.904-31.66 44.6-26.725",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    d: "m24.577 44.291 16.369 16.368a2 2 0 0 0 2.828 0l34.142-34.142",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};

var _path$b, _rect$4, _rect2$1;

function _extends$e() {
  _extends$e = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$e.apply(this, arguments);
}

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: "1em",
    height: "1em",
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M41.33 9.5 62.98 47c1.925 3.333-.48 7.5-4.33 7.5h-43.3c-3.85 0-6.255-4.167-4.33-7.5L32.67 9.5c1.924-3.333 6.736-3.333 8.66 0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect$4 || (_rect$4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 21,
    width: 4,
    height: 18,
    rx: 2,
    fill: "currentColor"
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 43,
    width: 4,
    height: 4,
    rx: 2,
    fill: "currentColor"
  })));
};

var Dialog = function Dialog(_ref8) {
  var icon = _ref8.icon,
      children = _ref8.children,
      error = _ref8.error,
      success = _ref8.success,
      props = _objectWithoutProperties(_ref8, _excluded);

  return /* @__PURE__ */jsx(Dialog$1, _objectSpread(_objectSpread({}, props), {}, {
    children: /* @__PURE__ */jsx(DialogPortal, {
      children: /* @__PURE__ */jsxs(DialogContent, {
        className: "flex max-w-md flex-col items-center justify-center bg-neutral-100 p-5 outline-none",
        children: [icon && /* @__PURE__ */jsx("div", {
          className: cn$1("-mt-24 flex h-32 w-32 items-center justify-center rounded-full border", {
            "bg-error-400 border-error-400": error,
            "bg-success-300 border-success-300": !error && success,
            "border-neutral-200 bg-white": !error && !success
          }),
          children: icon
        }), children]
      })
    })
  }));
};

var _path$a, _path2$7;

function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$d.apply(this, arguments);
}

var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.368 4.23a.5.5 0 0 1 0-1h3.264a.5.5 0 1 1 0 1H11.5v1.861a6.5 6.5 0 1 1-1 0v-1.86H9.368zM5.5 12.572a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0zm8.144-1.907a.5.5 0 0 0-.707-.707l-2.29 2.29a.5.5 0 0 0 .707.707l2.29-2.29z",
    fill: "#637280"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    d: "m15.32 8.28.96-.96",
    stroke: "#637280",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var useCounter = function useCounter(onCounterEnd) {
  var COUNTDOWN_SECONDS = 60;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      counter = _useState2[0],
      setCounter = _useState2[1];

  var startCounter = function startCounter() {
    setCounter(COUNTDOWN_SECONDS);
  };

  useEffect(function () {
    var timer;

    if (counter > 0) {
      timer = window.setTimeout(function () {
        return setCounter(counter - 1);
      }, 1e3);
    } else if (counter === 0) {
      if (onCounterEnd) {
        onCounterEnd();
      }

      setCounter(0);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [counter, onCounterEnd]);
  return {
    counter: counter,
    startCounter: startCounter
  };
};

var ResendBookingButton = function ResendBookingButton(_ref9) {
  var countdown = _ref9.countdown,
      onButtonClick = _ref9.onButtonClick;

  var _useTranslation$4 = useTranslation$1("parking:purchase-summary"),
      t = _useTranslation$4.t;

  var handleClick = function handleClick() {
    onButtonClick();
  };

  return /* @__PURE__ */jsxs("div", {
    className: "mt-2 flex items-center gap-5 text-xs text-neutral-800",
    children: [countdown === 0 && /* @__PURE__ */jsx(Button, {
      variant: "ghost",
      onClick: handleClick,
      className: "px-4 py-2",
      children: t("Resend confirmation")
    }), countdown > 0 && /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx("span", {
        children: t("Resend confirmation")
      }), /* @__PURE__ */jsxs("div", {
        className: "flex items-center gap-1",
        children: [/* @__PURE__ */jsx(SvgTimer, {
          className: "text-xl"
        }), " ", t("in {{countdown}} sec", {
          countdown: countdown
        }), "."]
      })]
    })]
  });
};

var ResendBookingDialog = function ResendBookingDialog(_ref10) {
  var open = _ref10.open,
      onClose = _ref10.onClose,
      onOpenChange = _ref10.onOpenChange;

  var _useTranslation$5 = useTranslation$1("transfer-widgets:header"),
      t = _useTranslation$5.t;

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useCounter = useCounter(),
      counter = _useCounter.counter,
      startCounter = _useCounter.startCounter;

  var resendConfirmationEmailMutation = useMutation({
    mutationFn: confirmationQuery.resendConfirmationEmail
  }, queryClient);
  var showLoading = resendConfirmationEmailMutation.isPending;
  var showSuccess = resendConfirmationEmailMutation.isSuccess;
  var showError = resendConfirmationEmailMutation.isError;
  var showForm = !showLoading && !showError && !showSuccess;

  var handleSend = function handleSend(event) {
    event.preventDefault();
    resendConfirmationEmailMutation.mutate(email);
  };

  var handleResend = function handleResend() {
    resendConfirmationEmailMutation.mutate(email);
  };

  var handleClose = function handleClose() {
    resendConfirmationEmailMutation.reset();
    setEmail("");
    onClose();
  };

  return /* @__PURE__ */jsxs(Dialog, {
    onOpenChange: onOpenChange,
    success: showSuccess,
    error: showError,
    open: open,
    icon: /* @__PURE__ */jsxs(Fragment, {
      children: [showForm && /* @__PURE__ */jsx(SvgResendBooking, {
        className: "text-primary text-6xl"
      }), showLoading && /* @__PURE__ */jsx(Loading, {
        className: "[&_svg]:h-16 [&_svg]:w-16"
      }), showSuccess && /* @__PURE__ */jsx("div", {
        className: "bg-success-300 flex h-full w-full items-center justify-center rounded-full",
        children: /* @__PURE__ */jsx(SvgSuccess, {
          className: "text-8xl text-white"
        })
      }), showError && /* @__PURE__ */jsx("div", {
        className: "bg-error-400 flex h-full w-full items-center justify-center rounded-full",
        children: /* @__PURE__ */jsx(SvgWarning, {
          className: "text-8xl text-white"
        })
      })]
    }),
    children: [/* @__PURE__ */jsxs("h2", {
      className: "mb-1 mt-7 text-2xl font-bold leading-9",
      children: [showForm && t("Resend Confirmation Email"), showSuccess && t("Thanks")]
    }), /* @__PURE__ */jsxs("p", {
      className: "mb-8 text-center",
      children: [showForm && t("Tell us your email and we'll send you copies of all your upcoming bookings."), showSuccess && t("If any reservations are found we'll send them to you."), showError && t("An error occurred while sending the email.")]
    }), showForm && /* @__PURE__ */jsxs("form", {
      onSubmit: handleSend,
      className: "w-full text-center",
      children: [/* @__PURE__ */jsxs(InputGroup, {
        className: "mb-4",
        children: [/* @__PURE__ */jsx(InputLeftContent, {
          children: /* @__PURE__ */jsx(SvgEmail, {})
        }), /* @__PURE__ */jsx(Input, {
          placeholder: t("Email address"),
          type: "email",
          required: true,
          value: email,
          onChange: function onChange(event) {
            return setEmail(event.target.value);
          }
        })]
      }), /* @__PURE__ */jsx(Button, {
        type: "submit",
        className: "w-full",
        children: t("Send")
      }), /* @__PURE__ */jsx(Button, {
        variant: "ghost",
        onClick: handleClose,
        children: t("Close")
      })]
    }), (showSuccess || showError) && /* @__PURE__ */jsx(Button, {
      onClick: handleClose,
      className: "mb-6 w-full",
      children: t("OK")
    }), showSuccess && /* @__PURE__ */jsx(ResendBookingButton, {
      onButtonClick: function onButtonClick() {
        startCounter();
        handleResend();
      },
      countdown: counter
    })]
  });
};

var getLinkUrl = function getLinkUrl(path) {
  var origin = window.location.origin;
  var fromPath = encodeURIComponent(btoa(window.location.href));
  return "".concat(origin, "/v2/user/").concat(path, "?fromPath=").concat(fromPath);
};

var UserAccountButtons = function UserAccountButtons(_ref11) {
  var isTravelAgent = _ref11.isTravelAgent,
      renderLink = _ref11.renderLink,
      onLogout = _ref11.onLogout,
      props = _objectWithoutProperties(_ref11, _excluded2);

  var _useTranslation$6 = useTranslation$1(),
      t = _useTranslation$6.t;

  var _getWhiteLabel2 = getWhiteLabel(),
      header = _getWhiteLabel2.header,
      tuiCSAdjustments = _getWhiteLabel2.tuiCSAdjustments;

  return /* @__PURE__ */jsxs(Fragment, {
    children: [header.showMyBookings && /* @__PURE__ */jsx(HeaderButton, _objectSpread(_objectSpread({
      asChild: true,
      className: "bg-white text-neutral-800 hover:bg-neutral-100  hover:text-neutral-800 xl:px-2 2xl:px-4"
    }, props), {}, {
      children: renderLink({
        to: getLinkUrl("my-reservations"),
        children: /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsx(SvgMyTrips, {
            className: "text-xl"
          }), t("My bookings")]
        })
      })
    })), header.showMyAccount && /* @__PURE__ */jsx(HeaderButton, _objectSpread(_objectSpread({
      asChild: true,
      className: "bg-white text-neutral-800 hover:bg-neutral-100 hover:text-neutral-800 xl:px-2 2xl:px-4 "
    }, props), {}, {
      children: renderLink({
        to: getLinkUrl("info"),
        children: /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsx(SvgPassenger, {
            className: "text-xl"
          }), t("My account")]
        })
      })
    })), !tuiCSAdjustments && /* @__PURE__ */jsxs(HeaderButton, {
      className: "text-error-300 hover:text-error-300 w-full bg-white hover:bg-neutral-100 xl:px-2 2xl:px-4",
      onClick: onLogout,
      children: [/* @__PURE__ */jsx(SvgSignOut, {
        className: "text-xl"
      }), t("Log out")]
    })]
  });
};

var HeaderContainer = function HeaderContainer(_ref12) {
  var _currenciesQuery$data, _languages$find, _currencies$find, _header$customLinks;

  var renderLink = _ref12.renderLink,
      onLogin = _ref12.onLogin,
      onLogout = _ref12.onLogout,
      activeLanguage = _ref12.activeLanguage,
      activeCurrency = _ref12.activeCurrency,
      onLocaleChange = _ref12.onLocaleChange,
      onCurrencyChange = _ref12.onCurrencyChange,
      user = _ref12.user;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openMobileMenu = _useState6[0],
      setOpenMobileMenu = _useState6[1];

  var _useTranslation$7 = useTranslation$1(),
      i18n = _useTranslation$7.i18n;

  var _useTranslation$8 = useTranslation$1("transfer-widgets:header"),
      t = _useTranslation$8.t;

  var _getWhiteLabel3 = getWhiteLabel(),
      header = _getWhiteLabel3.header,
      showResendBooking = _getWhiteLabel3.showResendBooking,
      partnerRef = _getWhiteLabel3.partnerRef;

  var logoUrl = getLocalizedUrl(header.customLogoLink);

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openResendDialog = _useState8[0],
      setOpenResendDialog = _useState8[1];

  var getLabel = function getLabel(language) {
    return i18n.language === "en-us" ? "".concat(language.name).concat(language.englishName === "English" ? "" : " (".concat(language.englishName, ")")) : language.name;
  };

  var languages = Object.values(LANGUAGES).map(function (l) {
    return _objectSpread(_objectSpread({}, l), {}, {
      label: getLabel(l),
      value: getLabel(l).toLowerCase()
    });
  });

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      currencyMenuOpen = _useState10[0],
      setCurrencyMenuOpen = _useState10[1];

  var currenciesQuery = useQuery({
    queryKey: ["currencies", currencyMenuOpen],
    queryFn: currencyQuery.getCurrencies,
    enabled: currencyMenuOpen
  }, queryClient);
  var priorityCurrencies = /* @__PURE__ */new Set(["USD", "GBP", "EUR"]);
  var currencies = ((_currenciesQuery$data = currenciesQuery.data) === null || _currenciesQuery$data === void 0 ? void 0 : _currenciesQuery$data.map(function (c) {
    return _objectSpread(_objectSpread({}, c), {}, {
      value: "".concat(c.code, " - ").concat(c.name).toLowerCase(),
      label: "".concat(c.code, " - ").concat(c.name)
    });
  })) || [];
  currencies.sort(function (a, b) {
    if (priorityCurrencies.has(a.code)) return -1;
    if (priorityCurrencies.has(b.code)) return 1;
    return a.code.localeCompare(b.code);
  });
  var currentLanguage = (_languages$find = languages.find(function (l) {
    return getSelectedLocale(l.value).value === languageToOldFormat(activeLanguage);
  })) !== null && _languages$find !== void 0 ? _languages$find : languages[0];
  var currentCurrency = (_currencies$find = currencies.find(function (c) {
    return c.code === activeCurrency;
  })) !== null && _currencies$find !== void 0 ? _currencies$find : currencies[0];
  var currentCurrencyCode = (currentCurrency === null || currentCurrency === void 0 ? void 0 : currentCurrency.code) || activeCurrency;
  var isTravelAgent = (user === null || user === void 0 ? void 0 : user.userType) === USER_TYPE.TRAVEL_AGENT;
  var showTravelAgentSubtext = isTravelAgent && header.headerShowTaSubtext;
  var travelAgentSubtext = showTravelAgentSubtext ? t("Travel Agent") : void 0;
  var links = header === null || header === void 0 || (_header$customLinks = header.customLinks) === null || _header$customLinks === void 0 ? void 0 : _header$customLinks.map(function (link) {
    return [getLocalizedUrl(link[0]), getLocalizedUrl(link[1])];
  }).filter(function (link) {
    return link[0] && link[1];
  });
  var mozioLinks = [{
    href: "/travelers",
    label: t("Travelers")
  }, {
    href: "/travel-agents",
    label: t("Travel Agents")
  }, {
    href: "/business-partners",
    label: t("Business Partners")
  }, {
    href: "/providers",
    label: t("Providers")
  }, {
    href: "/about",
    label: t("About")
  }];

  var handleLocaleChange = function handleLocaleChange(locale) {
    var selectedLocale = getSelectedLocale(locale);
    i18n.changeLanguage(selectedLocale.value);

    if (onLocaleChange) {
      onLocaleChange(selectedLocale.value);
    }
  };

  var handleCurrencyChange = function handleCurrencyChange(currency) {
    if (onCurrencyChange) {
      var _currency$split$;

      onCurrencyChange({
        code: ((_currency$split$ = currency.split(" - ")[0]) === null || _currency$split$ === void 0 ? void 0 : _currency$split$.toUpperCase()) || "USD"
      });
    }
  };

  var handleOnLogin = function handleOnLogin() {
    setOpenMobileMenu(false);

    if (onLogin) {
      onLogin();
    }
  };

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      sheetOpen = _useState12[0],
      setSheetOpen = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      popoverOpen = _useState14[0],
      setPopoverOpen = _useState14[1];

  var isMozioWL = partnerRef === "mozio";
  var contactSupportLink = getHelpCenterLink(activeLanguage);
  return /* @__PURE__ */jsxs(Header, {
    className: "relative inset-x-0 top-0 [&_div]:items-center ".concat(isMozioWL ? "[&_div]:justify-normal" : ""),
    children: [logoUrl ? /* @__PURE__ */jsx(HeaderLogo, {
      href: logoUrl,
      children: /* @__PURE__ */jsx("img", {
        src: header.logo,
        alt: "logo"
      })
    }) : /* @__PURE__ */jsx("div", {
      children: renderLink({
        to: "/",
        children: /* @__PURE__ */jsx("img", {
          className: "h-[var(--mz-header-logo-height)]",
          src: header.logo,
          alt: "logo"
        })
      })
    }), user && /* @__PURE__ */jsxs(Sheet, {
      onOpenChange: setSheetOpen,
      children: [/* @__PURE__ */jsx(HeaderButton, {
        className: "ml-auto px-0 xl:hidden xl:px-2 2xl:px-4",
        asChild: true,
        children: /* @__PURE__ */jsx(SheetTrigger, {
          children: /* @__PURE__ */jsx(HeaderAvatar, {
            label: user === null || user === void 0 ? void 0 : user.firstName[0],
            showCaret: true,
            isOpen: sheetOpen
          })
        })
      }), /* @__PURE__ */jsxs(SheetContent, {
        side: "bottom",
        className: "z-50 mt-[var(--mz-header-height)] flex flex-col gap-3 rounded-t-lg p-3",
        children: [/* @__PURE__ */jsxs("div", {
          className: "flex justify-between px-4",
          children: [/* @__PURE__ */jsx("h2", {
            className: "py-2 text-lg font-bold",
            children: t("Hello, {{name}}!", {
              name: user.firstName
            })
          }), /* @__PURE__ */jsx(SheetClose, {
            children: /* @__PURE__ */jsx(SvgTimes, {
              className: "text-primary text-xl"
            })
          })]
        }), /* @__PURE__ */jsx(SheetClose, {
          asChild: true,
          children: /* @__PURE__ */jsx(UserAccountButtons, {
            isTravelAgent: isTravelAgent,
            renderLink: renderLink,
            onLogout: onLogout
          })
        })]
      })]
    }), header.showSignInButton && !user && /* @__PURE__ */jsx(HeaderButton, {
      className: "ml-auto px-0 xl:hidden",
      asChild: true,
      children: renderLink({
        to: "/user/login",
        children: /* @__PURE__ */jsx(HeaderAvatar, {})
      })
    }), /* @__PURE__ */jsxs(HeaderContent, {
      className: "items-center ".concat(isMozioWL ? "xl:flex-1" : ""),
      open: openMobileMenu,
      onOpenChange: setOpenMobileMenu,
      breakpoint: "xl",
      children: [/* @__PURE__ */jsxs("div", {
        className: "flex justify-between px-4 xl:hidden",
        children: [/* @__PURE__ */jsx("h2", {
          className: "py-2 text-lg font-bold",
          children: t("More")
        }), /* @__PURE__ */jsx(Button, {
          variant: "ghost",
          className: "px-0",
          onClick: function onClick() {
            setOpenMobileMenu(false);
          },
          children: /* @__PURE__ */jsx(SvgTimes, {
            className: "text-primary text-xl"
          })
        })]
      }), /* @__PURE__ */jsxs("div", {
        className: "flex flex-col items-start xl:flex-row xl:gap-1 ".concat(isMozioWL ? "xl:flex-1 xl:justify-between" : ""),
        children: [isMozioWL && /* @__PURE__ */jsx("div", {
          className: "flex w-full flex-col items-start gap-4 xl:my-0 xl:flex-row xl:gap-1",
          children: mozioLinks.map(function (link) {
            return /* @__PURE__ */jsx(HeaderButton, {
              asChild: true,
              children: /* @__PURE__ */jsx("a", {
                href: link.href,
                className: "appearance-none xl:px-2 2xl:px-4",
                children: link.label
              })
            }, link.href);
          })
        }), /* @__PURE__ */jsxs("div", {
          className: "my-3 flex w-full min-w-fit flex-col items-start justify-end gap-4 xl:my-0 xl:flex-row xl:gap-1",
          children: [isMozioWL && /* @__PURE__ */jsx(HeaderButton, {
            asChild: true,
            children: /* @__PURE__ */jsx("a", {
              href: contactSupportLink,
              target: "_blank",
              rel: "noreferrer",
              className: "appearance-none xl:px-2 2xl:px-4",
              children: t("Help")
            })
          }), links === null || links === void 0 ? void 0 : links.map(function (link) {
            return /* @__PURE__ */jsx(HeaderButton, {
              asChild: true,
              children: /* @__PURE__ */jsx("a", {
                href: link[1],
                target: "_blank",
                rel: "noreferrer",
                className: "appearance-none xl:px-2 2xl:px-4",
                children: link[0]
              })
            }, link[1]);
          }), showResendBooking && /* @__PURE__ */jsx(HeaderButton, {
            asChild: true,
            children: /* @__PURE__ */jsx(Button, {
              className: "xl:px-2 2xl:px-4",
              variant: "solid",
              onClick: function onClick() {
                setOpenResendDialog(true);
              },
              children: t("Resend Booking")
            })
          }), /* @__PURE__ */jsx(HeaderCombobox, {
            value: currentLanguage.value,
            triggerText: currentLanguage.name,
            label: "Language",
            items: languages,
            shouldFilter: true,
            onValueChange: handleLocaleChange
          }), /* @__PURE__ */jsx(HeaderCombobox, {
            value: currentCurrency === null || currentCurrency === void 0 ? void 0 : currentCurrency.value,
            triggerText: currentCurrencyCode,
            label: "Currency",
            items: currencies,
            open: currencyMenuOpen,
            loading: currenciesQuery.isFetching,
            shouldFilter: true,
            onValueChange: handleCurrencyChange,
            onOpenChange: setCurrencyMenuOpen
          }), header.showSignInButton && !user && /* @__PURE__ */jsxs(Fragment, {
            children: [/* @__PURE__ */jsx(HeaderSignInButton, {
              asChild: true,
              onClick: handleOnLogin,
              className: "appearance-none",
              children: renderLink({
                to: "/user/login",
                children: t("Sign In")
              })
            }), /* @__PURE__ */jsx("div", {
              className: "w-full px-4 xl:w-auto xl:px-0",
              children: /* @__PURE__ */jsx(HeaderCreateAccountButton, {
                asChild: true,
                onClick: handleOnLogin,
                className: "appearance-none justify-center",
                children: renderLink({
                  to: "/user/register",
                  children: t("Create Account")
                })
              })
            })]
          }), user && /* @__PURE__ */jsx("div", {
            className: "hidden xl:flex",
            children: /* @__PURE__ */jsxs(Popover, {
              onOpenChange: setPopoverOpen,
              children: [/* @__PURE__ */jsx(PopoverTrigger, {
                asChild: true,
                children: /* @__PURE__ */jsx(HeaderButton, {
                  className: "hidden xl:flex xl:px-2 2xl:px-4",
                  children: /* @__PURE__ */jsx(HeaderUserAvatar, {
                    name: "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName),
                    email: user === null || user === void 0 ? void 0 : user.email,
                    role: travelAgentSubtext,
                    isOpen: popoverOpen,
                    displayField: header.headerUsername
                  })
                })
              }), /* @__PURE__ */jsx(PopoverContent, {
                sideOffset: 12,
                align: "end",
                className: "ml-auto w-44 px-0",
                children: /* @__PURE__ */jsx(PopoverClose, {
                  asChild: true,
                  children: /* @__PURE__ */jsx(UserAccountButtons, {
                    isTravelAgent: isTravelAgent,
                    renderLink: renderLink,
                    onLogout: onLogout
                  })
                })
              })]
            })
          })]
        })]
      })]
    }), /* @__PURE__ */jsx(ResendBookingDialog, {
      open: openResendDialog,
      onClose: function onClose() {
        setOpenResendDialog(false);
      },
      onOpenChange: setOpenResendDialog
    })]
  });
};

var getSelectedLocale = function getSelectedLocale(locale) {
  var formattedLocale = locale.split(" ")[0];
  var selectedLocale = Object.values(LANGUAGES).find(function (lang) {
    return lang.name.toLowerCase().includes(formattedLocale);
  });
  return selectedLocale;
};

var _path$9;

function _extends$c() {
  _extends$c = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$c.apply(this, arguments);
}

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: "1em",
    height: "1em",
    viewBox: "0 0 106 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.75 81.658 0 164.158V0l105.75 81.658Z",
    fill: "currentColor"
  })));
};

var _g$3, _defs$1;

function _extends$b() {
  _extends$b = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$b.apply(this, arguments);
}

var SvgCancellation = function SvgCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cancellation_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.533,
    cy: 19.025,
    r: 10.964,
    transform: "rotate(-45 41.533 19.025)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.059 21.257a1 1 0 0 1 1.5-.866l19.688 11.367a1 1 0 0 1-.148 1.802l-5.433 2.04a1 1 0 0 0-.502 1.457l4.343 7.107a1 1 0 0 1-.339 1.38l-5.785 3.47a1 1 0 0 1-1.367-.336l-4.391-7.185a1 1 0 0 0-1.479-.259l-4.462 3.572a1 1 0 0 1-1.625-.78v-22.77Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.533 40.525v-10.5m0-2.5v-2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.426 14.96.645-.381a.75.75 0 0 0-1.176-.149l.53.53ZM37.468 25.918l-.53-.53a.75.75 0 0 0 .149 1.175l.381-.645Zm-2.828-2.829-.646.382a.75.75 0 0 0 1.176.148l-.53-.53Zm10.957-10.957.53.53a.75.75 0 0 0-.149-1.176l-.38.646Zm2.298 2.298L36.938 25.387l1.06 1.061 10.958-10.957-1.06-1.061Zm-1.236 9.721a7.253 7.253 0 0 1-8.81 1.12l-.762 1.292a8.753 8.753 0 0 0 10.633-1.351l-1.06-1.06Zm1.12-8.81a7.253 7.253 0 0 1-1.12 8.81l1.06 1.061a8.753 8.753 0 0 0 1.352-10.633l-1.291.763ZM35.17 23.62l10.957-10.957-1.06-1.06-10.958 10.957 1.061 1.06Zm.116-.911a7.253 7.253 0 0 1 1.12-8.81l-1.06-1.06a8.753 8.753 0 0 0-1.352 10.633l1.292-.763Zm1.12-8.81a7.253 7.253 0 0 1 8.81-1.12l.762-1.292a8.753 8.753 0 0 0-10.633 1.352l1.061 1.06Z",
    fill: "currentColor"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cancellation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(0 .025)",
    d: "M0 0h60v60H0z"
  })))));
};

var _circle$6, _circle2$4, _path$8;

function _extends$a() {
  _extends$a = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$a.apply(this, arguments);
}

var SvgExpertise = function SvgExpertise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$6 || (_circle$6 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32.143,
    r: 14.139,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2$4 || (_circle2$4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32.143,
    r: 10.086,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "m25.02 32.706 3.743 3.743 6.217-6.217M16.92 37.67l-5.725 9.917 4.87-.66 1.865 4.548 4.497-7.346M43.08 37.67l5.725 9.917-4.87-.66-1.865 4.548-4.38-7.388M30 4.271l1.846 2.783 3.218.896-2.076 2.616.142 3.337L30 12.737l-3.13 1.166.142-3.337-2.076-2.616 3.218-.896L30 4.27ZM12.605 10.59l1.847 2.783 3.217.896-2.076 2.616.142 3.337-3.13-1.166-3.13 1.166.143-3.337-2.076-2.616 3.217-.896 1.846-2.783ZM47.395 10.59l1.846 2.783 3.218.896-2.077 2.616.142 3.337-3.13-1.166-3.129 1.166.142-3.337-2.076-2.616 3.217-.896 1.847-2.783Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$7, _path2$6, _path3$6, _circle$5, _circle2$3, _circle3;

function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$9.apply(this, arguments);
}

var SvgGlobal = function SvgGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 17.6a19.884 19.884 0 0 0-5.644 13.903c0 11.018 8.932 19.95 19.95 19.95 11.017 0 19.948-8.932 19.948-19.95 0-3.398-.85-6.598-2.348-9.398M20.77 13.749a19.885 19.885 0 0 1 9.106-2.195c4.985 0 9.542 1.828 13.039 4.85",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.473 12.115c-.443.627-1.675 3.186-.169 3.806 1.883.775 3.876 4.32.997 5.095-2.88.775-5.206-.443-6.535 1.44-1.329 1.882-.221 2.547-2.325 2.325-2.105-.221-1.252-2.693-4.508-2.105M43.263 17.693c-.88.408-2.427 1.87-1.583 4.45 1.056 3.227.422 3.45 3.483 4.674 3.061 1.224 4.688 5.689 4.477 7.358M39.424 30.072c2.596 3.172-1.05 6.633-1.339 10.527-.288 3.894-3.633 8.71-5.167 5.365-.844-1.84 1.729-3.97-.55-5.365-1.813-.685-6.77 2.622-5.499-2.363m12.555-8.164c-.213-.26-.425-.513-.636-.755m.636.755-.636-.755m0 0c-1.128-1.519-4.427-4.026-8.598-1.901",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.207 9.432c0 2.998-4.025 9.672-5.428 9.672-1.403 0-5.429-6.674-5.429-9.672a5.428 5.428 0 0 1 10.857 0ZM52.864 13.54c0 2.962-3.976 9.553-5.362 9.553-1.386 0-5.361-6.591-5.361-9.552a5.361 5.361 0 1 1 10.723 0ZM31.29 30.45c0 2.509-3.368 8.092-4.541 8.092-1.174 0-4.542-5.584-4.542-8.092a4.542 4.542 0 1 1 9.083 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle$5 || (_circle$5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.779,
    cy: 9.432,
    r: 2.281,
    fill: "currentColor"
  })), _circle2$3 || (_circle2$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.502,
    cy: 13.541,
    r: 2.253,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.748,
    cy: 30.45,
    r: 1.909,
    fill: "currentColor"
  })));
};

var _path$6, _path2$5, _circle$4, _path3$5, _path4$1, _path5;

function _extends$8() {
  _extends$8 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$8.apply(this, arguments);
}

var SvgInnovative = function SvgInnovative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.654 38.394h5.655l6.058 9.676H12.633l6.058-9.676h5.655",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.671 36.09h5.596a2 2 0 0 1 1.669.896l7.95 12.028a1 1 0 0 1-.833 1.551H8.947a1 1 0 0 1-.834-1.551l7.951-12.028a2 2 0 0 1 1.669-.897h5.595",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle$4 || (_circle$4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 15.615,
    r: 2.166,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.46 10.94h-.75c0 .334.221.627.542.72l.209-.72Zm.83.319-.328.674a.75.75 0 0 0 .858-.144l-.53-.53Zm.667-.668.53.53-.53-.53Zm1.415 0 .53-.53-.53.53Zm.651.652.53-.53-.53.53Zm0 1.414-.53-.53.53.53Zm-.562.563-.53-.53a.75.75 0 0 0-.108.925l.638-.396Zm.457.934-.703.26a.75.75 0 0 0 .703.49v-.75Zm.21 2.921v-.75a.75.75 0 0 0-.733.594l.734.156Zm-.41 1.192-.674-.327a.75.75 0 0 0 .144.858l.53-.53Zm.305.305-.53.53.53-.53Zm0 1.414-.53-.53.53.53Zm-.651.652-.53-.53.53.53Zm-1.415 0-.53.53.53-.53Zm-.199-.2.53-.53a.75.75 0 0 0-.925-.107l.395.637Zm-1.297.577-.209-.72a.75.75 0 0 0-.541.72h.75Zm-2.922 0h.75a.75.75 0 0 0-.541-.72l-.209.72Zm-1.297-.577.395-.637a.75.75 0 0 0-.925.107l.53.53Zm-.2.2-.53-.53.53.53Zm-1.414 0-.53.53.53-.53Zm-.651-.652-.53.53.53-.53Zm0-1.414.53.53-.53-.53Zm.304-.305.53.53a.75.75 0 0 0 .145-.858l-.675.328Zm-.41-1.192.734-.156a.75.75 0 0 0-.734-.594v.75Zm.21-2.921v.75a.75.75 0 0 0 .704-.49l-.703-.26Zm.458-.934.638.394a.75.75 0 0 0-.107-.925l-.53.53Zm-.562-.563-.53.53.53-.53Zm0-1.414-.53-.53.53.53Zm.651-.652.53.53-.53-.53Zm1.414 0 .53-.53-.53.53Zm.668.668-.53.53a.75.75 0 0 0 .858.144l-.328-.674Zm.83-.32.208.721a.75.75 0 0 0 .541-.72h-.75Zm1-2.718a1.75 1.75 0 0 0-1.75 1.75h1.5a.25.25 0 0 1 .25-.25v-1.5Zm.92 0h-.92v1.5h.92v-1.5Zm1.75 1.75a1.75 1.75 0 0 0-1.75-1.75v1.5a.25.25 0 0 1 .25.25h1.5Zm0 .969V9.97h-1.5v.969h1.5Zm.408-.356a5.957 5.957 0 0 0-.949-.365l-.417 1.441c.246.071.483.163.71.273l.656-1.349Zm.202 1.205.668-.667-1.06-1.061-.668.668 1.06 1.06Zm.668-.667a.25.25 0 0 1 .353 0l1.061-1.061a1.75 1.75 0 0 0-2.475 0l1.06 1.06Zm.353 0 .652.651 1.06-1.06-.651-.652-1.06 1.06Zm.652.651a.25.25 0 0 1 0 .354l1.06 1.06a1.75 1.75 0 0 0 0-2.474l-1.06 1.06Zm0 .354-.563.562 1.061 1.06.563-.562-1.061-1.06Zm1.128 1.766a5.974 5.974 0 0 0-.523-1.069l-1.275.79c.156.252.288.52.392.8l1.406-.521Zm.022-.49h-.725v1.5h.725v-1.5Zm1.75 1.75a1.75 1.75 0 0 0-1.75-1.75v1.5a.25.25 0 0 1 .25.25h1.5Zm0 .922v-.921h-1.5v.921h1.5Zm-1.75 1.75a1.75 1.75 0 0 0 1.75-1.75h-1.5a.25.25 0 0 1-.25.25v1.5Zm-.514 0h.514v-1.5h-.514v1.5Zm.264.77c.209-.428.367-.885.47-1.363l-1.468-.313c-.076.358-.195.7-.35 1.02l1.348.656Zm.16-.553-.304-.305-1.06 1.06.304.305 1.06-1.06Zm0 2.475a1.75 1.75 0 0 0 0-2.475l-1.06 1.06a.25.25 0 0 1 0 .354l1.06 1.06Zm-.651.651.651-.651-1.06-1.061-.652.652 1.061 1.06Zm-2.475 0a1.75 1.75 0 0 0 2.475 0l-1.06-1.06a.25.25 0 0 1-.354 0l-1.06 1.06Zm-.2-.2.2.2 1.06-1.06-.199-.2-1.06 1.06Zm-.558.768a5.97 5.97 0 0 0 1.484-.66l-.79-1.275c-.343.212-.716.38-1.11.494l.416 1.44Zm.542-.478v-.243h-1.5v.243h1.5Zm-1.75 1.75a1.75 1.75 0 0 0 1.75-1.75h-1.5a.25.25 0 0 1-.25.25v1.5Zm-.922 0h.922v-1.5h-.922v1.5Zm-1.75-1.75c0 .966.784 1.75 1.75 1.75v-1.5a.25.25 0 0 1-.25-.25h-1.5Zm0-.243v.243h1.5v-.243h-1.5Zm-.942.06a5.97 5.97 0 0 0 1.484.66l.417-1.44a4.468 4.468 0 0 1-1.111-.494l-.79 1.275Zm-.135-1.167-.2.2 1.06 1.06.2-.2-1.06-1.06Zm-.2.2a.25.25 0 0 1-.354 0l-1.06 1.06a1.75 1.75 0 0 0 2.475 0l-1.06-1.06Zm-.354 0-.651-.652-1.06 1.06.65.652 1.061-1.06Zm-.651-.652a.25.25 0 0 1 0-.354l-1.06-1.06a1.75 1.75 0 0 0 0 2.475l1.06-1.061Zm0-.354.304-.304-1.06-1.06-.305.304 1.061 1.06Zm-1.37-1.87c.102.478.261.935.47 1.363l1.349-.655a4.456 4.456 0 0 1-.351-1.021l-1.467.313Zm.22.593h.514v-1.5h-.514v1.5Zm-1.75-1.75c0 .967.783 1.75 1.75 1.75v-1.5a.25.25 0 0 1-.25-.25h-1.5Zm0-.921v.921h1.5v-.921h-1.5Zm1.75-1.75a1.75 1.75 0 0 0-1.75 1.75h1.5a.25.25 0 0 1 .25-.25v-1.5Zm.725 0h-.725v1.5h.725v-1.5Zm-.18-.58a5.974 5.974 0 0 0-.523 1.069l1.406.522c.104-.281.236-.549.392-.8l-1.275-.79Zm-.456.363.563.563 1.06-1.06-.562-.563-1.06 1.06Zm0-2.474a1.75 1.75 0 0 0 0 2.474l1.061-1.06a.25.25 0 0 1 0-.354l-1.06-1.06Zm.652-.652-.652.652 1.061 1.06.652-.651-1.061-1.061Zm2.475 0a1.75 1.75 0 0 0-2.475 0l1.06 1.06a.25.25 0 0 1 .354 0l1.06-1.06Zm.667.668-.667-.668-1.06 1.06.667.668 1.06-1.06Zm.09-.51a5.962 5.962 0 0 0-.948.365l.656 1.35c.227-.11.464-.203.71-.274l-.417-1.44Zm-.54-.248v.969h1.5V9.97h-1.5Z",
    fill: "currentColor"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.966v6.892M25.992 26.318v6.892M34.008 25.794v6.892M43.084 12.941h5.651v5.651h-5.651zM38.714 24.581h3.385v3.385h-3.385zM10.705 12.382h6.211v6.211h-6.211z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.06 19.223v1.827h-3.654v-3.653h1.827M41.258 5.832h3.653v3.653h-3.653zM16.916 22.755h3.653v3.653h-3.653zM18.742 5.832h3.653v3.653h-3.653z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _g$2;

function _extends$7() {
  _extends$7 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$7.apply(this, arguments);
}

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 23.025a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-7l-5 4v-4h-2a3 3 0 0 1-3-3v-9Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 28.025c0-9.941-8.059-18-18-18s-18 8.059-18 18M9.533 31.484a3 3 0 0 1 2.411-2.942l.196-.039a2 2 0 0 1 2.393 1.961v7.121a2 2 0 0 1-2.393 1.961l-.196-.039a3 3 0 0 1-2.411-2.942v-5.08ZM50.533 36.565a3 3 0 0 1-2.412 2.942l-.196.04a2 2 0 0 1-2.392-1.962v-7.12a2 2 0 0 1 2.392-1.962l.196.04a3 3 0 0 1 2.412 2.941v5.081Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.533 39.025v4a5 5 0 0 1-5 5h-4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.533,
    y: 46.025,
    width: 7,
    height: 4,
    rx: 2,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.033,
    cy: 28.525,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.033,
    cy: 28.525,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.033,
    cy: 28.525,
    r: 1,
    fill: "currentColor"
  }))));
};

var _path$5, _path2$4, _circle$3, _path3$4, _rect$3, _circle2$2;

function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$6.apply(this, arguments);
}

var SvgTransparency = function SvgTransparency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.585 41.577H9.656a2 2 0 0 1-2-2V12.216a2 2 0 0 1 2-2h40.688a2 2 0 0 1 2 2v27.36a2 2 0 0 1-2 2h-3.586M52.134 16.053H8.07M49.88 13.015h-1.466M45.856 13.015H44.39M41.68 13.015h-1.466M17.587 13.015h-6.86",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "m37.464 33.356.67.336a.75.75 0 0 0 0-.672l-.67.336Zm-.92 1.275.53.53-.53-.53Zm-6.957 0-.53.53.53-.53Zm-.921-1.275-.67-.336a.75.75 0 0 0 0 .672l.67-.336Zm.921-1.274.53.53-.53-.53Zm6.956 0 .53-.53-.53.53Zm.25.938a4.162 4.162 0 0 1-.78 1.08l1.06 1.061a5.665 5.665 0 0 0 1.062-1.469l-1.341-.672Zm-.78 1.08a4.169 4.169 0 0 1-5.896 0l-1.06 1.061a5.669 5.669 0 0 0 8.016 0l-1.06-1.06Zm-5.896 0a4.16 4.16 0 0 1-.78-1.08l-1.341.672c.265.531.62 1.028 1.06 1.47l1.061-1.061Zm-.78-.408c.194-.388.454-.754.78-1.08l-1.06-1.06a5.664 5.664 0 0 0-1.061 1.468l1.34.672Zm.78-1.08a4.169 4.169 0 0 1 5.896 0l1.06-1.06a5.669 5.669 0 0 0-8.016 0l1.06 1.06Zm5.896 0c.326.326.586.692.78 1.08l1.342-.672a5.666 5.666 0 0 0-1.062-1.469l-1.06 1.061Z",
    fill: "currentColor"
  })), _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.065,
    cy: 33.356,
    r: 9.877,
    transform: "rotate(-45 33.065 33.356)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    d: "m39.212 41.132 2.902 2.902m-1.273-4.53 1.45 1.45 1.452 1.452",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.455,
    y: 44.693,
    width: 4.168,
    height: 8.673,
    rx: 1,
    transform: "rotate(-45 41.455 44.693)",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2$2 || (_circle2$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.065,
    cy: 33.357,
    r: 1.298,
    fill: "currentColor"
  })));
};

var AdditionalFeatures = function AdditionalFeatures() {
  var _useTranslation$9 = useTranslation$1("transfer-widgets:home"),
      t = _useTranslation$9.t;

  var additionalFeatures = [{
    icon: /* @__PURE__ */jsx(SvgSupport, {
      className: "text-primary text-6xl"
    }),
    title: t("World class customer service"),
    description: t("Flight delayed? We wait. Need help with your booking? Receive immediate assistance with our 24/7  support.")
  }, {
    icon: /* @__PURE__ */jsx(SvgGlobal, {
      className: "text-primary text-6xl"
    }),
    title: t("Global coverage"),
    description: t("180 countries, 3500+ airports, 3000+ providers, 17 languages, 90+ currencies.")
  }, {
    icon: /* @__PURE__ */jsx(SvgInnovative, {
      className: "text-primary text-6xl"
    }),
    title: t("Innovative technology"),
    description: t("Utilize our cutting-edge technology with advanced features and customizable options.")
  }, {
    icon: /* @__PURE__ */jsx(SvgTransparency, {
      className: "text-primary text-6xl"
    }),
    title: t("Transparency"),
    description: t("We partner with licensed ground transportation Providers, ensuring reliability in every booking.")
  }, {
    icon: /* @__PURE__ */jsx(SvgCancellation, {
      className: "text-primary text-6xl"
    }),
    title: t("Free online cancellations"),
    description: t("Manage changes easily with free online cancellations on 99% of bookings.")
  }, {
    icon: /* @__PURE__ */jsx(SvgExpertise, {
      className: "text-primary text-6xl"
    }),
    title: t("Expertise"),
    description: t("Leverage our industry expertise with over 12 years of specialization in ground transportation.")
  }];
  return /* @__PURE__ */jsxs("div", {
    className: "py-12 sm:py-20",
    children: [/* @__PURE__ */jsx("h6", {
      className: "mb-10 text-[1.375rem] font-semibold leading-8 sm:text-4xl",
      children: t("Why choose Mozio")
    }), /* @__PURE__ */jsx("ul", {
      className: "flex flex-col gap-5 sm:grid sm:grid-cols-2 sm:gap-6 lg:grid-cols-3",
      children: additionalFeatures.map(function (feature) {
        var description = feature.description,
            icon = feature.icon,
            title = feature.title;
        return /* @__PURE__ */jsxs("li", {
          className: "flex items-start gap-3",
          children: [icon, /* @__PURE__ */jsxs("div", {
            className: "flex-1",
            children: [/* @__PURE__ */jsx("p", {
              className: "mb-2 mt-0 text-xl font-semibold",
              children: title
            }), /* @__PURE__ */jsx("p", {
              className: "m-0 text-sm text-neutral-800",
              children: description
            })]
          })]
        }, title);
      })
    })]
  });
};

var _path$4, _path2$3, _circle$2, _ellipse, _path3$3;

function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$5.apply(this, arguments);
}

var SvgEsim = function SvgEsim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.843 16.015V13.95a4 4 0 0 0-4-4h-14.7a4 4 0 0 0-4 4V46.7a4 4 0 0 0 4 4h14.7a4 4 0 0 0 4-4v-1.43",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.319 9.95 1.116 1.754a3 3 0 0 0 2.53 1.389h5.056a3 3 0 0 0 2.531-1.39l1.116-1.753M22.462 46.827h8.044",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.196,
    cy: 30.323,
    r: 12.661,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.196,
    cy: 30.323,
    rx: 5.647,
    ry: 12.661,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.67 24.869h23.05m0 10.909H20.67",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};

var _path$3;

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$4.apply(this, arguments);
}

var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.029 7.734a1.75 1.75 0 0 0-1.75 1.75v2.971h-8.163a3 3 0 0 0-3 3V43.21a3 3 0 0 0 3 3h8.163v4.956c0 .967.783 1.75 1.75 1.75h5.942a1.75 1.75 0 0 0 1.75-1.75V46.21h8.164a3 3 0 0 0 3-3V15.455a3 3 0 0 0-3-3H34.72v-2.97a1.75 1.75 0 0 0-1.75-1.75H27.03Zm-.25 43.432V46.21h6.442v4.956a.25.25 0 0 1-.25.25H27.03a.25.25 0 0 1-.25-.25Zm6.442-38.71V9.483a.25.25 0 0 0-.25-.25H27.03a.25.25 0 0 0-.25.25v2.971h6.442Zm-16.105 1.5h25.769a1.5 1.5 0 0 1 1.5 1.5V43.21a1.5 1.5 0 0 1-1.5 1.5h-25.77a1.5 1.5 0 0 1-1.5-1.5V15.455a1.5 1.5 0 0 1 1.5-1.5Zm1.432 27.908V16.801h22.904v25.063H18.548Zm-1.5-25.563a1 1 0 0 1 1-1h23.904a1 1 0 0 1 1 1v26.063a1 1 0 0 1-1 1H18.048a1 1 0 0 1-1-1V16.301Zm17.794 16.997-1.32-3.215a.398.398 0 0 0-.378-.252l-.808-.002.58 3.597 1.926-.128Zm-.009 2.441 1.831.113a.88.88 0 0 0 .778-.366l.328-.455a.887.887 0 0 0 .004-1.045l-.315-.453a.89.89 0 0 0-.78-.357l-6.741.461a.27.27 0 0 1-.248-.142l-.378-.737a.257.257 0 0 0-.284-.137l-.792.172a.262.262 0 0 0-.197.344l.481 1.318c.021.052.021.116 0 .179l-.49 1.321a.267.267 0 0 0 .189.348l.796.16a.264.264 0 0 0 .286-.138l.377-.745a.274.274 0 0 1 .248-.143l3.713.229-.731-.044-.603 3.601.802-.002a.42.42 0 0 0 .381-.255l1.345-3.227ZM22.058 20.398v14.296h2.7v-4.845h3.336a10.632 10.632 0 0 0 1.191-.08c.847-.132 1.542-.413 2.085-.843.55-.43.953-.97 1.211-1.619.265-.655.397-1.383.397-2.184 0-.8-.129-1.525-.387-2.174a3.8 3.8 0 0 0-1.211-1.628c-.543-.43-1.241-.712-2.095-.844a4.324 4.324 0 0 0-.635-.06c-.232-.013-.417-.02-.556-.02h-6.036Zm5.917 6.93h-3.217v-4.409h3.217c.139 0 .291.007.456.02.166.013.318.04.457.08.364.099.645.268.844.506.198.231.334.493.407.784.08.285.12.556.12.814 0 .258-.04.533-.12.824a1.983 1.983 0 0 1-.407.785c-.199.231-.48.397-.844.496a2.34 2.34 0 0 1-.457.08c-.165.012-.317.02-.456.02Z",
    fill: "currentColor"
  })));
};

var _rect$2, _path$2, _circle$1, _circle2$1, _path2$2, _path3$2, _path4;

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

var SvgTransfers = function SvgTransfers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.601,
    y: 41.026,
    width: 26.798,
    height: 8.028,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.305 49.054v2.476a1 1 0 0 0 1 1h1.751a1 1 0 0 0 1-1v-2.476M19.944 49.054v2.476a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1v-2.476M44.008 39.606c0 .638-.517 1.156-1.155 1.156s-2.028.126-2.028-.512 1.39-1.799 2.028-1.799c.638 0 1.155.517 1.155 1.155ZM15.991 39.606c0 .638.518 1.156 1.156 1.156.638 0 2.028.126 2.028-.512s-1.39-1.799-2.028-1.799c-.638 0-1.156.517-1.156 1.155ZM38.162 40.626a2.174 2.174 0 1 0-4.349 0",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.833,
    cy: 45.083,
    r: 1.794,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.167,
    cy: 45.083,
    r: 1.794,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.639 41.026-1.289-5.263a3 3 0 0 0-2.914-2.287H23.564a3 3 0 0 0-2.914 2.287l-1.29 5.263",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.772 22.254h-9.658a5 5 0 0 1-5-5V8.098l2.14.827a3 3 0 0 1 1.713 1.71l1.042 2.678a1 1 0 0 0 .932.637h19.45a3 3 0 0 1 1.503.403l3.786 2.191a3 3 0 0 1 .951 4.323l-.08.113a3 3 0 0 1-2.453 1.274h-7.973M13.74 11.493h-2.21m2.21 3.577h-3.256m3.256 3.78h-2.21m25.848-2.01H21.98",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.05 15.19h-1.628c-.855 0-1.548.694-1.548 1.549v0c0 .854.693 1.547 1.548 1.547h5.327M31.541 20.412a1 1 0 0 1 .933-.638h4.373a1 1 0 0 1 .815 1.58l-2.61 3.672a5 5 0 0 1-4.075 2.105h-.582a1 1 0 0 1-.932-1.362l2.078-5.357Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};

var MOZIO_STATIC_URL = "https://static.mozio.com/transfer-widgets";

var Hero = function Hero(_ref13) {
  var children = _ref13.children;
  useTranslation$1("transfer-widgets:home");
  return /* @__PURE__ */jsxs("section", {
    className: "relative",
    children: [/* @__PURE__ */jsxs("div", {
      className: "absolute inset-0 -z-10 overflow-hidden",
      children: [/* @__PURE__ */jsxs("picture", {
        children: [/* @__PURE__ */jsx("source", {
          srcSet: "\n              ".concat(MOZIO_STATIC_URL, "/transfer-hero-desktop-768w.png 768w,\n              ").concat(MOZIO_STATIC_URL, "/transfer-hero-desktop-1542w.png 1542w, \n              ").concat(MOZIO_STATIC_URL, "/transfer-hero-desktop-2058w.png 2058w, \n              ").concat(MOZIO_STATIC_URL, "/transfer-hero-desktop-2509w.png 2509w, \n              ").concat(MOZIO_STATIC_URL, "/transfer-hero-desktop-2880w.png 2880w"),
          media: mediaQueries.md
        }), /* @__PURE__ */jsx("source", {
          srcSet: "\n              ".concat(MOZIO_STATIC_URL, "/transfer-hero-mobile-200w.png 200w, \n              ").concat(MOZIO_STATIC_URL, "/transfer-hero-mobile-717w.png 717w, \n              ").concat(MOZIO_STATIC_URL, "/transfer-hero-mobile-1035w.png 1035w")
        }), /* @__PURE__ */jsx("img", {
          className: "absolute inset-0 h-full w-full object-cover object-top",
          src: "".concat(MOZIO_STATIC_URL, "/transfer-hero-mobile-717w.png"),
          alt: "A woman in a brown coat smiles while stepping out of a vehicle."
        })]
      }), /* @__PURE__ */jsx("div", {
        className: "bg-primary-400/50 absolute inset-0"
      })]
    }), /* @__PURE__ */jsxs("div", {
      className: "relative max-w-5xl px-2 py-6 lg:m-auto lg:flex lg:items-start lg:gap-7 lg:px-4 lg:pb-28 lg:pt-20",
      children: [children, /* @__PURE__ */jsxs("div", {
        className: "m-auto my-5 flex max-w-[17rem] items-start gap-4 py-5 lg:mt-0 lg:w-60 lg:flex-col lg:pt-0",
        children: [/* @__PURE__ */jsxs("div", {
          className: "bg-white py-1 lg:flex lg:w-full lg:flex-col lg:items-center",
          children: [/* @__PURE__ */jsx("img", {
            className: "h-14 lg:h-20",
            src: "".concat(MOZIO_STATIC_URL, "/trustpilot.png"),
            alt: "Trustpilot"
          }), /* @__PURE__ */jsx("p", {
            className: "m-0 text-center text-[0.56rem] font-semibold lg:text-base",
            children: "Trustscore: 4.8 / 5"
          }), /* @__PURE__ */jsx("p", {
            className: "m-0 text-center text-[0.5rem] lg:text-xs",
            children: "6,211 reviews"
          })]
        }), /* @__PURE__ */jsxs("div", {
          className: "bg-white p-1 lg:flex lg:w-full lg:flex-col lg:items-center",
          children: [/* @__PURE__ */jsx("img", {
            className: "h-14 lg:h-20",
            src: "".concat(MOZIO_STATIC_URL, "/reviews-io.png"),
            alt: "Reviews io"
          }), /* @__PURE__ */jsx("p", {
            className: "m-0 text-center text-[0.56rem] font-semibold lg:text-base",
            children: "Rating: 4.75 / 5"
          }), /* @__PURE__ */jsx("p", {
            className: "m-0 text-center text-[0.5rem] lg:text-xs",
            children: "771 reviews"
          })]
        })]
      })]
    })]
  });
};

var Businesses = function Businesses() {
  var _useTranslation$10 = useTranslation$1("transfer-widgets:home"),
      t = _useTranslation$10.t;

  var travelAgentProducts = [{
    icon: /* @__PURE__ */jsx(SvgTransfers, {
      className: "text-primary text-6xl"
    }),
    title: t("All transfers in one place"),
    description: t("Book sedans, SUVs, vans, private and shared buses, limos, trains, and even water taxis.")
  }, {
    icon: /* @__PURE__ */jsx(SvgEsim, {
      className: "text-primary text-6xl"
    }),
    title: t("eSIMs"),
    description: t("Provide your clients with seamless internet access worldwide with eSIMs. ")
  }, {
    icon: /* @__PURE__ */jsx(SvgParking, {
      className: "text-primary text-6xl"
    }),
    title: t("Airport Parking"),
    description: t("Offer your clients hassle-free Airport Parking options, ensuring a smooth start and end to their journey. ")
  }];
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsxs("section", {
      className: "mt-12 bg-neutral-100 md:flex",
      children: [/* @__PURE__ */jsxs("div", {
        className: "relative md:min-w-[50%] md:flex-1",
        children: [/* @__PURE__ */jsxs("picture", {
          children: [/* @__PURE__ */jsx("source", {
            srcSet: "\n                ".concat(MOZIO_STATIC_URL, "/travel-agent-mobile-360w.png 360w,\n                ").concat(MOZIO_STATIC_URL, "/travel-agent-mobile-540w.png 540w,\n                ").concat(MOZIO_STATIC_URL, "/travel-agent-mobile-685w.png 640w,\n                ").concat(MOZIO_STATIC_URL, "/travel-agent-desktop.png 1440w\n              ")
          }), /* @__PURE__ */jsx("img", {
            className: "max-h-60 w-full object-cover md:h-[41rem] md:max-h-full",
            src: "".concat(MOZIO_STATIC_URL, "/travel-agent-mobile-685w.png"),
            alt: t("Travel Agent")
          })]
        }), /* @__PURE__ */jsx("div", {
          className: "bg-primary-500/70 absolute inset-0 flex items-end md:hidden",
          children: /* @__PURE__ */jsx("p", {
            className: "m-0 px-2 py-5 text-lg font-semibold text-white",
            children: t("Are you a Travel Agent?")
          })
        })]
      }), /* @__PURE__ */jsxs("div", {
        className: "px-2 py-6 md:flex md:flex-1 md:flex-col md:justify-center md:py-16 md:pl-9 lg:py-24",
        children: [/* @__PURE__ */jsx("h6", {
          className: "mb-2 hidden text-[1.625rem] font-semibold leading-9 md:block",
          children: t("Are you a Travel Agent?")
        }), /* @__PURE__ */jsx("p", {
          className: "m-0 md:max-w-md",
          children: t("Use our platform as a one-stop shop for all your ground transportation bookings, from airport transfers to local taxis, across the globe.")
        }), /* @__PURE__ */jsx("ul", {
          className: "mt-5 flex flex-col gap-5 md:max-w-md",
          children: travelAgentProducts.map(function (product) {
            var description = product.description,
                icon = product.icon,
                title = product.title;
            return /* @__PURE__ */jsxs("li", {
              className: "flex items-start gap-3",
              children: [icon, /* @__PURE__ */jsxs("div", {
                className: "flex-1",
                children: [/* @__PURE__ */jsx("p", {
                  className: "mb-1 mt-0 text-base lg:text-xl",
                  children: title
                }), /* @__PURE__ */jsx("p", {
                  className: "m-0 text-sm text-neutral-800",
                  children: description
                })]
              })]
            }, title);
          })
        }), /* @__PURE__ */jsx("a", {
          href: "/travel-agents",
          className: "bg-secondary lg:hover:bg-secondary-400 mt-5 inline-block w-fit rounded-md px-2 py-4 transition",
          children: t("Start booking now")
        })]
      })]
    }), /* @__PURE__ */jsxs("section", {
      className: "bg-neutral-100 py-8 md:flex md:flex-row-reverse md:py-0",
      children: [/* @__PURE__ */jsxs("div", {
        className: "relative md:min-w-[50%] md:flex-1",
        children: [/* @__PURE__ */jsxs("picture", {
          children: [/* @__PURE__ */jsx("source", {
            srcSet: "\n                ".concat(MOZIO_STATIC_URL, "/travel-agency-mobile-360w.png 360w,\n                ").concat(MOZIO_STATIC_URL, "/travel-agency-mobile-540w.png 540w,\n                ").concat(MOZIO_STATIC_URL, "/travel-agency-mobile-685w.png 640w,\n                ").concat(MOZIO_STATIC_URL, "/travel-agency-desktop.png 1440w\n              ")
          }), /* @__PURE__ */jsx("img", {
            className: "max-h-60 w-full object-cover md:h-[41rem] md:max-h-full",
            src: "".concat(MOZIO_STATIC_URL, "/travel-agency-mobile-685w.png"),
            alt: t("Travel Agency")
          })]
        }), /* @__PURE__ */jsx("div", {
          className: "bg-primary-500/70 absolute inset-0 flex items-end md:hidden",
          children: /* @__PURE__ */jsx("p", {
            className: "m-0 px-2 py-5 text-lg font-semibold text-white",
            children: t("Are you a Travel Agency, Hotel, Airline, or Car Rental?")
          })
        })]
      }), /* @__PURE__ */jsx("div", {
        className: "px-2 py-6 md:flex md:flex-1 md:items-center md:justify-end md:py-16 md:pl-4 lg:pr-20",
        children: /* @__PURE__ */jsxs("div", {
          className: "md:max-w-[30rem]",
          children: [/* @__PURE__ */jsx("h6", {
            className: "mb-2 hidden text-[1.625rem] font-semibold leading-9 md:block",
            children: t("Are you a Travel Agency, Hotel, Airline, or Car Rental?")
          }), /* @__PURE__ */jsx("p", {
            className: "m-0",
            children: t("Enhance customer experience by integrating convenient ground transportation booking options into your existing systems.")
          }), /* @__PURE__ */jsx("a", {
            href: "/business-partners",
            className: "bg-secondary lg:hover:bg-secondary-400 mt-5 inline-block rounded-md px-2 py-4 transition",
            children: t("Discover our solutions")
          })]
        })
      })]
    }), /* @__PURE__ */jsxs("section", {
      className: "bg-neutral-100 sm:m-0 md:flex",
      children: [/* @__PURE__ */jsxs("div", {
        className: "relative md:min-w-[50%] md:flex-1",
        children: [/* @__PURE__ */jsxs("picture", {
          children: [/* @__PURE__ */jsx("source", {
            srcSet: "\n                ".concat(MOZIO_STATIC_URL, "/provider-mobile-360w.png 360w,\n                ").concat(MOZIO_STATIC_URL, "/provider-mobile-540w.png 540w,\n                ").concat(MOZIO_STATIC_URL, "/provider-mobile-685w.png 640w,\n                ").concat(MOZIO_STATIC_URL, "/provider-desktop.png 1440w\n              ")
          }), /* @__PURE__ */jsx("img", {
            className: "max-h-60 w-full object-cover md:h-[41rem] md:max-h-full",
            src: "".concat(MOZIO_STATIC_URL, "/provider-mobile-685w.png"),
            alt: t("Provider")
          })]
        }), /* @__PURE__ */jsx("div", {
          className: "bg-primary-500/70 absolute inset-0 flex items-end md:hidden",
          children: /* @__PURE__ */jsx("p", {
            className: "m-0 px-2 py-5 text-lg font-semibold text-white",
            children: t("Are you a ground transportation Provider?")
          })
        })]
      }), /* @__PURE__ */jsxs("div", {
        className: "px-2 py-6 md:flex md:flex-1 md:flex-col md:justify-center md:py-16 md:pl-9 lg:py-24",
        children: [/* @__PURE__ */jsx("h6", {
          className: "mb-2 hidden text-[1.625rem] font-semibold leading-9 md:block md:max-w-md",
          children: t("Are you a ground transportation Provider?")
        }), /* @__PURE__ */jsx("p", {
          className: "m-0 md:max-w-md",
          children: t("Join Mozio's global network and connect with millions of Travelers. ")
        }), /* @__PURE__ */jsx("a", {
          href: "/providers",
          className: "bg-secondary lg:hover:bg-secondary-400 mt-5 inline-block w-fit rounded-md px-2 py-4 transition",
          children: t("Partner with us")
        })]
      })]
    })]
  });
};

var _g$1, _defs;

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

var SvgEasyBooking = function SvgEasyBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#easy-booking_svg__a)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.36 34.04a1 1 0 0 1 .866-1.5H50.96a1 1 0 0 1 .772 1.636l-3.685 4.483a1 1 0 0 0 .294 1.513l7.315 3.984a1 1 0 0 1 .396 1.363l-3.274 5.898a1 1 0 0 1-1.353.393l-7.395-4.027a1 1 0 0 0-1.41.515l-2.078 5.325a1 1 0 0 1-1.798.137L27.36 34.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.136 49.49-5.25-9.093m-1.25-2.165-1-1.732",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.514 25.945v-6.27c0-6.076-4.925-11-11-11H18.979c-6.075 0-11 4.924-11 11v17.11c0 6.075 4.925 11 11 11h9.084",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.848,
    cy: 21.03,
    r: 8.498,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.638 22.3 2.234 2.233a1 1 0 0 0 1.414 0l4.772-4.772",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "easy-booking_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(0 .025)",
    d: "M0 0h60v60H0z"
  })))));
};

var _rect$1, _g, _g2, _path$1, _g3, _path2$1, _circle, _circle2, _path3$1;

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

var SvgPartners = function SvgPartners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    x: 23.689,
    y: 31.673,
    width: 26.798,
    height: 8.028,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.394 39.701v2.475a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1v-2.475M27.032 39.701v2.475a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1v-2.475"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.096 30.253c0 .638-.517 1.155-1.155 1.155s-2.028.127-2.028-.511 1.39-1.8 2.028-1.8c.638 0 1.155.518 1.155 1.156ZM23.08 30.253c0 .638.517 1.155 1.155 1.155s2.028.127 2.028-.511-1.39-1.8-2.028-1.8c-.638 0-1.155.518-1.155 1.156Z"
  }))), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 31.272a2.174 2.174 0 0 0-4.349 0",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.921,
    cy: 35.729,
    r: 1.794
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.255,
    cy: 35.729,
    r: 1.794
  }))), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "m47.727 31.673-1.289-5.264a3 3 0 0 0-2.914-2.286H30.652a3 3 0 0 0-2.914 2.286l-1.289 5.264M17.682 34.946H6.904a6 6 0 0 1-6-6V9.239m47.093 9.997v-8.441a6 6 0 0 0-6-6h-20.36",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.354,
    cy: 7.577,
    r: 6.704,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.353,
    cy: 7.577,
    r: 2.804,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11 12.825V23.56l4.244-2.845 4.243 2.845V12.825",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};

var _rect, _rect2, _path, _path2, _path3;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var SvgWait = function SvgWait(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.142,
    y: 10.992,
    width: 23.715,
    height: 3.208,
    rx: 1.604,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.142,
    y: 46.326,
    width: 23.715,
    height: 3.208,
    rx: 1.604,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.347 43.472a4.583 4.583 0 0 1 4.583-4.583h4.113a4.583 4.583 0 0 1 4.583 4.583c0 .506-.41.916-.916.916H24.264a.917.917 0 0 1-.917-.916ZM36.221 21.602a6.158 6.158 0 0 1-2.981 4.025l-1.435.81c-.65.368-1.17.926-1.49 1.6a.363.363 0 0 1-.655 0 3.625 3.625 0 0 0-1.49-1.6l-.953-.537a7.033 7.033 0 0 1-3.46-4.865 1.407 1.407 0 0 1 1.788-1.6l2.657.795a10 10 0 0 0 4.715.247l1.874-.353a1.232 1.232 0 0 1 1.43 1.478Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.73 14.22v6.913a7.105 7.105 0 0 0 3.208 5.94l2.377 1.56a1.84 1.84 0 0 1 .196 2.928l-2.573 2.231a9.3 9.3 0 0 0-3.208 7.027v5.942M39.27 14.2v6.912a7.105 7.105 0 0 1-3.208 5.941l-2.377 1.56a1.84 1.84 0 0 0-.196 2.928l2.573 2.23a9.3 9.3 0 0 1 3.209 7.028v5.94",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.987 28.38v1.645M29.987 32.886v.822M29.987 36.128v.823",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Features = function Features() {
  var _useTranslation$11 = useTranslation$1("transfer-widgets:home"),
      t = _useTranslation$11.t;

  var features = [{
    icon: /* @__PURE__ */jsx(SvgCancellation, {
      className: "text-6xl text-white"
    }),
    title: t("Free cancellations within 24 hours")
  }, {
    icon: /* @__PURE__ */jsx(SvgSupport, {
      className: "text-6xl text-white"
    }),
    title: t("24/7 customer support")
  }, {
    icon: /* @__PURE__ */jsx(SvgPartners, {
      className: "text-6xl text-white"
    }),
    title: t("Licensed partners")
  }, {
    icon: /* @__PURE__ */jsx(SvgEasyBooking, {
      className: "text-6xl text-white"
    }),
    title: t("Instantly guaranteed booking")
  }, {
    icon: /* @__PURE__ */jsx(SvgWait, {
      className: "text-6xl text-white"
    }),
    title: t("Flight delayed? We wait.")
  }];
  return /* @__PURE__ */jsx("section", {
    className: "bg-primary",
    children: /* @__PURE__ */jsx(Container, {
      className: "max-w-6xl px-4 py-8 lg:py-14",
      children: /* @__PURE__ */jsx("ul", {
        className: "flex flex-col gap-5 sm:flex-row sm:gap-2 lg:gap-8",
        children: features.map(function (feature) {
          return /* @__PURE__ */jsxs("li", {
            className: "flex items-center gap-3 text-white sm:flex-1 sm:flex-col",
            children: [feature.icon, /* @__PURE__ */jsx("p", {
              className: "m-0 text-base font-semibold sm:text-center sm:text-sm lg:text-lg",
              children: feature.title
            })]
          }, feature.title);
        })
      })
    })
  });
};

var PRODUCT_TYPE = {
  TRAVEL_AGENT: "TRAVEL_AGENT",
  API_INTEGRATION: "API_INTEGRATION",
  WHITE_LABEL: "WHITE_LABEL",
  WIDGET: "WIDGET"
};

var Products = function Products() {
  var _useTranslation$12 = useTranslation$1("transfer-widgets:home"),
      t = _useTranslation$12.t;

  var products = [{
    title: t("Booking tool for Travel Agents"),
    description: t("Are you a Travel Agent? Book ground transportation on behalf of your clients seamlessly with our Travel Agent Booking Tool."),
    image: "travel-agent-tool",
    label: t("Learn more"),
    path: "/travel-agents",
    value: PRODUCT_TYPE.TRAVEL_AGENT
  }, {
    title: t("API Integration"),
    description: t("Integrate Mozio's powerful API into your existing systems and allow your clients to book transfers seamlessly."),
    image: "api-integration",
    label: t("Learn more"),
    path: "/business-partners",
    value: PRODUCT_TYPE.API_INTEGRATION
  }, {
    title: t("White Label"),
    description: t("Enhance your brand with Mozio\u2019s White Label solution, offering a fully customized transportation booking flow that integrates your branding\u2014from colors and logos to URLs\u2014providing your clients with a seamless experience under your name."),
    image: "white-label",
    label: t("Learn more"),
    path: "/business-partners",
    value: PRODUCT_TYPE.WHITE_LABEL
  }, {
    title: t("Widget"),
    description: t("Add search Widgets onto your website, enabling visitors to search transportation options directly on your page and redirecting them to Mozio.com for booking."),
    image: "widget",
    label: t("Learn more"),
    path: "/business-partners",
    value: PRODUCT_TYPE.WIDGET
  }];
  return /* @__PURE__ */jsx("div", {
    className: "mt-8 bg-neutral-100 pt-16 sm:py-20",
    children: /* @__PURE__ */jsxs(Container, {
      className: "max-w-6xl",
      children: [/* @__PURE__ */jsx("h6", {
        className: "mb-6 text-[1.375rem] font-semibold leading-8 sm:text-4xl",
        children: t("What we offer")
      }), /* @__PURE__ */jsxs(Tabs, {
        variant: "bordered",
        defaultValue: PRODUCT_TYPE.TRAVEL_AGENT,
        children: [/* @__PURE__ */jsxs(TabsList, {
          className: "no-scrollbar flex-nowrap overflow-x-auto py-1",
          children: [/* @__PURE__ */jsx(TabsTrigger, {
            className: "data-[state=active]:border-primary min-w-fit !bg-transparent text-neutral-800 group-data-[variant=bordered]/tabs:border-transparent",
            value: PRODUCT_TYPE.TRAVEL_AGENT,
            children: t("Travel Agent Booking Tool")
          }), /* @__PURE__ */jsx(TabsTrigger, {
            className: "data-[state=active]:border-primary min-w-fit !bg-transparent text-neutral-800 text-neutral-800 group-data-[variant=bordered]/tabs:border-transparent",
            value: PRODUCT_TYPE.API_INTEGRATION,
            children: t("API Integration")
          }), /* @__PURE__ */jsx(TabsTrigger, {
            className: "data-[state=active]:border-primary min-w-fit !bg-transparent text-neutral-800 group-data-[variant=bordered]/tabs:border-transparent",
            value: PRODUCT_TYPE.WHITE_LABEL,
            children: t("White Label")
          }), /* @__PURE__ */jsx(TabsTrigger, {
            className: "data-[state=active]:border-primary min-w-fit !bg-transparent text-neutral-800 group-data-[variant=bordered]/tabs:border-transparent",
            value: PRODUCT_TYPE.WIDGET,
            children: t("Widget")
          })]
        }), products.map(function (product) {
          var title = product.title,
              label = product.label,
              value = product.value,
              description = product.description,
              image = product.image,
              path = product.path;
          return /* @__PURE__ */jsx(TabsContent, {
            value: value,
            className: "px-0",
            children: /* @__PURE__ */jsxs("div", {
              className: "gap-8 px-1 pt-8 sm:flex sm:items-center lg:pt-4",
              children: [/* @__PURE__ */jsxs("div", {
                className: "sm:flex-1",
                children: [/* @__PURE__ */jsx("h6", {
                  className: "mb-2 text-lg font-semibold lg:text-[1.625rem] lg:leading-9",
                  children: title
                }), /* @__PURE__ */jsx("p", {
                  className: "m-0 text-sm",
                  children: description
                }), /* @__PURE__ */jsx("a", {
                  href: path,
                  className: "bg-secondary lg:hover:bg-secondary-400 mb-10 mt-5 inline-block rounded-md px-2 py-3 transition sm:mb-0 lg:text-xl",
                  children: label
                })]
              }), /* @__PURE__ */jsxs("picture", {
                className: "w-full sm:flex-[2]",
                children: [/* @__PURE__ */jsx("source", {
                  srcSet: "\n                        ".concat(MOZIO_STATIC_URL, "/").concat(image, "-360w.png 360w,\n                        ").concat(MOZIO_STATIC_URL, "/").concat(image, "-484w.png 640w,\n                        ").concat(MOZIO_STATIC_URL, "/").concat(image, "-595w.png 1024w,\n                        ").concat(MOZIO_STATIC_URL, "/").concat(image, "-685w.png 1440w\n                      ")
                }), /* @__PURE__ */jsx("img", {
                  className: "w-full sm:min-h-[22rem] sm:object-cover",
                  src: "".concat(MOZIO_STATIC_URL, "/").concat(image, "-685w.png"),
                  alt: t("Travelers")
                })]
              })]
            })
          }, value);
        })]
      })]
    })
  });
};

var Segments = function Segments() {
  var _useTranslation$13 = useTranslation$1("transfer-widgets:home"),
      t = _useTranslation$13.t;

  var segments = [{
    title: t("Travelers"),
    image: "travelers-card",
    description: t("Are you planning a trip and need reliable transportation options?"),
    label: t("Learn more"),
    path: "/travelers"
  }, {
    title: t("Travel Agents"),
    image: "travel-agents-card",
    description: t("Do you manage travel arrangements for clients?"),
    label: t("Book with Mozio"),
    path: "/travel-agents",
    className: "pb-10"
  }, {
    title: t("Businesses"),
    image: "businesses-card",
    description: t("Are you a Travel Agency, Hotel, Airline, or Car Rental wanting to expand your reach?"),
    label: t("Integrate with Mozio"),
    path: "/business-partners",
    className: "pb-14"
  }, {
    title: t("Providers"),
    image: "provider-card",
    description: t("Do you offer ground transportation services and want to expand your reach?"),
    label: t("Partner with Us"),
    path: "/providers",
    className: "pb-10"
  }];
  return /* @__PURE__ */jsx("div", {
    className: "flex flex-col gap-5 sm:flex-row sm:gap-2 lg:gap-5",
    children: segments.map(function (segment) {
      var title = segment.title,
          description = segment.description,
          image = segment.image,
          label = segment.label,
          path = segment.path,
          className = segment.className;
      return /* @__PURE__ */jsxs("div", {
        className: "relative sm:flex-1",
        children: [/* @__PURE__ */jsx("div", {
          className: "absolute inset-0 -z-10 overflow-hidden rounded-2xl",
          children: /* @__PURE__ */jsxs("picture", {
            children: [/* @__PURE__ */jsx("source", {
              srcSet: "\n                    ".concat(MOZIO_STATIC_URL, "/").concat(image, "-desktop-150w.png 640w,\n                    ").concat(MOZIO_STATIC_URL, "/").concat(image, "-desktop-213w.png 1024w, \n                    ").concat(MOZIO_STATIC_URL, "/").concat(image, "-desktop-265w.png 1440w"),
              media: mediaQueries.md
            }), /* @__PURE__ */jsx("source", {
              srcSet: "\n                    ".concat(MOZIO_STATIC_URL, "/").concat(image, "-mobile-300w.png 360w, \n                    ").concat(MOZIO_STATIC_URL, "/").concat(image, "-mobile-490w.png 490w, \n                    ").concat(MOZIO_STATIC_URL, "/").concat(image, "-mobile-640w.png 640w")
            }), /* @__PURE__ */jsx("img", {
              className: "absolute inset-0 h-full w-full object-cover object-top md:object-center",
              src: "".concat(MOZIO_STATIC_URL, "/").concat(image, "-mobile-640w.png"),
              alt: title
            })]
          })
        }), /* @__PURE__ */jsxs("div", {
          className: cn$1("from-primary-500 relative rounded-2xl bg-gradient-to-r to-transparent p-3 pb-6 pr-[40%] text-white sm:flex sm:h-full sm:min-h-[22rem] sm:flex-col sm:bg-gradient-to-t sm:pb-5 sm:pr-3 sm:pt-32 lg:min-h-[29rem] lg:pt-56", className),
          children: [/* @__PURE__ */jsx("h6", {
            className: "text-lg font-semibold lg:text-[1.6rem]",
            children: title
          }), /* @__PURE__ */jsx("p", {
            className: "mb-5 mt-2 sm:text-sm lg:text-lg",
            children: description
          }), /* @__PURE__ */jsx("a", {
            className: "bg-secondary lg:hover:bg-secondary-400 inline-block rounded p-2 text-center text-xl text-black transition sm:mt-auto sm:text-sm lg:text-lg",
            href: path,
            children: label
          })]
        })]
      }, title);
    })
  });
};

var Statistics = function Statistics() {
  var _useTranslation$14 = useTranslation$1("transfer-widgets:home"),
      t = _useTranslation$14.t;

  var statistics = [{
    value: "180+",
    label: t("countries")
  }, {
    value: "3500+",
    label: t("airports")
  }, {
    value: "2500+",
    label: t("cities")
  }, {
    value: "3000+",
    label: t("providers")
  }, {
    value: "17",
    label: t("languages")
  }, {
    value: "39",
    label: t("currencies")
  }];
  return /* @__PURE__ */jsxs("div", {
    className: "pt-2",
    children: [/* @__PURE__ */jsx("h6", {
      className: "mb-10 text-[1.375rem] font-semibold leading-8 sm:text-4xl",
      children: t("Extensive network and reach")
    }), /* @__PURE__ */jsx("ul", {
      className: "grid grid-cols-2 gap-2 lg:grid-cols-3 lg:gap-6",
      children: statistics.map(function (statistic) {
        var label = statistic.label,
            value = statistic.value;
        return /* @__PURE__ */jsxs("li", {
          className: "rounded-xl border-4 border-solid border-[#29D3C9] bg-[#BFF2EF] px-5 py-3",
          children: [/* @__PURE__ */jsx("p", {
            className: "text-primary-500 m-0 text-[2.5rem] font-semibold leading-8 lg:text-6xl",
            children: value
          }), /* @__PURE__ */jsx("p", {
            className: "text-primary-500 mb-0 mt-2 text-xl lg:text-2xl",
            children: label
          })]
        }, label);
      })
    })]
  });
};

var Home = function Home(_ref14) {
  var children = _ref14.children;

  var _useTranslation$15 = useTranslation$1("transfer-widgets:home"),
      t = _useTranslation$15.t;

  var logos = [{
    image: "logo-tui.png",
    alt: "Tui"
  }, {
    image: "logo-hertz.png",
    alt: "Hertz"
  }, {
    image: "logo-priceline.png",
    alt: "Priceline"
  }, {
    image: "logo-dnata.png",
    alt: "Dnata"
  }, {
    image: "logo-klook.png",
    alt: "Klook"
  }, {
    image: "logo-viator.png",
    alt: "Viator"
  }, {
    image: "logo-travel-counsellors.png",
    alt: "Travel Counsellors"
  }, {
    image: "logo-jet-blue.png",
    alt: "Jet Blue"
  }, {
    image: "logo-booking.png",
    alt: "Booking"
  }, {
    image: "logo-air-france.png",
    alt: "Air France"
  }, {
    image: "logo-agoda.png",
    alt: "Agoda"
  }, {
    image: "logo-air-canada.png",
    alt: "Air Canada"
  }, {
    image: "logo-cruise-planners.png",
    alt: "Cruise Planners"
  }, {
    image: "logo-edreams.png",
    alt: "Edreams"
  }, {
    image: "logo-rakuten.png",
    alt: "Rakuten"
  }, {
    image: "logo-despegar.png",
    alt: "Despegar"
  }];
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(Hero, {
      children: children
    }), /* @__PURE__ */jsx(Features, {}), /* @__PURE__ */jsxs(Container, {
      className: "max-w-6xl py-8 sm:py-20",
      children: [/* @__PURE__ */jsx("p", {
        className: "mb-4 text-[1.375rem] font-semibold sm:text-4xl",
        children: t("The largest Travel Businesses in the world trust Mozio")
      }), /* @__PURE__ */jsx("p", {
        className: "hidden sm:block sm:text-2xl",
        children: t("Brands like Hertz, Air France, TUI, Priceline, JetBlue, Booking.com, CruisePlanners, Accor, and over 5,000 travel agents trust Mozio for their ground transportation needs.")
      }), /* @__PURE__ */jsx("ul", {
        className: "grid grid-cols-4 items-center gap-x-7 gap-y-4 sm:mt-5 lg:mt-8",
        children: logos.map(function (logo) {
          var alt = logo.alt,
              image = logo.image;
          return /* @__PURE__ */jsx("li", {
            className: "flex justify-center",
            children: /* @__PURE__ */jsx("img", {
              src: "".concat(MOZIO_STATIC_URL, "/").concat(image),
              alt: alt
            })
          }, alt);
        })
      }), /* @__PURE__ */jsxs("div", {
        className: "mb-14 mt-10 flex items-center gap-3 sm:py-8 lg:mb-16 lg:mt-14 lg:gap-7",
        children: [/* @__PURE__ */jsx(SvgArrow, {
          height: "auto",
          width: "auto",
          className: "text-secondary w-[75px] min-w-[75px] lg:w-[110px] lg:min-w-[110px]"
        }), /* @__PURE__ */jsx("p", {
          className: "flex:1 text-[1.375rem] font-semibold lg:hidden",
          children: t("Your go-to ground transportation platform")
        }), /* @__PURE__ */jsx("p", {
          className: "flex:1 hidden text-4xl font-semibold leading-[3rem] lg:block",
          children: t("Your go-to ground transportation platform for Travelers, Travel Agents, Hotels, Airlines, and more.")
        })]
      }), /* @__PURE__ */jsx(Segments, {})]
    }), /* @__PURE__ */jsx(Products, {}), /* @__PURE__ */jsxs(Container, {
      className: "w-full max-w-6xl",
      children: [/* @__PURE__ */jsx(AdditionalFeatures, {}), /* @__PURE__ */jsx(Statistics, {})]
    }), /* @__PURE__ */jsx(Businesses, {})]
  });
};

var cn = function cn() {
  for (var _len2 = arguments.length, inputs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    inputs[_key2] = arguments[_key2];
  }

  return twMerge(clsx(inputs));
};

export { Footer, HeaderContainer as Header, Home, cn, setTranslation, setWhiteLabel, useTranslation };